/* global ModeSave, ID_FORMULAIRE */

var CLASSE_CONTROLE_MODIFIE = 'controle-modifie'; // le contrôle est modifié : sa couleur de fond est changé et doit être laissé dans cette couleur jusqu'à la fermeture de la fiche s'il est sauvegardé
var CLASSE_VALEUR_MODIFIEE = 'valeur-modifiee'; // la valeur du contrôle est modifié : sert à la sauvegarde du bloc
//var CLASSE_NOUVELLE_LIGNE = 'nouvelle-ligne'; // une nouvelle ligne est créé : sert à ajouter des données
//var CLASSE_SUPPRESSION_LIGNE = 'suppression-ligne'; // la ligne est en suppression : sert à supprimer dans la table à la sauvegarde
//var CLASSE_CONTROLE_SUPPRESSION = 'ctrl-suppression'; // le checkbox utilisé pour la suppression dans la section multiple
var CLASSE_CONTROLE_CHECKBOX = 'ctrl-checkbox'; // le checkbox personnalisé pour afficher un booléen
//var CLASSE_VALEUR_SAUVEGARDEE = 'sauvegarde'; // la valeur du contrôle est sauvegardée
var CLASSE_PORTRAIT_ANTERIEUR = 'portrait_anterieur'; // le portrait antérieur existe et sa valeur est différente de la valeur de l'évènement courant
// var map;
var dateEvenement = moment().format('YYYY-MM-DD');

/* textes utilisés à plusieurs endroits */
var texteTableauDeconnecteNonImporte = {
    "note": "Une note sur tableau blanc a été créée en mode déconnecté et a été sauvegardée sur votre appareil. Actuellement, elle n'est pas disponible pour les autres utilisateurs. Veuillez la téléverser dans la section <button class='reset-button-style btn-link lien-tableau-blanc' data-type-tableau='note' id='lienTableauBlanc' title='Accéder au tableau blanc'>Tableau blanc</button>.",
    "croquis": "Une note sur croquis a été créée en mode déconnecté et a été sauvegardée sur votre appareil. Actuellement, elle n'est pas disponible pour les autres utilisateurs. Veuillez la téléverser dans la section <button class='reset-button-style btn-link lien-tableau-blanc' data-type-tableau='croquis' id='lienNotesCroquis' title='Accéder aux notes sur croquis'>Note sur croquis</button>."
};

/**
 * Initialisation du module d'évaluation foncière
 */
function init_gestionRoles() {}

function getBlocDivision(obj, modeSave) {
    var idUe = null;
    var idBatiment = null;
    var idFormulaire = null;
    var idTypeBatiment = null;
    var nomDivision = 'main';
    var blocsContainer;
    if (modeSave == ModeSave.FICHE || modeSave == ModeSave.VALEUR_TERRAIN) {
        idBatiment = $('#current-id-batiment').val();
        idFormulaire = $('#current-id-formulaire').val();
        idTypeBatiment = $('#current-id-type-batiment').val();
        blocsContainer = $('#blocs-container');
        idUe = $('#id-ue').val();
    }

    if (modeSave == ModeSave.WIZARD) {
        idFormulaire = ID_FORMULAIRE.renseignementAdministratif;
        idUe = $('#wizard').attr('id-ue');
        idBatiment = idUe; // nécessaire car utilisé dans l'appel à getParamsSuppPourInsertion

        // par défaut, on va considérer que c'est le même batiment / formulaire pour toute la page du wizard
        $('.step-pane.active form.blocForm').each(function () {
            if ($(this).attr('id_formulaire')) {
                idFormulaire = $(this).attr('id_formulaire');
                idBatiment = $(this).attr('id_batiment');
                return false;
            }
        });
    }

    var reperesContainer = obj.closest('.container-reperes');
    if (reperesContainer.length > 0) {
        blocsContainer = reperesContainerToBlocsContainer(reperesContainer).first();
        return getBlocDivision(blocsContainer, modeSave);
    }

    var divBatiment = obj.closest('[id^=accordion-batiment-]');
    if (divBatiment.length > 0) {
        idUe = $('#wizard').attr('id-ue');
        idBatiment = idUe;
        idTypeBatiment = null;

        var splitId = divBatiment.attr('id').split('-');
        idFormulaire = splitId[4];
        nomDivision = '0-' + idFormulaire;

        if (splitId[2] != '0') {
            idBatiment = splitId[2];
            idTypeBatiment = splitId[3];
            nomDivision = idBatiment;
        }
    }

    return {
        id_batiment: idBatiment,
        id_type_batiment: idTypeBatiment,
        id_formulaire: idFormulaire,
        id_ue: idUe,
        nom_division: nomDivision
    };
}

function getParamsBloc(bloc, blocDivision, dateEvenement, modeSave) {

    var idModelInstance = bloc.attr('id_model_instance');
    var blocEditable = bloc.attr('bloc_editable');
    var nomBloc = bloc.attr('id');
    var idBloc = bloc.attr('id_bloc');

    var inputsBloc = bloc.find(':input:not(button)').not('.champs-multiple :input').not('.exception-save');
    // mettre les select multiples 'disabled' temporairement pour faire le serialize
    var selectsMultipleDisabled = inputsBloc.filter('.container-select-multiple-input-multiple select:not(:disabled)').attr('disabled', true);
    // mettre les champs inactifs temporairement actifs pour faire le serialize(ex.: certains champs disabled du bloc 07 qui sont des calculs)
    var inputsDisabled = inputsBloc.filter(':disabled').not(selectsMultipleDisabled).removeAttr('disabled');
    var inputsMoney = inputsBloc.filter('.money');
    var fakeSelect = bloc.find('ul.fake-select').not('.champs-multiple :input').not('.exception-save');

    var params = inputsBloc.not(selectsMultipleDisabled).not(inputsMoney).serializeArray();

    $.each(fakeSelect, function () {
        let value = $(this).attr('value');
        if (value !== undefined) {
            params.push({
                name: $(this).attr('name'),
                value: value
            });
        }
    });

    $.each(inputsMoney, function () {
        params.push({
            name: $(this).attr('name'),
            value: $(this).autoNumeric('get')
        });
    });

    // ajouter les checkbox qui ne sont pas cochés dans le serialize
    var checkboxUnchecked = inputsBloc.filter(':checkbox:not(:checked)').not('.ctrl-suppression');
    $.each(checkboxUnchecked, function (index, element) {
        var $element = $(element);
        // prendre la valeur pour le false s'il y a lieu
        var valueFalse = $element.attr('value_false');
        params.push({
            name: $element.attr('name'),
            value: valueFalse != undefined ? valueFalse : 0
        });
    });
    // ajouter les select qui n'ont pas de sélection dans le serialize
    var selectUnselected = inputsBloc.filter('.container-select-multiple select').filter(function () {
        return $(this).prop('selectedIndex') == -1;
    });
    $.each(selectUnselected, function (index, element) {
        var $element = $(element);
        var nom = $element.attr('name');
        // dans le cas où un select est affiché sur 2 colonnes ou plus, on ne veut pas perdre la valeur sélectionnée en
        // ajoutant une valeur vide pour ce champ
        var estTrouve = false;
        $.each(params, function (idx, val) {
            if (val.name == nom && val.value != '') {
                estTrouve = true;
                return false;
            }
        });
        if (!estTrouve) {
            params.push({
                name: $element.attr('name'),
                value: ''
            });
        }
    });
    // remettre les contrôles dans leur état initial
    inputsDisabled.attr('disabled', true);
    selectsMultipleDisabled.removeAttr('disabled');

    if (blocEditable == 'False') { // On fait un insert
        getParamsSuppPourInsertion(params, bloc, blocDivision.id_batiment, dateEvenement, blocDivision.id_formulaire);
        getParamsSuppCallbackSave(params, bloc);
    }
    var blocSansDonnee = false;
    // dans le cas du bloc 23, on veut supprimer le bloc même si les sous-blocs ne sont pas vides, alors, on le
    // force au lieu d'être géré par le serveur à la sauvegarde
    if (blocDivision.idFormulaire == ID_FORMULAIRE.residentiel && $.inArray(idBloc, ['23']) != -1) {
        blocSansDonnee = ligneEstSansDonnee(bloc);
    }
    var blocModifie = blocEstModifie(bloc);

    params.push({
        action: blocSansDonnee && blocModifie ? 'delete' : blocEditable == 'False' ? 'create' : 'update',
        id_instance: idModelInstance == 'None' ? '' : idModelInstance,
        bloc_editable: blocEditable == 'True',
        modifie: blocModifie,
        nom_bloc: nomBloc,
        id_bloc: idBloc
    });

    for (var property in blocDivision) {
        if (blocDivision.hasOwnProperty(property)) {
            params[params.length - 1][property] = blocDivision[property];
        }
    }

    return params;
}


function getParamsSuppCallbackSave(params, bloc) {
    var callbackSave = bloc.attr('callback_save');
    if (callbackSave != undefined) {
        var idUe = $('#id-ue').val();
        if (modeSave == ModeSave.WIZARD) {
            idUe = $('#wizard').attr('id-ue');
        }
        var parametres = [idUe];
        params.push(window[callbackSave].apply(window, parametres));
    }
}


function blocEstModifie(bloc) {

    // On enlève les éléments qui seraient dans un sous-bloc
    var elementsException = bloc.find('.champs-multiple .form-control.' + CLASSE_VALEUR_MODIFIEE);

    // On vérifie si une donnée a changé dans le bloc sauf les données des sous-blocs
    return bloc.find('.form-control.' + CLASSE_VALEUR_MODIFIEE).not(elementsException).length != 0;
}

function estMiseAjourB79Terrain(paramsAttestation) {
    return $.ajax({
            type: 'GET',
            url: '/gestion-roles/editeur-fiche/attestation-b79-terrain/',
                data: paramsAttestation,
                dataType: 'json'
            })
        .done(function (response) {
            return response.reponse === 'ok';
        })
        .fail(function () {
            return false;
        });
}


function getParamValeur(params, nom) {
    var valeur = null;
    $.each(params, function (idx, val) {
        if (val.name == nom) {
            valeur = val.value;
        }
    });
    return valeur;
}

var modeSave;

function saveBlocs(modeWizard, callback, options) {
    wait.start();

    // #18249: ferme tous les blocs historique avant de continuer. pour ne pas polluer l'output du validation.
    $('.bloc-historique-header').each(function (e) {
        $(this).parent().remove();
    });
    var reponse = {};
    var blocsContainer;

    if (typeof (options) == 'undefined') {
        options = {};
    }

    modeSave = (!modeWizard ? ModeSave.FICHE : ModeSave.WIZARD);
    if (typeof (options.modeSave) != 'undefined') {
        modeSave = options.modeSave;
    }

    var modeErreur = modeSave;
    if (typeof (options.modeErreur) != 'undefined') {
        modeErreur = options.modeErreur;
    }

    if (modeSave == ModeSave.FICHE) {
        var idBatiment = $('#current-id-batiment').val();
        var idFormulaire = $('#current-id-formulaire').val();
        var idTypeBatiment = $('#current-id-type-batiment').val();
        blocsContainer = $('#blocs-container');
        var dateEvenement = $('#date-evenement').val();
        var idEvenement = $('#id-evenement').val();
        var idMunicipalite = $('#id_municipalite').val();
    }
    if (modeSave == ModeSave.WIZARD || modeSave == ModeSave.VALEUR_TERRAIN) {
        var wizard = $('#wizard');
        var idBatiment = wizard.attr('id-ue');
        var idTypeBatiment = null;

        var idFormulaire;
        if ($('form[code=00]').length > 0) {
            idFormulaire = ID_FORMULAIRE.renseignementAdministratif; // HACK !
        } else {
            idFormulaire = ID_FORMULAIRE.terrainGeneral; // HACK !
        }

        $('.step-pane.active form.blocForm').each(function () {
            if ($(this).attr('id_formulaire')) {
                idFormulaire = $(this).attr('id_formulaire');
                idBatiment = $(this).attr('id_batiment');
                var idMunicipalite = $('#id_municipalite').val();
                return false;
            }
        });

        blocsContainer = $('.step-pane.active');
        var dateEvenement = wizard.attr('date-evenement');
        var idEvenement = wizard.attr('id-evenement');

        if (idBatiment == '') {
            idBatiment = 0; // HACK !!
        }
        if (wizard.attr('id-municipalite')) {
            var idMunicipalite = wizard.attr('id-municipalite'); // HACK !
        }
        if ($('#municipalite').val()) {
            var idMunicipalite = $('#municipalite').val(); // HACK !
        }

        // DM: normalement on ne devrait plus spécifier de id_batiment et id_formulaire ici car on peut en avoir des différents d'un bloc à l'autre
        if ($('.active[data-id_processus="31"]')) {
            idBatiment = 0;
            idFormulaire = 0;
            idTypeBatiment = 0;
        }
    }
    if (modeSave == ModeSave.MENU) {
        blocsContainer = $('#page_content');

        var idBatiment = 0; // HACK !
        var idFormulaire = 0; // HACK !
        var idMunicipalite = 0; // HACK !

        // cette 'date_courante' ne doit jamais être sauvegardé : enlever les classes de modification pour ne pas sauvegarder la date courante
        $('[name=date_courante]').removeClass(CLASSE_CONTROLE_MODIFIE).removeClass(CLASSE_VALEUR_MODIFIEE);
    }

    if (modeSave == ModeSave.MODAL) {
        var idBatiment = 0; // HACK !
        var idFormulaire = 0; // HACK !
        var idMunicipalite = 0; // HACK !
        var idTypeBatiment = 0; // HACK !
    }

    if ('idEvenement' in options) {
        idEvenement = options.idEvenement;
    }
    if ('dateEvenement' in options) {
        dateEvenement = options.dateEvenement;
    }
    if ('blocsContainer' in options) {
        blocsContainer = options.blocsContainer;
    }
    if ('idMunicipalite' in options) {
        idMunicipalite = options.idMunicipalite;
    }

    // assigner la variable globale(pas locale) car elle est utilisée dans des fonctions connexes qui gère les erreurs
    nbErreurs = 0;

    var blocs = blocsContainer.find('.blocForm');
    var sousBlocs = blocs.find('.champs-multiple');

    if ((modeSave == ModeSave.FICHE || (modeSave == ModeSave.WIZARD && $('.step-pane.active').attr('data-id_processus') == '31'))) {
        if (modeSave == ModeSave.FICHE)
            changerValeursAvantSauvegarde();

        // effacer les textes de validation affiché à la fin de chaque bloc et la notification sur les champs
        effacerValidation();
        $.each(blocs, function (index, bloc) {
            effacerValidation($(bloc));
        });
    } else {
        erreursAjax.effacerErreurChamps(blocsContainer);
    }

    var validation = {};
    // on itère sur les blocs pour obtenir tous les contrôles
    var blocsValidation = blocs.filter(':not(#document-correction-mineure, ' +
        '#document-annulation-ue, #document-actualisation-inventaire, #document-changement-legislatif,  ' +
        '#document-communication, #document-changement-terrain)'); //# 5874 Permet de rendre ou pas obligatoire un document
    $.each(blocsValidation, function (index, bloc) {
        var $bloc = $(bloc);
        var nomBloc = $bloc.attr('id');
        var blocDivision = getBlocDivision($bloc, modeSave);

        var params = getParamsBloc($bloc, blocDivision, dateEvenement, modeSave);
        if (params.length > 0) {
            if ($(bloc).attr('id') === 'evenement-wizard') {
                //s'assurer qu'on est dans le new remarque
                var evenementRemarque = $('.step-pane.active').find('[name="remarque"]');
                if (evenementRemarque.length > 0) {
                    params.push({
                        'name': 'remarque',
                        'value': evenementRemarque.val()
                    });
                }
            }
            var valDivision = validation[blocDivision.nom_division];
            if (typeof (valDivision) == 'undefined')
                valDivision = validation[blocDivision.nom_division] = {
                    info: blocDivision
                };

            valDivision[nomBloc] = params;
        }
    });

    var params_supp = {
        mode_wizard: modeWizard
    };

    if (modeWizard) {
        params_supp['id_processus'] = $('.step-pane.active').attr('data-id_processus');
    }

    if ('idEvenementAnt' in options) {
        params_supp['idEvenementAnt'] = options.idEvenementAnt;
    }

    if ('idEvenementPost' in options) {
        params_supp['idEvenementPost'] = options.idEvenementPost;
    }

    if (options.paramsSupp) {
        $.extend(params_supp, options.paramsSupp);
    }

    validation['params_supp'] = params_supp;

    // enlever les sous-blocs qu'on ne veut pas ni valider ni sauvegarder
    var sousBlocsValidation = sousBlocs; //.not('#b93-cout-neuf-sous-bloc');
    // avoir les sous-blocs qui ne vont pas être sauvegardés par cette logique mais plutôt sauvegarder par la suite par un ajax personnalisé
    var exceptionsSauvegarde = sousBlocs.filter('[id^="document-"]').has('.ace-file-input');

    // avoir les sous-blocs qui doivent être validés malgré que la ligne est vide
    var exceptionsLigneSansDonnee = sousBlocs.filter('[id$="qualite-complexite"]');

    // enlever les lignes de B79 qui viennent des portraits antérieurs
    var exceptionsLigne = [];

    if (modeSave == ModeSave.MENU) {
        exceptionsLigne = ".sous-bloc-form.exceptions-ligne";
    }

    var validationSousBlocs = getValidationSousBlocs(sousBlocsValidation, dateEvenement, exceptionsSauvegarde, exceptionsLigneSansDonnee, exceptionsLigne);

    for (var property in validationSousBlocs) {
        if (validationSousBlocs.hasOwnProperty(property)) {
            var valDivision = validation[property];
            if (typeof (valDivision) == 'undefined')
                valDivision = validation[property] = {};

            $.extend(valDivision, validationSousBlocs[property]);
        }
    }

    if (modeSave == ModeSave.FICHE ||
        (modeSave == ModeSave.WIZARD && $('.step-pane.active').find('[name="qualiteComplexite"]').length))

        if (!([ID_FORMULAIRE.terrainGeneral, ID_FORMULAIRE.terrainAgricoleBoise, ID_FORMULAIRE.renseignementAdministratif].indexOf(idFormulaire) >= 0)) {

            $('.container-reperes').each(function () {
                var reperesContainer = $(this);
                var blocsContainer = reperesContainerToBlocsContainer(reperesContainer);
                if (blocsContainer.hasClass('avant-container')) {
                    return;
                }

                var validationSousBlocsReperes = getValidationSousBlocs(reperesContainer.find('.champs-multiple'), reperesContainer.attr('date-evenement'), [], [], []);

                for (var property in validationSousBlocsReperes) {
                    if (validationSousBlocsReperes.hasOwnProperty(property)) {
                        var valDivision = validation[property];
                        if (typeof (valDivision) == 'undefined')
                            valDivision = validation[property] = {};

                        $.extend(valDivision, validationSousBlocsReperes[property]);
                    }
                }
            });
        }

    var params = {
        'validation': JSON.stringify(validation),
        'mode_wizard': modeWizard, // sera déprécié au profit de mode_save
        'mode_save': modeSave,
        'id_type_evenement': $('#wizard').attr('id-type-evenement')
    };

    if (modeSave == ModeSave.FICHE) {
        params['date_chargee'] = $('#date-chargee').val();
    }
    if (modeSave == ModeSave.WIZARD || modeSave == ModeSave.VALEUR_TERRAIN) {
        params['date_chargee'] = $('#wizard').attr('date-chargee');
        params['id_ue'] = $('#wizard').attr('id-ue');
    }

    if (typeof (options.paramsSupp) != 'undefined') {
        for (var k in options.paramsSupp) params[k] = options.paramsSupp[k];
    }
    var url;
    let accessToken = null;
    if (modeSave == ModeSave.FICHE || modeSave == ModeSave.WIZARD || modeSave == ModeSave.MODAL) { //  || modeSave == ModeSave.VALEUR_TERRAIN
        const endPoint = '/gestion-roles/editeur-fiche/fiche-save/' + idMunicipalite + '/' + idBatiment + '/' + idFormulaire + '/?date_evenement=' + encodeURI(dateEvenement) + '&id_evenement=' + idEvenement + '&id_type_batiment=' + idTypeBatiment;
        if (isRunningInApp) {
            url = `${window.ionicConfig.apiUrl}${endPoint}`;
            accessToken = window.ionicConfig.accessToken;
        } else {
            url = endPoint;
        }
    }
    if (modeSave == ModeSave.MENU) {
        url = '/gestion-entreprise/fiche-save/';
    }
    var esttoucheb79 = false;

    // On récupère la liste des blocs pour lesquels on force l'affichage des erreurs dans un format différent que celui défini par défaut pour la sauvegarde. On peut avoir deux types de fiche dans la même page : voir l'étape terrain dans l'évènement de mutation complexe.

    var liste_mode_afficher_erreurs_wizard = [];
    $('.step-pane.active').find('[mode_afficher_erreurs_wizard="oui"]').each(function () {
        liste_mode_afficher_erreurs_wizard.push(this.id);
    });

    var success_cb = function (response) {
        var msgErreurCritique = null;
        var avertissements = ''; // DM 2018-03-06: Pas trouvé de façon générique, mais ceci est utilisé par Communications pour afficher un toast avec avertissements
        if (typeof response.main !== 'undefined') {
            if (response.main.recharger_selecteur_fiche == true) {
                var id_evenement = $('#id-evenement').val();
                params = {
                    'id_evenement': id_evenement
                };
                var jqxhr = $.ajax({
                    url: '/gestion-roles/editeur-fiche/modal-choisir-fiche-ajax/evenement' + '/' + id_evenement + '/',
                    data: params,
                    type: 'POST',
                    dataType: 'html',
                    async: true
                });
                jqxhr
                    .done(function (reponse) {
                        var html = reponse;
                        $('#modalChoisirFiche').detach(); // On retire les éléments mais on conserve les events.
                        $('body.editeur-fiche').append(html);
                    });
                jqxhr
                    .fail(function (jqxhr, textStatus, errorThrown) {
                        infos.ajouterMessageToast({
                            message: "Erreur de chargement du sélecteur de fiche",
                            messageDuree: 5000,
                            messageCouleur: "red"
                        });
                    });
            }

            delete response.main.recharger_selecteur_fiche;
            var nomDivision = 'main';
            var saveBlocsContainer = blocsContainer;

            var divBatiment = blocsContainer.find('[id^=accordion-batiment-' + nomDivision + '-]');
            if (divBatiment.length > 0) {
                saveBlocsContainer = divBatiment;
            }

            var nomDivisionFormulaire = (nomDivision.indexOf('-') > -1 ? nomDivision.split('-')[1] : 0);
            var divBatiment = blocsContainer.find('[id=accordion-batiment-0-0-' + nomDivisionFormulaire + ']');
            if (divBatiment.length > 0) {
                saveBlocsContainer = divBatiment;
            }
            for (var [nomBloc, champs] of Object.entries(response.main)) {
                var sequence = '';
                var indexSequence = nomBloc.lastIndexOf('_');
                if (indexSequence != -1 && $.isNumeric(nomBloc.substr(indexSequence + 1))) {
                    sequence = nomBloc.substr(indexSequence + 1);
                    nomBloc = nomBloc.substring(0, indexSequence);
                }

                if (nomBloc.indexOf('b79-attestation-sous-bloc') === 0) {
                    esttoucheb79 = true;
                }

                var bloc;
                if (sequence == '') {
                    bloc = saveBlocsContainer.find('.blocForm#' + nomBloc);

                    // hack pour prendre le sous-bloc au complet
                    if (bloc.length == 0) {
                        bloc = saveBlocsContainer.find('.blocForm .champs-multiple#' + nomBloc);
                    }
                } else {
                    var idBloc = champs['params']['id_bloc'];
                    nomBloc = champs['params']['nom_bloc'];
                    bloc = saveBlocsContainer.find('.blocForm[id_bloc="' + idBloc + '"]').find('#' + nomBloc + ' .sous-bloc-form:eq(' + sequence + ')');
                    if (modeSave == ModeSave.MENU) {
                        bloc = saveBlocsContainer.find('.blocForm #' + nomBloc + ' .sous-bloc-form:eq(' + sequence + ')');
                    }

                    if (nomBloc.indexOf('qc-composante-') > -1 || nomBloc.indexOf('b93-tranche-terrain-') > -1) {
                        bloc = $('#' + nomBloc + ' .sous-bloc-form:eq(' + sequence + ')');
                    }
                }

                // s'il y a eu une sauvegarde, on met à jour les données
                if ('params' in champs && 'action' in champs['params']) {
                    var blocEditable = champs['params']['bloc_editable'];
                    var idModelInstance = champs['params']['id_instance'];
                    var action = champs['params']['action'];
                    if (sequence == '') {
                        if (action == 'delete') {
                            // quand c'est un bloc et l'action est 'delete', on ajuste les attributs pour remettre dans l'état d'une création
                            bloc.attr('bloc_editable', 'False');
                            bloc.attr('id_model_instance', 'None');
                        } else if (blocEditable != undefined && !blocEditable) {
                            bloc.attr('bloc_editable', 'True');
                            bloc.attr('id_model_instance', idModelInstance);
                        }
                    } else {
                        var accordionComposante = [];
                        var qcComposante = bloc.find('.qc [name$=composante]');
                        if (qcComposante.val() != undefined) {
                            var noLigne = bloc.attr('no-ligne');
                            var reperesContainer = getReperesContainer(qcComposante);
                            accordionComposante = reperesContainer.find('[name="accordion-qc-composante-' + qcComposante.val() + '"][no-ligne="' + noLigne + '"]');
                        }
                        if (action == 'create') {
                            bloc.attr('bloc-editable', 'True');
                            bloc.attr('id-model-instance', idModelInstance);
                            // si un qc existe pour cette ligne, mettre à jour les données des repères associés
                            if (accordionComposante.length > 0) {
                                accordionComposante
                                    .attr('id-sous-bloc-parent', idModelInstance)
                                    .find('.repere')
                                    .attr('id-sous-bloc-parent', idModelInstance)
                                    .addClass('repere-modifie');
                            }
                        } else if (action == 'delete') {
                            bloc.attr('id-model-instance', 'None');
                            bloc.attr('bloc-editable', 'True');
                            // Si un qc existe pour cette ligne, mettre à jour les données des repères associés car ces repères ont été supprimés lors de la suppression du sous-bloc
                            if (accordionComposante.length > 0) {
                                accordionComposante
                                    .attr('id-sous-bloc-parent', 'None')
                                    .find('.repere')
                                    .attr('id-model-instance', 'None')
                                    .attr('id-repere-defaut', 'None')
                                    .attr('id-sous-bloc-parent', 'None');
                            }
                        }

                        if ('document' in champs['params']) {
                            let document = champs['params']['document'];
                            var inputFile = bloc.find('input:file');
                            if (inputFile.length > 0 && bloc.find('.ace-file-input span.selected').length > 0) {
                                postSauvegardeDocument(bloc, document, 'document');
                            }

                            afficherPhotoPrincipale(nomBloc, document);
                        }
                    }
                    resetControle(bloc);
                }

                if ('params' in champs && 'champ_modifie_auto' in champs['params']) {
                    $.each(champs['params']['champ_modifie_auto'], function (nom, valeur) {
                        var input = bloc.find('.form-control[name="' + nom + '"]');
                        if (input.is('.fiche-select2-ajax')) {
                            input.select2('val', valeur);
                        } else {
                            input.val(valeur);
                        }

                        if (valeur) {
                            // demande de revision: DemandeDeRevisionSerializer.post_sauvegarde_callback retourne la valeur demandeDeRevision
                            if ($.inArray(nom, ['correctionMineure', 'annulationUe', 'actualisationInventaire', 'enqueteVente', 'revisionRecours', 'changementLegislatif', 'changementTerrain', 'demandeDeRevision', 'recoursAuTribunal', 'correctionDOffice', 'correctionErreurEcriture', 'enqueteRevenu']) > -1) { //# 5874
                                $('#wizard').attr('id-processus', valeur);
                            }
                        }

                        if (nom == 'statutEvenement') {
                            $('#wizard').attr('id-statut-evenement', valeur);
                        }

                        if (modeSave == ModeSave.FICHE) {
                            if (nom == 'date_chargee') {
                                $('#date-chargee').val(valeur);
                            }
                        }
                        if (modeSave == ModeSave.WIZARD || modeSave == ModeSave.VALEUR_TERRAIN) {
                            if (nom == 'date_chargee') {
                                $('#wizard').attr('date-chargee', valeur);
                            }
                            if (nom == 'date_evenement') {
                                $('#wizard').attr('date-evenement', valeur);
                                saveBlocsContainer.find('[name="date_evenement"]').val(valeur);
                            }
                            if (nom == 'evenement_lie') {
                                $('#wizard').data('evenement-lie', valeur);
                            }
                        }
                    });
                }

                if ('params' in champs && 'new_html' in champs['params']) {
                    bloc.replaceWith(champs['params']['new_html']);
                    // reprendre le bloc une fois que le DOM a été remplacé pour lui appliquer le fond vert
                    var bloc_id = bloc.attr('id');
                    bloc = saveBlocsContainer.find('[id="' + bloc_id + '"]');
                    bloc.find('.form-control').addClass(CLASSE_CONTROLE_MODIFIE);

                    if (champs['params']['id_bloc'] == '11') {
                        initBlocsCharges('7', 11);
                        init_guides_calcul('b11-charge-estimee', 'poids', 'calcul_charges_auto');
                    } else if (bloc_id == "b21-acier-cadre-rigide") { // B21-1
                        initBlocsCharges('7', 21);
                        init_guides_calcul('b21-acier-cadre-rigide', 'quantite', 'calcul_quantite_auto');
                    } else if (bloc_id == "b21-acier-etagee") { // B21-2
                        initBlocsCharges('7', 21);
                        init_guides_calcul('b21-acier-etagee', 'quantite', 'calcul_quantite_auto');
                        init_guide_calcul_b21_2();
                    }

                }

                // s'il y a des avertissements, on les affiche en premier (peut être écrasé par une erreur qui est prioritaire)
                if ('warning' in champs) {
                    if (typeof traiterAvertissement !== 'undefined') {
                        if ((modeSave == ModeSave.WIZARD && $('.step-pane.active').attr('data-id_processus') == '31')) {
                            traiterAvertissementPropagation(bloc, champs['warning']);
                        } else {
                            if (nomBloc === 'general') {
                                afficherValidationGenerale(champs.warning, 'avertissements');
                                tree_data.validations.additionalParameters.children.avertissements.name = `Avertissements (${nombreValidation('avertissements')})`;
                            } else {
                                traiterAvertissement(bloc, champs['warning']);
                            }
                        }
                    }

                    // DM: Pour l'instant ne sert qu'au toast de save de Communication
                    if (modeSave == ModeSave.MENU) {
                        Object.keys(champs['warning']).forEach(function (key, index) {
                            if (champs['warning'][key].texte && champs['warning'][key].texte[0]) {
                                avertissements += champs['warning'][key].texte[0] + '. ';
                            }
                        });
                    }
                }

                // s'il y a des erreurs, on les affiche
                if ('erreurs' in champs) {
                    if (modeSave == ModeSave.FICHE || (modeSave == ModeSave.WIZARD && $('.step-pane.active').attr('data-id_processus') == '31')) {
                        if (nomBloc == 'general') {
                            msgErreurCritique = champs['erreurs']['bidon'][0];
                            nbErreurs = 1;
                        } else {
                            if ((modeSave == ModeSave.WIZARD && $('.step-pane.active').attr('data-id_processus') == '31')) {
                                traiterErreursPropagation(bloc, champs['erreurs']);
                                nbErreurs = 1;

                            } else {
                                traiterErreurs2(bloc, champs['erreurs']);
                            }
                        }
                    } else if (modeSave == ModeSave.WIZARD || modeSave == ModeSave.VALEUR_TERRAIN) {
                        if (nomBloc == 'general' || ($.inArray(nomBloc, liste_mode_afficher_erreurs_wizard) > -1)) {
                            tenueAJourModal.traiterErreursWizard(bloc, champs['erreurs']);
                        } else {
                            if (modeErreur == ModeSave.FICHE || (modeSave == ModeSave.WIZARD && $('.step-pane.active').attr('data-id_processus') == '31')) {
                                // afficher les erreurs comme dans la fiche
                                afficherValidation(bloc, champs['erreurs'], 'erreurs');
                            } else {
                                tenueAJourModal.traiterErreursWizard(bloc, champs['erreurs']);
                            }
                        }
                        nbErreurs = 1;
                    } else if (modeSave == ModeSave.MENU || modeSave == ModeSave.MODAL) {
                        tenueAJourModal.traiterErreursWizard(bloc, champs['erreurs']);
                        nbErreurs = 1;
                    }
                }
            }
        }

        // recharger les choix des combobox de numéro d'espace des blocs d'équipements de la fiche NR
        if (modeSave == ModeSave.FICHE) {
            initEquipementsEspaces();
            majBadgesValidation();
        }
        // On obtient les contrôles modifiés qui sont dans les sous-blocs
        var ctrlsSousBlocModifies = sousBlocs.find('.form-control.' + CLASSE_VALEUR_MODIFIEE);
        // On obtient les lignes en suppression qui sont dans un sous-bloc
        var sousBlocsSuppression = sousBlocs.find('.' + CLASSE_SUPPRESSION_LIGNE);
        // On obtient les blocs dont les données ont changées sauf les données des sous-blocs
        var blocsModifies = blocs.find('.form-control.' + CLASSE_VALEUR_MODIFIEE).not(ctrlsSousBlocModifies).closest('.blocForm');
        // On vérifie si une donnée a changé dans le sous-bloc en ajoutant les lignes en suppression
        var sousBlocsModifies = ctrlsSousBlocModifies.add(sousBlocsSuppression).closest('.champs-multiple');

        // Documents
        if (blocsModifies.length > 0 || sousBlocsModifies.length > 0) {
            // issue #24702 : cas temporaire pour ordonner les photos dans les fiches de bâtiment de la mun. 72015
            if ($('#id_municipalite').val() == '72015' && modeSave == ModeSave.FICHE &&
                estBatiment($('#current-id-formulaire').val())) {
                // ordonner les photos du bloc 05 par nom de fichier descendant
                var b05DocumentsContainer = $('[id^="b05-document"]');
                var b05Documents = b05DocumentsContainer.find('.sous-bloc-form').not('.sous-bloc-form.' + CLASSE_NOUVELLE_LIGNE)
                    .filter(function () {
                        return $(this).attr('id-model-instance') == 'None';
                    });
                var b05DocumentsAvantSave = b05Documents.clone();
                // il faut garder la valeur des 'select' car le clone ne le fait pas
                b05Documents.find('select').each(function (i) {
                    b05DocumentsAvantSave.find('select').eq(i).val($(this).val());
                });
                var documents = b05Documents.detach();
                // on doit prendre le 'reverse' pour garder l'ordre alphabétique des noms de fichiers, tel que le
                // fileUpload les récupère. Le 'sort' ne fonctionne pas correctement pour ordonner les noms de fichiers
                var documentsOrderedDivs = documents.get().reverse();
                b05DocumentsContainer.find('.sous-bloc-form.' + CLASSE_NOUVELLE_LIGNE).before(documentsOrderedDivs);
            }

            // Pour les documents, sauf ceux des blocs 05, 06 et Autres documents(90), on garde l'ancienne façon de sauvegarder avec le ajax pour chaque sous-bloc
            // On itère sur les sous-blocs du formulaire qui ont des changements incluant les suppressions
            var lignesModifiesSauvegarde = sousBlocsModifies.filter('[id^="document-"]').has('.ace-file-input').find('.sous-bloc-form').not('.sous-bloc-form.' + CLASSE_NOUVELLE_LIGNE);

            lignesModifiesSauvegarde.each(function (index, ligne) {
                if ($(ligne).find('.erreur-validation').length) return true;
                var blocDivision = getBlocDivision($(ligne), modeSave);

                if (!modeWizard) {
                    sauvegarderSousBloc($(ligne), blocDivision.id_batiment, dateEvenement, blocDivision.id_formulaire);
                } else {
                    if (nbErreurs == 0) { // DM: dans le cas du wizard, si les validations plus haut ont failé, on ne veut pas continuer la sauvegarde donc ne rien faire ici par rapport aux documents
                        var idUe = $('#wizard').attr('id-ue');
                        var idMunicipalite = $('#municipalite').val() || $('#wizard').attr('id-municipalite');
                        var erreurFichier = $(ligne).find('.ace-file-container.selected .ace-error').attr('erreur');
                        var paramsSupplementaires = [{
                                name: 'id_municipalite',
                                value: idMunicipalite
                                },
                            {
                                name: 'erreur_fichier',
                                value: erreurFichier
                            }
                        ];

                        var idProcessus = $('#wizard').attr('id-processus');
                        if (idProcessus) {
                            paramsSupplementaires.push({
                                name: 'id_processus',
                                value: idProcessus
                            });
                        }
                        paramsSupplementaires.push({
                            name: 'id_type_evenement',
                            value: $('#wizard').attr('id-type-evenement')
                        });
                        paramsSupplementaires.push({
                            name: 'id_etape_processus',
                            value: $('.step-pane.active').attr('data-id_processus')
                        });
                        nbErreurs += tenueAJourModal.wizardSauvegarderSousBloc($(ligne), blocDivision.id_batiment, blocDivision.id_formulaire, paramsSupplementaires, dateEvenement);
                    }
                }
            });
            // issue #24702 : cas temporaire pour ordonner les photos dans les fiches de bâtiment de la mun. 72015
            if ($('#id_municipalite').val() == '72015' && modeSave == ModeSave.FICHE &&
                estBatiment($('#current-id-formulaire').val())) {
                $(documentsOrderedDivs).detach();
                b05DocumentsContainer.find('.sous-bloc-form.' + CLASSE_NOUVELLE_LIGNE).before(b05DocumentsAvantSave);
            }
        }

        if (modeSave == ModeSave.FICHE || (modeSave == ModeSave.WIZARD && $('.step-pane.active').attr('data-id_processus') == '31')) {
            if (msgErreurCritique) {
                infos.ajouterMessageToast({
                    message: msgErreurCritique, // 'Une erreur s\'est produite. Contactez un administrateur.',
                    messageDuree: 8000,
                    icone: 'fa-exclamation-circle',
                    iconeCouleur: 'red',
                    type: 'error'
                });
                wait.stop();
            } else {
                if (response.bool_imputer_temps === true) {
                    localStorage.setItem('fdt_date_modif', moment().format('YYYY-MM-DD H:m:s'));
                }
                // on peut avoir des erreurs dans les sauvegardes qui ont lieu après la validation/sauvegarde
                // globale(documents, repères, etc.)
                if (nombreValidation('erreurs') > 0) {

                    if (modeSave == ModeSave.WIZARD) {
                        afficherFenetreValidation();
                    }

                    infos.ajouterMessageToast({
                        message: 'Sauvegarde partiellement réussie',
                        messageDuree: 0,
                        icone: 'fa-exclamation-triangle',
                        iconeCouleur: 'orange'
                    });
                    wait.stop();
                } else {
                    infos.ajouterMessageToast({
                        message: 'Sauvegarde réussie',
                        messageDuree: 0,
                        icone: 'fa-check-circle-o',
                        iconeCouleur: 'green'
                    });
                    wait.stop();
                    // Permet de rafraichir le calcul des valeurs de côuts des blocs qui sont ouvert
                    $('#blocs-container .accordion-style1').each(function () {

                        // seulement les bloc de coûts
                        // DM: mis indexOf au lieu de contains() car ce dernier est compatible avec Chrome seulement
                        if ($(this).attr('id').indexOf('accordion-evenement-bloc') != -1) {
                            var bloc = $(this).attr('id');
                            var idBloc = $('#' + bloc).parent('form').attr('id_bloc');
                            $('#' + bloc).remove();
                            $('#' + idBloc + '-cout').trigger('click');
                        }
                    });

                    if (nombreValidation('avertissements') > 0) {
                        afficherFenetreValidation();
                    } else {
                        fermerFenetreValidation();
                    }
                }
                var params_attestation = {
                    'id_batiment': idBatiment,
                    'id_evenement': idEvenement,
                    'modeSave': modeSave
                };
                if (esttoucheb79 && estMiseAjourB79Terrain(params_attestation)) {
                    afficherAvertissementEditeurFiche('avertissement_editeur_fiche',
                        'avertissement_editeur_fiche_texte', "L'attestation de vérification du terrain (bloc 79) a " +
                        "été mise à jour automatiquement en indiquant une attestation complète (C). Si cela ne " +
                        "correspond pas à la vérification réalisée, veuillez effectuer la modification requise dans " +
                        "la fiche du terrain.");
                }
            }

            // recharger les choix des combobox de numéro d'espace des blocs d'équipements de la fiche NR
            if (modeSave == ModeSave.FICHE) {
                initEquipementsEspaces();
                majBadgesValidation();
                afficherMasquerErreurB79ImputerTemps(response.main);
            }

            // ordonner les agrandissements du bloc 08 par date descendante
            var b08AgrandissementContainer = $('#b08-agrandissement');
            var b08Agrandissements = b08AgrandissementContainer.find('.sous-bloc-form').not('.sous-bloc-form.' + CLASSE_NOUVELLE_LIGNE);
            var agrandissements = b08Agrandissements.detach();
            var agrandissementOrderedDivs = agrandissements.sort(function (a, b) {
                var elementA = parseInt($(a).find('[name="annee"]').val());
                var elementB = parseInt($(b).find('[name="annee"]').val());
                return elementA < elementB ? 1 : elementA > elementB ? -1 : 0;
            });
            b08AgrandissementContainer.find('.sous-bloc-form.' + CLASSE_NOUVELLE_LIGNE).before(agrandissementOrderedDivs);
            // ré-assigner les no de lignes
            b08AgrandissementContainer.each(function (idx, obj) {
                assignerNoLigneSousBloc($(obj));
            });
        }

        if (modeWizard === true) {
            // rester a la meme étape apres la sauvegarde, s'il reste des validations en haut en rouge
            if ($('.step-pane.active .wiz-validation-erreur').length > 0) {
                $('#modal-step-contents').slimScroll({
                    scrollTo: 0
                }); // remonter le scroll en haut pour afficher les validations rouges
                nbErreurs += 1; // notifier qu'il y a encore des erreurs
            }
            wait.stop('contenu');
        }

        nbErreurs > 0 ? reponse.reponse = 'error' : reponse.reponse = 'ok';
        if (typeof (callback) != 'undefined' && callback != null) {
            if (reponse.reponse == 'error') {
                reponse.erreurs = response;
                reponse.status = 400;
            }

            if (avertissements) {
                reponse.avertissements = avertissements;
            }
            reponse.orginal_response = response;
            callback(reponse);
        }
        if (window.isRunningInApp) {
            var lienValidationErreur = $("#lienValidationErreur");
            lienValidationErreur.attr("data-nb-avertissements", nombreValidation("avertissements"));
            lienValidationErreur.attr("data-nb-erreurs", nombreValidation("erreurs"));
            window.dispatchEvent(new CustomEvent('fiche-post-save-server-success', {
                detail: {
                    htmlContent: generateHtmlForSaveModeDeconnecte(),
                    nbErreurs: nombreValidation("erreurs"),
                    nbAvertissements: nombreValidation("avertissements")
                }
            }));
        }
        wait.stop();
    };

    var error_cb = function (xhr, textStatus, error) {
        wait.stop();
        if (modeWizard === true) {
            wait.stop('contenu');
        }

        var responseText = xhr.responseText;
        if (xhr.status < 500) {
            let erreur;
            if (responseText) {
                erreur = $.parseJSON(responseText);
            }
            if (erreur && erreur.message_erreur) {
                infos.ajouterMessageToast({
                    message: "Erreur de sauvegarde : " + erreur.message_erreur,
                    messageDuree: 8000,
                    icone: 'fa-exclamation-circle',
                    iconeCouleur: 'red',
                    type: 'error',
                });
            }
        } else {
            if (responseText) {
                var baliseErreurEvb = 'ERREUR_EVB:';
                var indexBaliseEvbDebut = responseText.indexOf(baliseErreurEvb);

                if (indexBaliseEvbDebut != -1) {
                    var indexBaliseEvbFin = responseText.indexOf('^^^', indexBaliseEvbDebut);
                    var texteErreurEvb = responseText.substring(indexBaliseEvbDebut + baliseErreurEvb.length, indexBaliseEvbFin);
                    erreursAjax.afficherErreurGenerique('#erreurs-generiques', 'append', '', texteErreurEvb);
                }
            }

            infos.ajouterMessageToast({
                message: 'Une erreur s\'est produite. Contactez un administrateur.',
                messageDuree: 8000,
                icone: 'fa-exclamation-circle',
                iconeCouleur: 'red',
                type: 'error',
            });
            //TODO : logguer les erreurs
        }
        nbErreurs = 1;

        if (modeSave == ModeSave.FICHE) {
            majBadgesValidation();
        }

        if (typeof (callback) != 'undefined') {
            reponse.reponse = 'error';
            callback(reponse);
        }
    };

    var form_data = new FormData();
    $.each(params, function (key, value) {
        console.log("key", key, ", value", value);
        form_data.append(key, value);
    });

    $("input[type=file]").each(function (i, input) {
        if ((input.files.length || (input.fichier !== undefined && input.fichier.files !== undefined)) &&
            $(input).closest('.ace-file-input').find('.ace-file-container.selected').length) {
            // fichier upload : avoir le nom du champ en ajoutant le préfixe du sous-bloc et du no de ligne.
            // Ex.: 'b05-document-1-document.nom'
            let fichier = input.files.length ? input.files[0] : input.fichier.files;
            form_data.append($(input).closest('.champs-multiple').attr('id') + '-' +
                parseInt($(input).closest('.sous-bloc-form').attr('no-ligne')) + '-' +
                $(input).attr('name'), fichier, fichier.name);
        }
    });

    call_ajax_with_file(url, 'POST', form_data, success_cb, error_cb, accessToken);
}


function callBackSelectMultiplePointerup(option, event) {
    var o_this = $(option);
    // On ne veut pas continuer l'event en cas d'option disabled
    if ($(o_this).is(':disabled')) {
        return;
    }
    var o_event = event;
    setTimeout(function () {
        selectMultipleInputMultipleClicked(o_this, o_event);
    }, 50);
}

var modeLoad;

function initBlocsCharges(idFormulaire, idBloc, options) {
    var modeWizard = ($('#wizard').length > 0);
    if (typeof (options) == 'undefined') {
        options = {};
    }

    if (modeWizard) {
        modeLoad = ModeSave.WIZARD;
    } else if ($('#blocs-container').length > 0) {
        modeLoad = ModeSave.FICHE;
    } else {
        modeLoad = ModeSave.MENU;
    }

    if ('modeSave' in options) {
        modeLoad = options.modeSave;
    }

    var blocsContainer = options.blocsContainer;
    if (typeof (blocsContainer) == 'undefined') {
        if (modeLoad == ModeSave.FICHE) {
            blocsContainer = $('#blocs-container');
        }
        if (modeLoad == ModeSave.WIZARD || modeSave == ModeSave.VALEUR_TERRAIN) {
            blocsContainer = $('.step-pane.active');
        }
        if (modeLoad == ModeSave.MENU) {
            blocsContainer = $('#page_content');
        }
    }

    if (idBloc == null) {
        // fermer le bloc 09 car ce bâtiment n'est pas un condo
        var estCondo = $('#est-condo').val();
        if (estCondo == 'False') {
            $('#b09-caracteristique-copropriete-divise').find('.accordion-toggle').trigger('click');
        }

        if (modeLoad == ModeSave.FICHE) {
            $('#suppression-batiment').toggle(estBatiment(idFormulaire));
            $('#desannuler-batiment').toggle(estBatiment(idFormulaire));

        }

        // pour la fiche résidentielle
        if (idFormulaire == 2) {

            $('#b08-renseignements-generaux-batiment').find('[name="nb_logement"], [name="nb_chambre_locative"], [name="nb_local"]').change(function () {
                ouvrirFermerBloc81();
            });

            ouvrirFermerBloc81();

            function ouvrirFermerBloc81() {
                var b08 = $('#b08-renseignements-generaux-batiment');
                var b08NbLogement = b08.find('[name="nb_logement"]').val() ? parseInt(b08.find('[name="nb_logement"]').val()) : 0;
                var b08NbChambreLocative = b08.find('[name="nb_chambre_locative"]').val() ? parseInt(b08.find('[name="nb_chambre_locative"]').val()) : 0;
                var b08NbLocal = b08.find('[name="nb_local"]').val() ? parseInt(b08.find('[name="nb_local"]').val()) : 0;
                if (b08NbLogement > 1 || b08NbChambreLocative > 0 || b08NbLocal >= 0) {
                    // ouvrir le bloc 81 si une donnée est saisie au bloc 08
                    $('#b81-inventaire').find('.accordion-toggle.collapsed').trigger('click');
                } else {
                    // fermer le bloc 81 du résidentiel selon les données du bloc 08
                    $('#b81-inventaire').find('.accordion-toggle').not('.collapsed').trigger('click');
                }
            }

        }
    }

    // On initialise les évènements de chacun des blocs
    var blocs = blocsContainer.find('.blocForm');
    // ou on initialise les évènements de ce bloc seulement
    if (idBloc != null) {
        blocs = blocs.filter('[id_bloc="' + idBloc + '"]');
    }
    // if (window.isRunningInApp && modeErreur) {

    // afficher un tooltip de la sélection sur le sélecteur au chargement de la fiche et à chaque changement
    // ajouter le code pour les sélecteurs qui ont cette notion en plus de la valeur
    blocs.find('select.form-control')
        .not('.container-select-multiple-input-multiple select, .container-select-multiple select,' +
            ' .geo-select, #b79-attestation select, #type-regroupement-x-variable select')
        .each(function () {
                    ajouterTooltipSelecteur($(this));
            $(this).find('option').each(function () {
                        var splitText = $(this).text().split(/ | - /, 1);
                        if (splitText.length >= 1 && splitText.length <= 2) {
                            if (splitText[0] != $(this).val()) {
                                $(this).attr('code', splitText[0]);
                            }
                        }
            });
        })
        .on('change', function (e) {
            ajouterTooltipSelecteur($(this));
        });

    function ajouterTooltipSelecteur(selecteur) {
        selecteur.attr('title', selecteur.find('option:selected').text());
    }

    $.each(blocs, function (index, bloc) {

        var idBloc = $(bloc).attr('id_bloc');

        var nomFonction = 'initBloc' + idBloc;
        if (typeof window[nomFonction] === "function") window[nomFonction]();

        // garder la valeur courante pour chaque sélecteur simple
        var selects = $(bloc).find('.container-select-multiple select.form-control');
        var selectUlsMultiples = $(bloc).find('.container-select-multiple ul.form-control');
        var selectUlsMultiplesInput = $(bloc).find('.container-select-multiple-input-multiple ul.form-control');
        $.each(selects, function (key, valeur) {
            $(valeur).attr('selection-precedente', $(valeur).val());
        });
        // les listes n'ont pas de valeur, on prend un autre chemin pour aller chercher la valeur du input associé
        $.each(selectUlsMultiples, function (idx, element) {
            let value = $(element).closest('.blocForm').find('input[parent="' + $(element).data('js') + '"]').attr('value');
            $(element).attr('selection-precedente', value);
            $(element).attr('value', value);
        });
        $.each(selectUlsMultiplesInput, function (idx, element) {
                    $.each($(element).closest('.blocForm').find('input[parent="' + $(element).data('js') + '"]'), function (idx, inputElement) {
                var previousValue = $(element).attr('selection-precedente');
                var newValue = $(inputElement).attr('value');
                if (previousValue) {
                    $(element).attr('selection-precedente', previousValue + ',' + newValue);
                } else {
                    $(element).attr('selection-precedente', newValue);
                }
            });
        });

        initSelecteurMultiple($(bloc), false);

        $.each($(bloc).find('.champs-multiple'), function (idx, obj) {
            initChampsMultiple($(obj));
        });

        // On initialise le spinner pour les input de type "number"
        $.each($(bloc).find('.integer-spinner'), function (index, valeur) {
            initIntegerSpinner($(valeur));
        });


        if (modeLoad == ModeSave.FICHE) {
            //bloc 07 calculs
            calculerBloc07(idFormulaire, idBloc);

            // interaction bloc 07 vs bloc 31 du NR
            interactionB07vsB31(idFormulaire, idBloc);

            // ordonner services du bloc 81
            initServicesBloc81(idBloc);
        }

        if (modeWizard) {
            var etapeProcessusId = $('.steps').find('.active').data('id_processus');
            if (etapeProcessusId == '31') {
                $('.step-pane.active [id^=accordion-batiment-]').each(function () {
                            var divBatiment = $(this);
                            var splitId = divBatiment.attr('id').split('-');
                            var idFormulaire = splitId[4];
                            if (idFormulaire == ID_FORMULAIRE.nonResidentiel && ($(this).find('.avant-container').find('#b31-cloison')).length > 0 && ($(this).find('.avant-container').find('#b07-dimension-base')).length > 0) {
                                var b07HauteurBruteSousSol = $(this).find('.avant-container').find('#b07-dimension-base').find('[name="hauteur_brute_sous_sol"]');
                                var b07HauteurHauteurEtage = $(this).find('.avant-container').find('#b07-dimension-base').find('[name="hauteur"]');
                                var b31HauteurMoyenneSousSol = $(this).find('.avant-container').find('#b31-paroi-interieure-1').find('[name="hauteur_moyenne"]');
                                var b31HauteurMoyenneEtage = $(this).find('.avant-container').find('#b31-paroi-interieure-2').find('[name="hauteur_moyenne"]');
                                if (b07HauteurBruteSousSol.val() != b31HauteurMoyenneSousSol.val()) {
                                    b31HauteurMoyenneSousSol.val(b07HauteurBruteSousSol.val());
                                    b31HauteurMoyenneSousSol.trigger('change');
                                }
                                if (b07HauteurHauteurEtage.val() != b31HauteurMoyenneEtage.val()) {
                                    b31HauteurMoyenneEtage.val(b07HauteurHauteurEtage.val());
                                    b31HauteurMoyenneEtage.trigger('change');
                                }
                            }
                });
            }
            }
            });

    // DM: nécessaire pour charger les contrôles SELECT avec tags
    init_chosen(blocs);

    init_date_picker(blocs); // Laisser ceci à la fin car sinon le calendrier du b79 reçoit un focus indésirable.

    init_change_event_sous_bloc(blocs);


    if (modeLoad === ModeSave.FICHE) {
        blocs.find('ul.form-control li.option').mouseup(function () {
                    if ($(this).hasClass('bg-grey')) {
                        ($(this).removeClass('bg-grey'));
                setTimeout(function () {
                            selectGrisInputChoisi();
                }, 150);
            }
            });
            }

    console.log('gestion-roles.js: modifie 2025-12-02 V2');
    blocs.find('.container-select-multiple select.form-control, .container-select-multiple ul.form-control li.option')
        .off("click.selectMultiple")
        .on("click.selectMultiple", function (e) {
                    $(this).siblings('li.selected').removeClass('selected');
                    $(this).addClass('selected');
                    selectMultipleClicked($(this));
        });

    // #12493: Gestion du click/touch/stylet a l'aide de la librairie PEP, inclu dans editeur-fiche.html
    // 1) on ajoute un nouvel attribut à nos 'options' concernées
    $('.container-select-multiple-input-multiple select.form-control>option, .container-select-multiple-input-multiple select.form-control>optgroup>option').attr('touch-action', 'oui');
    // 2) On peut maintenant écouter sur l'event pointerup (et ne plus se soucier de click, vclick, touch etc... et les appels concurents ou subséquents

    blocs.find('.container-select-multiple-input-multiple select.form-control>option, .container-select-multiple-input-multiple select.form-control>optgroup>option, .container-select-multiple-input-multiple ul.form-control>.option').off('pointerup').on('pointerup', function (event) {
                setTimeout(function () {
            selectGrisInputChoisi();
        }, 150);
        callBackSelectMultiplePointerup(this, event);
    });
    // pour les sélecteurs dans un sous-bloc qui ont un sélecteur parent(ex.: bloc 61), il faut afficher les sélections faites
    blocs.find('.champs-multiple select[parent]').on('change', function () {
        var bloc = $(this).closest('.blocForm');
        initSelecteurMultiple(bloc, false);
    });

    // DM: HACK avec Firefox pour cacher les scrollbars des SELECT
    var FF = estFirefox();
    if (FF) {
        blocs.find(".container-select-multiple,.container-select-multiple-input-multiple").css({
            'display': 'inline-block',
            'vertical-align': 'top',
            'overflow': 'hidden'
        });

        blocs.find(".container-select-multiple select,.container-select-multiple-input-multiple select").css({
            'padding': '10px',
            'margin': '-5px -27px -5px -5px'
        });
    } else {
        // espacement entre les colonnes d'un select multiple
        blocs.find(".container-select-multiple > div,.container-select-multiple-input-multiple  > div").css({
            'padding-right': '10px'
        });
    }

    // corriger les input-select-multiple dont le parent n'a pas de portrait antérieur
    // i.e. le portrait antérieur n'existe pas donc on retourne un serializer vide
    // qui ne prend pas en compte les champs custom(read_only=True)
    $.each(blocs.find('select.form-control'), function () {
        var select = $(this);
        var inputAssocie = getInputSelectSimple(select);
        if (inputAssocie) {
            // passer la valeur antérieure au input associé et l'enlever sur le select
            inputAssocie.attr('valeur-anterieure', select.attr('valeur-anterieure'));
            inputAssocie.addClass(CLASSE_PORTRAIT_ANTERIEUR);
            select.removeAttr('valeur-anterieure');
        }
    });
    // }

    // Initialisation des boutons input file en lot
    if (!window.isRunningInApp) {

        var organisation = securite.reqOrganisation();
        var documents = blocs.find('.btn-file input[type="file"][lot-sous-bloc]');
        var organisationInput = $("#organisationJSON");
        if (organisationInput.length) {
            organisationInput.val(JSON.stringify(organisation));
        }

        $.each(documents, function (idx, obj) {
            initAceInputFile($(obj), organisation);
        });

        // Initialisation des input file de sous-blocs
        var documents = blocs.find('.sous-bloc-form');
        $.each(documents.find('.ace-input-file'), function (idx, obj) {
            initAceInputFile($(obj), organisation);
        });
    }
    // on affiche le portrait antérieur pour les champs d'un bloc
    $.each(blocs.find('input.form-control[valeur-anterieure], select.form-control[valeur-anterieure]'), function () {
        var ctrl = $(this);
        var valeurAnterieure = ctrl.attr('valeur-anterieure');
        var defaultValue = ctrl.prop('defaultValue'); // prendre le 'defaultValue' car il est utilisable pour le checkbox aussi
        // si 'valeur-anterieure' est différente de la valeur actuelle
        // en plus pour un checkbox, vérifier que la valeur du portrait antérieur est égale à ''(vide), ça veut dire que la valeur du checkbox est '0'
        if (valeurAnterieure != defaultValue && !(ctrl.is('input:checkbox') && valeurAnterieure == '' && ctrl.prop('defaultValue') == 0)) {
            marquerChangement(ctrl, true);
            ctrl.addClass(CLASSE_PORTRAIT_ANTERIEUR);
        }
    });

    // on affiche le portrait antérieur pour les lignes d'un sous-bloc car chaque ligne a l'attribut 'bloc-editable'
    $.each(blocs.find('.sous-bloc-form[bloc-editable="True"]').not('.sous-bloc-form.nouvelle-ligne'), function () {
        var ligne = $(this);
        // vérifier que la ligne a des données
        if (!ligneEstSansDonnee(ligne)) {
            var ctrlsException = getCtrlSuppressionException(ligne);
            $.each(ligne.find(':input.form-control, label.ace-file-input span.ace-file-container').not(ctrlsException), function () {
                var ctrl = $(this);
                marquerChangement(ctrl, true);
                ctrl.addClass(CLASSE_PORTRAIT_ANTERIEUR);
            });
        }
    });

    if ($('#mode-read-only').val() == 'False' || !$('#mode-read-only').val() /* pour Wizard */ ) {
        var blocsContainerEdit = blocsContainer;
        if (blocsContainerEdit.find('.apres-container').length > 0) {
            blocsContainerEdit = blocsContainerEdit.find('.apres-container');
        }

        initCodeUtilisationSelect2(blocsContainerEdit);
        initProprietaireSelect2(blocsContainerEdit);
    }

    var checkChanging = false;
    // check-box "sélectionner tous" dans l'entete du sous-bloc
    $('.champs-multiple .selectionner-tous').each(function () {
                $(this).on('change', function (e) {
            if (checkChanging) {
                return;
            }

            var sousBloc = $(this).closest('.champs-multiple');
            var name = $(this).attr('name');
            var checks = sousBloc.find('.sous-bloc-form [name=' + name + ']');
            var checked = $(this).is(':checked');
            checkChanging = true;

            checks.each(function () {
                if ($(this).is(':checked') != checked) {
                    $(this).click();
                }
            });

            // checks.prop("checked", checked);
            checkChanging = false;
        });
    });

    // initialisation des combobox cascades (utilisés présentement dans la NR)
    initCascade(blocsContainer);


    blocsContainer.find('.bloc-tout-copier').on('click', function (e) {
        blocsContainer.find('.bloc-copier').click();
    });

    blocsContainer.find('.btn-tj-copier-autre-utilisation').off('click').on('click', function (e) {

        var container = $(this).closest('[id^=mutation-traitement]');
        var blocAvant = container.find('[id="collapse-evenement3"] .blocForm');
        var blocApres = container.find('[id="collapse-apres"] .blocForm');

        var inputsBlocApres = blocApres.find(':input:not(button)').not('.champs-multiple :input');

        var sousBlocsAvant = blocAvant.find('.champs-multiple, [id="b04-terrain-agricole-boise"]').not('[id="b04-service-tab"]');
        var sousBlocsApres = blocApres.find('.champs-multiple, [id="b04-terrain-agricole-boise"]').not('[id="b04-service-tab"]');

        sousBlocsAvant.each(function () {
            var sousBlocAvant = $(this);
            var sousBlocApres = sousBlocsApres.filter('[id="' + sousBlocAvant.attr('id') + '"]');

            var matchsAvant = [];
            var matchsApres = [];

            // obtenir la liste des rows qui sont identiques dans le AVANT et le APRES
            var sousBlocAvantRows = sousBlocAvant.find('.sous-bloc-form:not(.nouvelle-ligne)');
            sousBlocAvantRows.each(function (idx) {
                var row = $(this);

                var rowApres = trouverRowIdentique(sousBlocApres, row, matchsApres);
                if (rowApres != null) {
                    matchsAvant.push(row[0]);
                    matchsApres.push(rowApres[0]);
                }
            });

            // dans la portion APRÈS, supprimer toutes les lignes qui n'ont pas leur identique dans la portion AVANT
            var sousBlocApresRows = sousBlocApres.find('.sous-bloc-form:not(.nouvelle-ligne)');
            sousBlocApresRows.each(function () {
                if ($(this).find('input.ctrl-suppression:checked').length == 0 && $(this).find('.suppression-ligne').length == 0) {
                    if ($.inArray($(this)[0], matchsApres) == -1) {
                        // tentative de supprimer. On essaie d'abord par la poubelle
                        if ($(this).find('input.ctrl-suppression').length > 0) {
                            $(this).find('input.ctrl-suppression').click();
                            return true;
                        }

                        // tentative de supprimer en cliquant l'item du select dans la liste parente
                        var inputSelectMultiple = $(this).find('.input-select-multiple .form-control');
                        if (inputSelectMultiple.length > 0) {
                            var parentName = inputSelectMultiple.attr('parent');
                            if (parentName) {
                                var inputListeApres = blocApres.find('.container-select-multiple-input-multiple select[name="' + parentName + '"]');
                                if (inputListeApres.length > 0 && inputListeApres.attr('selection-none') == undefined) {
                                    var inputRow = $(this).find('.form-control[parent="' + inputListeApres.attr('name') + '"]');
                                    var inputRowValue = getBlocControlValeurs(inputRow, inputRow)[1]; // inputRow.val();
                                    var option = inputListeApres.find('option[value="' + inputRowValue + '"]');

                                    var inputApres = inputListeApres.filter(function () {
                                        return ($(this).find('option[value="' + option.val() + '"]').length > 0);
                                    });

                                    var idx = inputApres.find('option').index(option);
                                    inputApres.prop('selectedIndex', idx);
                                    simulerClicSelectMultiple(inputApres, idx);
                                    return true;
                                }
                            }
                        }
                    }
                }
            });

            // à partir de la portion AVANT, copier toutes les lignes qui n'ont pas leur identique dans la portion APRES
            sousBlocAvant.find('.sous-bloc-form:not(.nouvelle-ligne)').each(function () {
                var fromRow = $(this);
                var toRow;
                var idxMatchAvant = $.inArray(fromRow[0], matchsAvant);
                if (idxMatchAvant > -1) {
                    // DM 2019-03-27: finalement on va appeler blocCopierRow quand même, car on doit passer par là juste pour les repères
                    toRow = $(matchsApres[idxMatchAvant]);
                    blocCopierRow(fromRow, toRow);

                    return true; // ligne identique présente dans le APRES, on skip
                }

                toRow = sousBlocApres.find('.sous-bloc-form.nouvelle-ligne'); // comme cible on essaie d'abord le cas le plus élémentaire: la ligne vierge en bas

                // vérifier si on a une liste associée, pour créer une nouvelle ligne en cliquant dessus
                //if (toRow.length == 0) { // veut rien dire finalement (exemple bloc 13 NR, dalle, on avait une nouvelle ligne quand même)
                var inputSelectMultiple = $(this).find('.input-select-multiple .form-control');
                if (inputSelectMultiple.length > 0) {
                    var parentName = inputSelectMultiple.attr('parent');
                    if (parentName) {
                        var inputListeApres = blocApres.find('.container-select-multiple-input-multiple select[name="' + parentName + '"]:enabled');
                        if (inputListeApres.length > 0) {
                            // on clique l'item correspondant pour créer la ligne
                            var inputRow = fromRow.find('.form-control[parent="' + inputListeApres.attr('name') + '"]');
                            var inputRowValue = getBlocControlValeurs(inputRow, inputRow)[1]; // inputRow.val();
                            var option = inputListeApres.find('option[value="' + inputRowValue + '"]');

                            var inputApres = inputsBlocApres.filter('[name="' + inputListeApres.attr('name') + '"]').filter(function () {
                                return ($(this).find('option[value="' + option.val() + '"]').length > 0);
                            });

                            var idx = inputApres.find('option').index(option);
                            inputApres.prop('selectedIndex', idx);
                            simulerClicSelectMultiple(inputApres, idx);

                            if (inputListeApres.attr('selection-none') == undefined) { // liste que les choix sont cliquables une seule fois
                                var nomSelectCode = inputRow.attr('name');
                                var val = fromRow.find('.form-control[name="' + nomSelectCode + '"]').val();
                                var selectApres = sousBlocApres.find('.form-control[name="' + nomSelectCode + '"]').filter(function () {
                                    return ($(this).val() == val);
                                });

                                toRow = selectApres.closest('.sous-bloc-form');
                            } else { // liste select dont on peut cliquer un choix plus d'une fois
                                toRow = sousBlocApres.find('.sous-bloc-form').last();
                            }
                        }
                    }
                }

                // Sous-bloc n'ayant qu'une row et aucune nouvelle ligne. Comme les RCT ou Remarque par exemple.
                if (toRow.length == 0 && sousBlocApres.find('.sous-bloc-form').length == 1) {
                    toRow = sousBlocApres.find('.sous-bloc-form').first();
                }

                blocCopierRow(fromRow, toRow);
            });
        });

        // il y a certains champs qui n'activent pas le bouton Sauvegarder, alors on le force
        $('#btn-wizard-save').prop('disabled', false);

        // #25900 : force une réactualisation des champs imasks copiés:
        $('form#b04-terrain-agricole-boise [name="superficie"]').each(function (e) {
            let champ = $(this)[0];
            if (champ.imask != undefined) {
                champ.imask.updateValue();
            }
        });

    });

    blocsContainer.find('.bloc-copier').on('click', function (e) {

        var container = $(this).closest('[id^=nature_]');
        var blocAvant = container.find('.avant-container .blocForm');
        var blocApres = container.find('.apres-container .blocForm');


        var inputsBlocAvant = blocAvant.find(':input:not(button)').not('.champs-multiple :input');
        var inputsBlocApres = blocApres.find(':input:not(button)').not('.champs-multiple :input');

        inputsBlocAvant.each(function () {
            var inputAvant = $(this);
            var inputAvantNom = inputAvant.attr('name');
            var inputAvantVal = inputAvant.val();
            var inputApres = inputsBlocApres.filter('[name="' + inputAvantNom + '"]');
            var inputApresVal = inputApres.val();

            if (inputAvant.closest('.container-select-multiple-input-multiple,.container-select-multiple').length > 0) {
                inputAvantVal = inputAvant.attr('selection-precedente');
                inputApresVal = inputApres.attr('selection-precedente');
            }

            if (inputAvantVal != inputApresVal) {
                function copierSelectMultiple() {
                    inputAvant.find('option').each(function () {
                        var optionAvant = $(this);

                        var inputApres = inputsBlocApres.filter('[name="' + inputAvantNom + '"]').filter(function () {
                            return ($(this).find('option[value="' + optionAvant.attr('value') + '"]').length > 0);
                        });

                        var optionApres = inputApres.find('option[value="' + optionAvant.attr('value') + '"]');

                        var selectedAvant = optionAvant.prop('selected'); // ($.inArray(optionAvant.attr('value'), selOptionsAvant) > -1);
                        var selectedApres = optionApres.prop('selected'); // ($.inArray(optionApres.attr('value'), selOptionsApres) > -1);

                        if (selectedAvant != selectedApres) {
                            var idx = inputApres.find('option').index(optionApres);
                            inputApres.prop('selectedIndex', idx);
                            simulerClicSelectMultiple(inputApres, idx);
                            copieMarquerModifie(inputApres);
                        }
                    });
                }

                if (inputAvant.closest('.container-select-multiple-input-multiple').length > 0) {
                    return; // pour éviter de marquer comme modifié plus bas dans "blocCopierControl" (donc plantait côté serveur, voir issue #7598)
                }

                if (inputAvant.closest('.container-select-multiple').length > 0) {
                    copierSelectMultiple();
                    return;
                }
            }

            blocCopierControl(inputAvant, inputApres);
        });

        // on ne veut pas copier les adresses de propriétaires car ils sont en read-only et que les données sont
        // correctes au chargement
        var sousBlocsAvant = blocAvant.find('.champs-multiple').not('[id="b02-adresse-proprietaire"]');
        var sousBlocsApres = blocApres.find('.champs-multiple').not('[id="b02-adresse-proprietaire"]');

        sousBlocsAvant.each(function () {
            var sousBlocAvant = $(this);
            var sousBlocApres = sousBlocsApres.filter('[id="' + sousBlocAvant.attr('id') + '"]');

            var matchsAvant = [];
            var matchsApres = [];

            // obtenir la liste des rows qui sont identiques dans le AVANT et le APRES
            var sousBlocAvantRows = sousBlocAvant.find('.sous-bloc-form:not(.nouvelle-ligne)');
            sousBlocAvantRows.each(function () {
                var row = $(this);

                var rowApres = trouverRowIdentique(sousBlocApres, row, matchsApres);
                if (rowApres != null) {
                    matchsAvant.push(row[0]);
                    matchsApres.push(rowApres[0]);
                }
            });

            // dans la portion APRÈS, supprimer toutes les lignes qui n'ont pas leur identique dans la portion AVANT
            var sousBlocApresRows = sousBlocApres.find('.sous-bloc-form:not(.nouvelle-ligne)');
            sousBlocApresRows.each(function () {
                if ($(this).find('input.ctrl-suppression:checked').length == 0 && $(this).find('.suppression-ligne').length == 0) {
                    if ($.inArray($(this)[0], matchsApres) == -1) {
                        // tentative de supprimer. On essaie d'abord par la poubelle
                        if ($(this).find('input.ctrl-suppression').length > 0) {
                            $(this).find('input.ctrl-suppression').click();
                            return true;
                        }

                        // tentative de supprimer en cliquant l'item du select dans la liste parente
                        var inputSelectMultiple = $(this).find('.input-select-multiple .form-control');
                        if (inputSelectMultiple.length > 0) {
                            var parentName = inputSelectMultiple.attr('parent');
                            if (parentName) {
                                var inputListeApres = blocApres.find('.container-select-multiple-input-multiple select[name="' + parentName + '"]');
                                if (inputListeApres.length > 0 && inputListeApres.attr('selection-none') == undefined) {
                                    var inputRow = $(this).find('.form-control[parent="' + inputListeApres.attr('name') + '"]');
                                    var inputRowValue = getBlocControlValeurs(inputRow, inputRow)[1]; // inputRow.val();
                                    var option = inputListeApres.find('option[value="' + inputRowValue + '"]');

                                    var inputApres = inputListeApres.filter(function () {
                                        return ($(this).find('option[value="' + option.val() + '"]').length > 0);
                                    });

                                    var idx = inputApres.find('option').index(option);
                                    inputApres.prop('selectedIndex', idx);
                                    simulerClicSelectMultiple(inputApres, idx);
                                    return true;
                                }
                            }
                        }
                    }
                }
            });

            // à partir de la portion AVANT, copier toutes les lignes qui n'ont pas leur identique dans la portion APRES
            sousBlocAvant.find('.sous-bloc-form:not(.nouvelle-ligne)').each(function () {
                var fromRow = $(this);
                var toRow;
                var idxMatchAvant = $.inArray(fromRow[0], matchsAvant);
                if (idxMatchAvant > -1) {
                    // DM 2019-03-27: finalement on va appeler blocCopierRow quand même, car on doit passer par là juste pour les repères
                    toRow = $(matchsApres[idxMatchAvant]);
                    blocCopierRow(fromRow, toRow);

                    return true; // ligne identique présente dans le APRES, on skip
                }

                toRow = sousBlocApres.find('.sous-bloc-form.nouvelle-ligne'); // comme cible on essaie d'abord le cas le plus élémentaire: la ligne vierge en bas

                // vérifier si on a une liste associée, pour créer une nouvelle ligne en cliquant dessus
                var inputSelectMultiple = $(this).find('.input-select-multiple .form-control');
                if (inputSelectMultiple.length > 0) {
                    var parentName = inputSelectMultiple.attr('parent');
                    if (parentName) {
                        var inputListeApres = blocApres.find('.container-select-multiple-input-multiple select[name="' + parentName + '"]:enabled');
                        if (inputListeApres.length > 0) {
                            // on clique l'item correspondant pour créer la ligne
                            var inputRow = fromRow.find('.form-control[parent="' + inputListeApres.attr('name') + '"]');
                            var inputRowValue = getBlocControlValeurs(inputRow, inputRow)[1]; // inputRow.val();
                            var option = inputListeApres.find('option[value="' + inputRowValue + '"]');

                            var inputApres = inputsBlocApres.filter('[name="' + inputListeApres.attr('name') + '"]').filter(function () {
                                return ($(this).find('option[value="' + option.val() + '"]').length > 0);
                            });

                            var idx = inputApres.find('option').index(option);
                            inputApres.prop('selectedIndex', idx);
                            simulerClicSelectMultiple(inputApres, idx);

                            if (inputListeApres.attr('selection-none') == undefined) { // liste que les choix sont cliquables une seule fois
                                var nomSelectCode = inputRow.attr('name');
                                var val = fromRow.find('.form-control[name="' + nomSelectCode + '"]').val();
                                var selectApres = sousBlocApres.find('.form-control[name="' + nomSelectCode + '"]').filter(function () {
                                    return ($(this).val() == val);
                                });

                                toRow = selectApres.closest('.sous-bloc-form');
                            } else { // liste select dont on peut cliquer un choix plus d'une fois
                                toRow = sousBlocApres.find('.sous-bloc-form').last();
                            }
                        }
                    }
                }

                // Sous-bloc n'ayant qu'une row et aucune nouvelle ligne. Comme les RCT ou Remarque par exemple.
                if (toRow.length == 0 && sousBlocApres.find('.sous-bloc-form').length == 1) {
                    toRow = sousBlocApres.find('.sous-bloc-form').first();
                }

                blocCopierRow(fromRow, toRow);
            });
        });

        // ne pas sauvegarder les champs read-only de b93_cout_neuf
        blocApres.find('#b93-cout-neuf-sous-bloc input').removeClass('valeur-modifiee');

        // il y a certains champs qui n'activent pas le bouton Sauvegarder, alors on le force
        $('#btn-wizard-save').prop('disabled', false);
    });

    setTimeout(function () {
        var sousBlocsB12 = blocsContainer.find('#b12-bati-mur .sous-bloc-form:not(.nouvelle-ligne)').closest('.champs-multiple');
        sousBlocsB12.each(function () {
            if (modeLoad == ModeSave.FICHE) {
                var blocsContainerFiche = blocsContainer;
            } else {
                var blocsContainerFiche = $(this).closest('[id^=accordion-batiment-]');
            }

            assurerBlocOuvert(blocsContainerFiche, '07');
        });
    }, 500);

    var callback = options.callback; // la fin d'initialisation des repères sera considéré comme la fin de l'initialisation des blocs au complet
    // if (window.isRunningInApp && !modeErreur) {
    initReperes(blocsContainer, (idBloc == null), callback);
    // }

    $('#b81-espace-locatif-nonresidentiel [name="typeOccupationMulti"]').on('change', function () {
        var Typeselected = $(this).find("option:selected").val();
        var paramsSupp = {};
        var champ = $(this).closest('.sous-bloc-form').find('[name="proprietaire"]');
        if (Typeselected == 4) {
            champ.val(null).trigger('change');
            initSelecteurDeRecherche($(champ), "/gestion-roles/get-choix-proprietaire", false, false, true, paramsSupp, false);
            champ.prop('disabled', true);
        } else {
            champ.prop('disabled', false);
            var champ_bloc = $(this).closest('.sous-bloc-form');
            initProprietaireSelect2(champ_bloc);
        }
    });

    function initvoiepubliqueb81(sous_bloc) {
        var b81 = $('#' + sous_bloc + ' .row.sous-bloc-form.nouvelle-ligne');
        if (b81.find('select[name="voiePublique"] option').length == 2) {
            $('#' + sous_bloc + ' .row.sous-bloc-form').find('[name="voiePublique"] option:last').attr('selected', 'selected');
            $('#' + sous_bloc + ' .row.sous-bloc-form').find('[name="voiePublique"]').prop('disabled', true);
        }
    }

    initvoiepubliqueb81('b81-espace-locatif-nonresidentiel');
    initvoiepubliqueb81('b81-espace-locatif-residentiel');


    // 13923, init de la carte
    // ********************************************************************************************
    // seulement pour la fiche agricole
    // b04-terrain-agricole-boise
    var ficheVariablesContainer = $('#editeur-fiche-globales-variables')

    if ($('#b04-terrain-agricole-boise')[0]) {
        if ($('#headerTitre')[0]) {
            var idMunicipalite = $('#headerTitre').attr('code-geographique'); //id-municipalite
            var id_ue = $('#infobox-identifiant').text();
            var matricule = $('#infobox-identifiant-matricule').text().substring(0, 12);
            var params = {
                'idMunicipalite': idMunicipalite,
                'id_ue': id_ue.substring(7, id_ue.length),
                'date_evenement': $('#date-evenement-en-cours').text().trim(),
                'matricule': matricule,
                'is_fiche_terrain': 'true'
            };
            chargerinformationecoforestiere(params);
        }
        if ($('#b04-terrain-agricole-boise').attr('id_model_instance') !== 'None') {
            // Si la ficheVariablesContainer n'est pas vide, on doit mettre le input de superficie en read only avec un tooltip
            if (ficheVariablesContainer.length > 0) {
                var inputSuperficieB04Tab = $('#b04-terrain-agricole-boise').find('input#form-superficie_agricole_exploitable_non_exploitee');
                inputSuperficieB04Tab.attr('disabled', 'disabled')
                inputSuperficieB04Tab.attr('title', 'Ce champ doit être modifié à partir de l\'assistant d\'événement');
            }

            if (modeLoad === ModeSave.WIZARD) {
                initQuestionOmiseInscriteTerrain('b04-terrain-agricole-boise', blocsContainerEdit, blocsContainer);
            }
        }
    }

    if ($('#b04-terrain-general')[0] && $('#b04-terrain-general').attr('id_model_instance') !== 'None'){
        // Si la ficheVariablesContainer n'est pas vide, on doit mettre le input de superficie en read only  avec un tooltip
        var inputSuperficieB04Tg = $('#b04-terrain-general').find('input#form-superficie_agricole_exploitable_non_exploitee');

        if (ficheVariablesContainer.length > 0) {
            inputSuperficieB04Tg.attr('disabled', 'disabled')
            inputSuperficieB04Tg.attr('title', 'Ce champ doit être modifié à partir de l\'assistant d\'événement');
        }

        if (modeLoad === ModeSave.WIZARD) {
            initQuestionOmiseInscriteTerrain('b04-terrain-general', blocsContainerEdit, blocsContainer);
        }
    }

    //*********************************************************************************************

}

function initQuestionOmiseInscriteTerrain(typeTerrain, blocsContainerEdit, blocsContainer){
     let inputSuperficiePourOmiseInscrite;
     let inputAvantSuperficiePourOmiseInscrite;

     inputSuperficiePourOmiseInscrite = blocsContainerEdit.find("#collapse-apres").find('#' + typeTerrain).find('input#form-superficie_agricole_exploitable_non_exploitee');
     inputAvantSuperficiePourOmiseInscrite = blocsContainer.find('#' + typeTerrain).find('input#form-superficie_agricole_exploitable_non_exploitee');
     gererTexteQuestionOmiseInscriteTerrain(inputSuperficiePourOmiseInscrite, inputAvantSuperficiePourOmiseInscrite, typeTerrain);
     gererAffichageQuestionOmiseInscriteTerrain(inputSuperficiePourOmiseInscrite, inputAvantSuperficiePourOmiseInscrite, typeTerrain);
}

function init_b46_modele_densite() {
    // #23524 B46 Électricité - prises de courant usuelles - champ densité automatique (via B46PriseCourantUsuelleSerializer)
    $('#b46-prise-courant-usuelle #form-modeleDensitePriseCourantUsuelle').off('change').on('change', function (evt) {
        let champ_densite = $($(this).parents('.row')[0]).find('#form-densite');
        let valeur_densite = $(champ_densite).val();
        let nouvelle_densite = $(this).find('[value="' + $(this).val() + '"]').data('densite_prise');
        if ($(champ_densite).val() == "") {
            $(champ_densite).val(nouvelle_densite);
            $(champ_densite).change();
        } else if (valeur_densite != nouvelle_densite) {
            let texte_modele_selectionne = $(this).find('option[value="' + $(this).val() + '"]').text();
            let messageConfirm =
                'Vous avez sélectionné le modèle de prise de courant "' + texte_modele_selectionne + '" \nayant une densité de (' + nouvelle_densite + ').' +
                '<br/>Le champ densité à déja une valeur (' + valeur_densite + ') voulez-vous la remplacer?';
            fenetreModal.modalMessage({
                conteneur: "#" + $(this).parents('form').attr('id'),
                enteteTitre: "Changement de valeur du champ densité",
                sansX: true,
                texteExplicatif: messageConfirm,
                boutons: {
                    "conserver": {
                        label: ' Conserver ',
                        id: "",
                        class: "btn",
                        action: function () {}
                    },
                    "remplacer": {
                        label: ' Remplacer ',
                        id: "",
                        class: "btn  btn-success",
                        action: function () {
                            $(champ_densite).val(nouvelle_densite);
                            $(champ_densite).change();
                        }
                    }
                }
            });
        }
    });
}

function init_b47_modele_densite() {
    // #23524 B47 Éclairage - type de lampes - champ densité automatique (via B47EclairageSousBlocSerializer)
    $('#b47-eclairage-sous-bloc #form-modeleDensiteEclairage').off('change').on('change', function (evt) {
        let champ_densite = $($(this).parents('.row')[0]).find('#form-densite');
        let valeur_densite = $(champ_densite).val();
        let nouvelle_densite = $(this).find('[value="' + $(this).val() + '"]').data('densite_eclairage');
        if (valeur_densite == "") {
            $(champ_densite).val(nouvelle_densite);
            $(champ_densite).change();
        } else if (valeur_densite != nouvelle_densite) {
            let texte_modele_selectionne = $(this).find('option[value="' + $(this).val() + '"]').text();
            let messageConfirm =
                'Vous avez sélectionné le modèle de lampe "' + texte_modele_selectionne + '" \nayant une densité de (' + nouvelle_densite + ').' +
                '<br/>Le champ densité à déja une valeur (' + valeur_densite + ') voulez-vous la remplacer?';
            fenetreModal.modalMessage({
                conteneur: "#" + $(this).parents('form').attr('id'),
                enteteTitre: "Changement de valeur du champ densité",
                sansX: true,
                texteExplicatif: messageConfirm,
                boutons: {
                    "conserver": {
                        label: ' Conserver ',
                        id: "",
                        class: "btn",
                        action: function () {}
                    },
                    "remplacer": {
                        label: ' Remplacer ',
                        id: "",
                        class: "btn  btn-success",
                        action: function () {
                            $(champ_densite).val(nouvelle_densite);
                            $(champ_densite).change();
                        }
                    }
                }
            });
        }
    });
}


function copieMarquerModifie(controle) {
    controle.addClass(CLASSE_CONTROLE_MODIFIE);

    if (controle.attr('name') == 'code_postal') {
        controle.closest('.blocForm')
            .find('[id="b00-adresse-ue"] .sous-bloc-form:not(.nouvelle-ligne) [name="no_civique"]')
            .addClass(CLASSE_CONTROLE_MODIFIE)
            .addClass(CLASSE_VALEUR_MODIFIEE);
    }
}

function ouvrir_modal_autre_docs(id) {
    var url = '/gestion-roles/' + $('#exp-ue-body-information').find('#id-ue').text() + '/autres-documents/';
    url = id ? url + id : url;
    var options = {
        id: "autre-documents-modal",
        view: "/core/modal/",
        processus_id: "",
        titre: id ? "Modifier document" : "Nouveau document",
        titre_supp: "",
        module: "",
        contenuHTML: "",
        template: "", //modal-inside-assigne-a.html
        template_view: url,
        template_depart: "",
        sans_x: false,
        template_depart_view: "",
        url: "",
        taille: "normal",
        resultat: "",
        resultat_depart: "",
        wizard: false,
        boutons: [{
                type: "cancel",
                label: "Annuler",
                    title: "",
                    classSupp: "",
                    afficher: true
                },
            {
                type: "save",
                label: "Sauvegarder",
                title: "",
                classSupp: "btn-primary",
                afficher: true,
                id: "btn-save-modal-autre-document",
                disabled: false,
            }
        ],
        date_evenement: new Date(moment().format('YYYY-MM-DD')).toJSON(),
        id_ue: $('#exp-ue-body-information').find('#id-ue').text()
    };
    setTimeout(function () {
        fenetreModal.creerModal(options, {}, [() => {
            $('#autre-documents-modal form input[type=file]').attr('multiple', true);
            $('#autre-documents-modal form input[type=file]').ace_file_input({
                no_file: 'Pas de fichier ...',
                btn_choose: 'Choisir',
                btn_change: 'Changer',
                droppable: true,
                onchange: null,
                thumbnail: false, //| true | large
                whitelist: 'gif|png|jpg|jpeg|zip|pdf'
            });
        }]);
    }, 0);
}

function initMapTerrainAgricoleBoise(idMunicipalite, matricule, dateEvenement) {

    var mapTerrainAgricoleBoise = null;
    var zoomToFeature = true;
    var idMap = 9;
    var bboxMunicipalite;
    getBboxMunicipalite(idMunicipalite, function (bbox) {
        bboxMunicipalite = bbox;
    });

    $('#map-terrain-agricole-boise-container').empty().append('<div id="lsidebar"></div><div id="map-controls-terrain" class="map-controls-container map-controls-container-alt"></div><div id="map-terrain-agricole-boise" class="leaflet-container-alt position-relative z-index-1" style="height:500px"> </div>');
    mapTerrainAgricoleBoise = new L.Map('map-terrain-agricole-boise', {
        center: new L.LatLng(45.5, -72.4),
        zoom: 16,
        maxZoom: 23
    });

    //17875
    mapTerrainAgricoleBoise.addLayer(googleStreets);

    var baseMaps = getBaseMap('carte_1');

    var overlays = [{}];
    var options = {
        container_width: "250px",
        group_maxHeight: "200px",
        container_maxHeight: "400px",
        exclusive: false
    };

    var control = L.Control.styledLayerControl(baseMaps, overlays, options);
    mapTerrainAgricoleBoise.addControl(control);
    $("#map-controls-terrain").append(control.getContainer());

    var urlGeoserver = $('#urlGeoserver').val();

    mapTerrainAgricoleBoise = mapTerrainAgricoleBoise.buildEvbMap({
        idMap: idMap,
        zoomToMapExtent: true,
        controlLayers: control,
        urlGeoserver: urlGeoserver,
        urlOrthosGeoserver: $('#urlOrthosGeoserver').val(),
        idMunicipalite: idMunicipalite,
        bbox: bboxMunicipalite,
        dateEvenement: dateEvenement,
        callback: function () {}
    });

    mapTerrainAgricoleBoise.whenReady(function () {
        init_layer_group_checkbox_and_layer_menu_styles();
    });

    function activerSelectFeature() {
        //Permet de selectionner une unité d'évaluation sur la carte
        mapTerrainAgricoleBoise.EnableSelectFeatureByAttribute({
            url: '/gestion-roles/tenue-a-jour/operation-ue/unite-evaluation.json/',
            zoomToFeature: true,
            idMunicipalite: idMunicipalite,
            dateEvenement: dateEvenement,
            callbackBeforeSelect: function () {},
                callback: function (properties) {
                if (properties.properties.error != 'pas_de_carte') {
                    ajouterSelectionCarte(mapTerrainAgricoleBoise, properties.geometry, properties);
                } else {
                    infos.ajouterMessageToast({
                        message: "Nous ne retrouvons pas les lots sur la matrice graphique ",
                        messageDuree: 5000,
                        messageCouleur: 'red'
                    });
                }
            }
        });
    }

    activerSelectFeature();

    var drawnItems = L.featureGroup().addTo(mapTerrainAgricoleBoise);
    mapTerrainAgricoleBoise.addControl(new L.Control.Draw({
        edit: {
            featureGroup: drawnItems,
            poly: {
                allowIntersection: false
            }
        },
        draw: {
            polygon: {
                allowIntersection: false,
                showArea: true,
                showLength: true
            },
            rectangle: false,
            circle: false,
            circlemarker: false
        }
    }));

    mapTerrainAgricoleBoise.on('draw:created', function (event) {
        var layer = event.layer;
        drawnItems.addLayer(layer);
    });

    setTimeout(function () {
        mapTerrainAgricoleBoise.selectFeatureByAttribute(matricule, true, zoomToFeature);

    }, 1000);

    $('#helpRepartitionSuperficieTotale').popover({
        html: true,
        trigger: 'click',
        placement: 'right',

        content: '<img src=' + urlGeoserver + '/evb/wms?request=GetLegendGraphic&amp;version=1.1.1&amp;layer=evb:v_peuplement_forestier_classifie&amp;styles=&amp;format=image/png&amp;transparent=true&amp;height=36&amp;width=36&amp;LEGEND_OPTIONS=fontColor:FFFFFF&quot;/>'
    });
}

function chargerinformationecoforestiere(params) {
    $('#exp-information-ecoforestiere').empty();

    $('#collapse-information-ecoforestiere').on('show.bs.collapse', function () {
        if ($('#exp-information-ecoforestiere').is(':empty')) {
            if (params.length <= 0) {
                idMunicipalite = $('#wizard').attr('id-municipalite');
                dateEvenement = $('#wizard').attr('date-evenement');
                params = {
                    "date_evenement": dateEvenement,
                    "id_ue": $('#wizard').attr('id-ue'),
                    "idMunicipalite": idMunicipalite,
                    'is_fiche_terrain': 'true'
                };
            } else {
                idMunicipalite = params['idMunicipalite'];
                dateEvenement = params['date_evenement'];
            }
            $.ajax({
                type: "GET",
                url: "/gestion-roles/tenue-a-jour/information-forestiere/",
                data: params,
                dataType: 'html',
                success: function (response) {
                    // charge les information dans l'accordeon evenement
                    $('#exp-information-ecoforestiere').html(response);
                    if ($("#matriculeTerrain").length != 0) {
                        var matricule = $('#matriculeTerrain').val().substring(0, 12);
                        if (matricule) {
                            initMapTerrainAgricoleBoise(idMunicipalite, matricule, dateEvenement);
                        }
                    }
                }
            });
        }
    });
}

function delete_doc(e, id) {
    e.preventDefault();
    e.stopPropagation();
    fenetreModal.modalMessage({
        enteteTitre: "Voulez-vous vraiment supprimer ce document?",
        texteExplicatif: "Les données seront détruites de façon permanente.",
        texteExplicatifIcone: "fa-exclamation-triangle orange vertical-align-middle",
        taille: "grande",
        boutons: {
            "Oui": {
                label: "Oui",
                id: "",
                class: "btn btn-success",
                action: function () {
                    var url = '/gestion-roles/' + $('#exp-ue-body-information').find('#id-ue').text() + '/autres-documents/' + id;
                    $.ajax({
                        url: url,
                        type: 'DELETE',
                        dataType: 'html',
                        async: true,
                        success: function (resp) {
                            fenetreModal.fermerModal('autre-documents-modal');
                            expUegetDocument($('#exp-ue-body-information').find('#id-ue').text());
                            infos.ajouterMessageToast({
                                message: resp,
                                messageDuree: 1000,
                                icone: 'fa-check-circle-o',
                                iconeCouleur: 'green'
                            });

                        }
                    });
                }
            },
            "Non": {
                label: "Non",
                id: "",
                class: "btn",
                action: function () {
                    fenetreModal.fermerModal('autre-documents-modal');
                }
            }
        }
    });
}


$('body').off('click').on('click', '#btn-save-modal-autre-document', (e) => {
    e.preventDefault();
    init_save_input_file('autre-documents-modal form', $('#autre-documents-modal form').attr('action'), (resp) => {
        fenetreModal.fermerModal('autre-documents-modal');
        infos.ajouterMessageToast({
            message: JSON.parse(resp).msg,
            messageDuree: 1000,
            icone: 'fa-check-circle-o',
            iconeCouleur: 'green'
        });
        expUegetDocument($('#exp-ue-body-information').find('#id-ue').text());
    }, (resp) => {
        infos.ajouterMessageToast({
            message: "Erreur lors de la soumission du formulaire",
            icone: 'fa-times-circle-o',
            messageDuree: 1000,
            iconeCouleur: 'red'
        });
        $('#autre-documents-modal form').html(resp);
        $('#autre-documents-modal form input[type=file]').ace_file_input({
            no_file: 'Pas de fichier ...',
            btn_choose: 'Choisir',
            btn_change: 'Changer',
            droppable: true,
            onchange: null,
            thumbnail: false, //| true | large
            whitelist: 'gif|png|jpg|jpeg|zip|pdf'
        });
    }, true, {
        'id_ue': $('#exp-ue-body-information').find('#id-ue').text()
    });
});


function blocCopierRow(fromRow, toRow) {
    fromRow.find('.form-control').each(function () {
        var fromControl = $(this);
        var toControl = toRow.find('.form-control[name="' + fromControl.attr('name') + '"]');
        blocCopierControl(fromControl, toControl);
    });
}

function blocCopierControl(fromControl, toControl) {
    var valeurs = getBlocControlValeurs(fromControl, toControl);
    var fromControlVal = valeurs[0];
    var toControlVal = valeurs[1];

    if (fromControlVal != toControlVal || toControl.is('.ace-input-file')) {
        if (toControl.is('input') && toControl.attr('type') == 'checkbox') {
            toControl.prop('checked', fromControl.prop('checked'));
            toControl.change();
        } else if (toControl.is('.ace-input-file')) {
            var fromAceFileName = fromControl.closest('.ace-file-input').find('.ace-file-container .ace-file-name');
            var toAceFileName = toControl.closest('.ace-file-input').find('.ace-file-container .ace-file-name');

            toAceFileName.attr('data-title', fromAceFileName.attr('data-title'));
            toAceFileName.find('i.ace-icon').attr('class', fromAceFileName.find('i.ace-icon').attr('class'));

            var fromBtnTelechargement = fromControl.closest('.sous-bloc-form').find('a.btn-telechargement');
            var toBtnTelechargement = toControl.closest('.sous-bloc-form').find('a.btn-telechargement');

            toBtnTelechargement.attr('href', fromBtnTelechargement.attr('href'));
            toBtnTelechargement.css('visibility', 'visible');

            var fromCbox = fromControl.closest('.sous-bloc-form').find('a.cboxElement,a.cboxElementVide');
            var toCbox = toControl.closest('.sous-bloc-form').find('a.cboxElement,a.cboxElementVide');

            if (toCbox.length > 0) {
                toCbox.replaceWith(fromCbox.clone());
            }

            toControl.val(fromControlVal);
            toControl.change();
        } else {
            // exception pour combobox occupant, où l'on prend des valeurs textuelles
            if (toControl.attr('name') == 'proprietaire') {
                var id = fromControl.attr('valeur-combobox');
                toControl.select2('data', {
                    id: id,
                    text: fromControlVal
                });
            }
            // exception pour les select2
            else if (toControl.is('.select2-container.geo-select, .fiche-select2-ajax, .select2-custom')) {
                toControl.select2('val', fromControlVal, true);
            } else {
                toControl.val(fromControlVal);
                toControl.change();
            }
        }
        copieMarquerModifie(toControl);
    }

    if (toControl.is('[name$="qualiteComplexite"]')) {
        var idComposante = toControl.closest('.qc').find('[id$="composante"]').val();
        // on obtient le no de ligne d'où le Q-C a été cliqué
        var noLigneFrom = fromControl.closest('.sous-bloc-form').attr('no-ligne');
        var noLigneTo = toControl.closest('.sous-bloc-form').attr('no-ligne');

        var reperesContainerFrom = getReperesContainer(fromControl);
        var reperesContainerTo = getReperesContainer(toControl);


        var accordionQcComposanteFrom = trouverAccordionRepere(reperesContainerFrom, idComposante, noLigneFrom, false);
        var accordionQcComposanteTo = trouverAccordionRepere(reperesContainerTo, idComposante, noLigneTo, false);

        accordionQcComposanteFrom.find('.sous-bloc-form').each(function (index) {
            var rowAvant = $(this);
            var rowApres = accordionQcComposanteTo.find('.sous-bloc-form:eq(' + index + ')');
            rowAvant.find('.cell-repere.click').each(function () {
                var cellAvant = $(this);
                var cellApres = rowApres.find('.cell-repere.click[id-repere="' + cellAvant.attr('id-repere') + '"]');
                if (cellAvant.hasClass('selected') != cellApres.hasClass('selected')) {
                    cellApres.click();
                }
            });
        });
    }
}

function getBlocControlValeur(control) {
    var val = control.val();

    if (control.closest('.container-select-multiple-input-multiple,.container-select-multiple').length > 0) {
        val = control.attr('selection-precedente');
    }

    return val;
}

// NB: retournera la valeur de controlAvant en tant que dans le bloc APRES
// Exemple, pour id_unite_voisinage, les pks peuvent différer à cause de l'historicité. Mais on retourne le pk du APRES même pour controlAvant
function getBlocControlValeurs(controlAvant, controlApres) {
    var valControlAvant = getBlocControlValeur(controlAvant);
    var valControlApres = getBlocControlValeur(controlApres);
    var option;

    if (controlApres.is('select') && controlAvant.is('input')) {
        valControlAvant = controlAvant.attr('valeur-combobox'); //  getSelectValeurFromTexte(controlApres, valControlAvant);
        var texteAvant;
        // exception rapide pour combobox unité de voisinage
        // de ne plus le copier dans le apres pour le tout remplacer
        // quand il n'y a pas d'instance dans le avant, c'est qu'on veut annuler les données pour annuler l'ue
        if ($.inArray(controlApres.attr('name'), ['uniteVoisinage', 'secteurTaxation', 'sousCategorieIR1', 'sousCategorieIR2', 'sousCategorieIR3', 'sousCategorieINR1', 'sousCategorieINR2', 'sousCategorieINR3']) != -1 &&
            controlAvant.closest('.blocForm').attr('id_model_instance') !== 'None') {
            texteAvant = controlAvant.val();

            // chercher pk selon texte
            option = controlApres.find('option').filter(function () {
                return ($(this).text().trim() == texteAvant.trim());
            });
            valControlAvant = option.val();
            if (valControlAvant != valControlApres)
                valControlApres = valControlAvant;
            return [valControlAvant, valControlApres];

        }

        // quand il n'y a pas d'instance dans le avant, c'est qu'on veut annuler les données pour annuler l'ue
        if (controlApres.attr('name') == 'secteur' &&
            controlAvant.closest('.blocForm').attr('id_model_instance') !== 'None') {
            valControlApres = '';
            valControlAvant = '';
            return [valControlAvant, valControlApres];

        }

        // exception rapide pour combobox b81EspaceLocatifNonresidentiel
        if (controlApres.attr('name') == 'b81EspaceLocatifNonresidentiel') {
            texteAvant = controlAvant.val();
            var listeTexteAvant = texteAvant.split('-');
            var codeAvant = (listeTexteAvant.length ? listeTexteAvant[0].trim() : '');

            // chercher pk selon texte
            option = controlApres.find('option').filter(function () {
                return ($(this).attr('code') == codeAvant);
            });
            valControlAvant = option.val();
        }

    }

    if (controlApres.is('input') && controlApres.closest('.input-select-multiple').length > 0) {
        var inputListeAssocie = controlApres.closest('.blocForm').find('.container-select-multiple-input-multiple').find('select[name="' + controlApres.attr('parent') + '"]');
        var optionCodes = inputListeAssocie.find('option').filter(function () {
            return ($(this).attr('code') && $(this).attr('code') != '');
        });
        if (optionCodes.length > 0) {
            option = optionCodes.filter(function () {
                return ($(this).attr('code') && $(this).attr('code') == controlAvant.val());
            });
            valControlAvant = option.val();

            option = optionCodes.filter(function () {
                return ($(this).attr('code') && $(this).attr('code') == controlApres.val());
            });
            valControlApres = option.val();
        }
    }

    if ($.inArray(controlApres.attr('name'), ['pourcentage_sous_categorie_ir_1', 'pourcentage_sous_categorie_ir_2', 'pourcentage_sous_categorie_ir_3', 'pourcentage_sous_categorie_inr_1', 'pourcentage_sous_categorie_inr_2', 'pourcentage_sous_categorie_inr_3']) != -1 &&
        controlAvant.closest('.blocForm').attr('id_model_instance') !== 'None') {
        valControlAvant = controlApres.val();
        if (valControlAvant != valControlApres)
            valControlApres = valControlAvant;
    }

    return [valControlAvant, valControlApres];
}

// DM: dans le bloc "avant" c'est un textbox alors que dans le "après" c'est un select...
function getSelectValeurFromTexte(select, texte) {
    // on suppose d'abord que le texte dans le "avant" correspond au Code
    var option = select.find('option').filter(function () {
        return ($(this).attr('code') == texte);
    });

    // sinon on suppose que ca correspond au Text de l'option (ex: bloc 72)
    if (option.length == 0) {
        option = select.find('option').filter(function () {
            return ($(this).text().trim() == texte);
        });
    }

    // sinon on suppose que ca correspond au Value de l'option (ex: bloc 63 - Remise)
    if (option.length == 0) {
        option = select.find('option').filter(function () {
            return ($(this).attr('value') == texte);
        });
    }

    if (option.length == 0) {
        return null;
    }

    return option.val();
}

function trouverRowIdentique(sousBlocApres, fromRow, matchsApres) {
    var rowRetour = null;

    sousBlocApres.find('.sous-bloc-form:not(.nouvelle-ligne)').each(function (idx) {
        var toRow = $(this);

        if ($.inArray(toRow[0], matchsApres) > -1) {
            return true; // continuer à l'itération suivante
        }


        var suppressionChecked = false;
        toRow.find('input.ctrl-suppression').each(function () {
            if ($(this).is(':checked')) {
                suppressionChecked = true;
            }
        });

        if (suppressionChecked) {
            return true;
        }

        if (toRow.find('.suppression-ligne').length > 0) {
            return true;
        }

        var rowCouranteIdentique = true;

        var listeControlVerifier = fromRow.find('.form-control');

        // dans le cas du b81-espace-locatif-nonresidentiel, considérer les lignes équivalentes en comparant seulement le champ identifiant_espace
        if (fromRow.closest('.champs-multiple[id=b81-espace-locatif-nonresidentiel]').length) {
            listeControlVerifier = listeControlVerifier.filter('[name=identifiant_espace]');
        }

        listeControlVerifier.each(function () {
            var fromControl = $(this);
            var toControl = toRow.find('.form-control[name="' + fromControl.attr('name') + '"]');

            var valeurs = getBlocControlValeurs(fromControl, toControl);
            var fromControlVal = valeurs[0];
            var toControlVal = valeurs[1];

            if (fromControlVal != toControlVal) {
                rowCouranteIdentique = false;
                return false;
            }
        });

        if (rowCouranteIdentique) {
            rowRetour = toRow;
            return false;
        }
    });

    return rowRetour;
}

function ouvrirDialogue(contenuDialogue) {
    contenuDialogue
        .parent().css({
            position: "fixed"
        }).end()
        .dialog('option', 'position', {
            my: 'top',
            at: 'bottom',
            of: '#entete-fixe'
        }) // on positionne le dialogue toujours en haut et en-dessous des liens des blocs
        .dialog('open')
        .css('width', 'inherit'); // corrige un problème du dialog : le dialogue met le width à auto sur le div reperes
    // et donc, le contenu ne prend pas toute la largeur du dialogue
}

function selectMultipleClicked(original_select) {
    // sélectionner/désélectionner dans un sélecteur simple
    if (original_select.is('li')) {
        var select = original_select.closest('ul');
        select.attr('value', original_select.attr('code') ? original_select.attr('code') : original_select.attr('value'));
    } else {
        var select = original_select;
    }


    // sur un poste, le 'change' vient avant le 'click'. Le 'change' et/ou le 'click' servent à ajouter une sélection et le 'click' sert également pour désélectionner quand il y une seule sélection
    // sur une tablette, le 'click' vient avant le 'change', donc, on pourrait garder que le 'change'. La liste n'est pas affichée comme sur le poste, il faut d'abord toucher pour l'ouvrir et ensuite, sélectionner
    // gardons seulement le 'click' sur le poste pour le moment. Cherchons une solution pour la tablette essayée iPad (si demandée).

    var inputAssocie = getInputSelectSimple(select);
    var selectedElement = null;
    // on vérifie si la sélection précédente est égale à la sélection actuelle
    if ((select.attr('value') == original_select.attr('value') && inputAssocie.val() == original_select.attr('value')) || (select.attr('value') == original_select.attr('code') && inputAssocie.val() == original_select.attr('code'))) {

        if (select.is('ul')) {
            // on vérifie si la sélection précédente est égale à la sélection actuelle
            if ((select.attr('value') == original_select.attr('code')) || (select.attr('value') == original_select.attr('value'))) {
                // on désélectionne et on enlève la valeur dans le input associé
                select.find('li.selected').removeClass('bg-grey');
                select.find('li.selected').removeClass('selected');
                select.attr('value', "");
            }
        } else {
            // on désélectionne et on enlève la valeur dans le input associé
            select.prop('options')[select.prop('selectedIndex')].selected = false;
        }
        // enlever la valeur du input associé
        if (inputAssocie.length > 0) {
            inputAssocie.val('');
        }
    } else {

        // s'il existe d'autres colonnes pour ce sélecteur, on enlève les sélections de ces autres sélecteurs
        var ctrlSelects = select.closest('.container-select-multiple').find('select.form-control').not(select);
        if (ctrlSelects.length > 0) {
            $.each(ctrlSelects, function (key, select) {
                $(select).val('');
            });
        }
        if (select.is('ul')) {
            var code = original_select.attr('code') ? original_select.attr('code') : original_select.attr('value');
            if (code != undefined) {
                inputAssocie.val(code);

            }
        } else {
            // mettre la valeur de la sélection dans le input associé
            if (inputAssocie.length > 0) {
                var option = $(select[0].options[select[0].selectedIndex]);
                // si un attribut 'code' existe pour cette option, on affiche cette valeur dans le input
                var code = option.attr('code');
                if (code != undefined) {
                    inputAssocie.val(code);
                } else {
                    inputAssocie.val(option.val());
                }
            }
        }
    }


    // appliquer le changement après que le sélecteur a été modifié
    appliquerChangement(select);

    // garder la valeur actuelle pour la prochaine fois
    var valeurSelect = select.val();
    if (valeurSelect == []) {
        select.attr('selection-precedente', original_select.attr('value'));
        valeurSelect = select.attr('value');
    }
    select.attr('selection-precedente', valeurSelect != null ? valeurSelect : '');
}

function getInputSelectSimple(select) {

    var ctrlInput = null;
    // si le contrôle est un select, utiliser plutôt le input associé
    if (select.is('.container-select-multiple ul.form-control')) {
        ctrlInput = select.closest('.bloc-container').find('.input-select-multiple input[parent="' + select.attr('data-js') + '"]');
        if (ctrlInput.length > 0) {
            return ctrlInput;
        } else if (select.is('.container-select-multiple li.form-control')) {
            return select.data('js');
        }
    }
    if (select.is('.container-select-multiple select.form-control')) {
        ctrlInput = select.closest('.bloc-container').find('.input-select-multiple input[parent="' + select.attr('name') + '"]');
        if (ctrlInput.length > 0) {
            return ctrlInput;
        }
    }
    return ctrlInput;
}

function selectMultipleInputMultipleClicked(select, event) {
    var original_select = $(select);
    if ($(original_select).is('option')) {
        select = $(select).parents('select');
    } else if ($(original_select).is('li')) {
        select = $(select).parents('ul');
    }
    // sélectionner/désélectionner dans un sélecteur multiple

    // sur un poste, le 'change' vient avant le 'click'. Le 'change' et/ou le 'click' servent à ajouter une sélection et le 'click' sert également pour désélectionner quand il y une seule sélection
    // sur une tablette(iPad), le 'click' vient avant le 'change', donc, on pourrait garder que le 'change'. La liste n'est pas affichée comme sur le poste, il faut d'abord toucher pour l'ouvrir et ensuite, sélectionner
    // gardons seulement le 'click' sur le poste pour le moment. Cherchons une solution pour la tablette essayée iPad (si demandée).

    var modeWizard = ($('#wizard').length > 0);

    // selection-none : sert au sélecteur dans lequel on peut choisir la même sélection plusieurs fois et on doit grisée les sélections choisies
    var selectionAffichee;
    if (select.is('ul')) {
        selectionAffichee = !select.closest("ul").hasAttr('selection-none');
    }
    else {
        selectionAffichee = !select.hasAttr('selection-none');
    }

    // si la sélection doit être affiché
    if (selectionAffichee) {

        // on affiche toutes les sélections dans le sélecteur
        // on garde l'information du sélecteur courant pour la prochaine sélection

        // convertir la valeur précédente dans un array pour faire les manipulations

        var selectionPrecedente = select.attr('selection-precedente');
        var selectionPrecedenteArray = selectionPrecedente != undefined && selectionPrecedente != '' ? selectionPrecedente.split(',') : [];

        var valeurSelectionne = '';
        // vérifier si la touche CTRL est pressée
        if (event.ctrlKey) {
            valeurSelectionne = comparerDeuxArrays(selectionPrecedenteArray, select.val(), true)[0];
        } else {
            var element_option_clicked_index;
            if ($(original_select).is('option')) {
                element_option_clicked_index = event.currentTarget.index;
            } else if ($(original_select).is('li')) {
                element_option_clicked_index = event.currentTarget.dataset.index;
            } else {
                // c'est un select
                element_option_clicked_index = event.currentTarget.options.selectedIndex;
            }
            if ($(original_select).is('li')) {
                valeurSelectionne = event.currentTarget.dataset.js;
            } else {
                valeurSelectionne = $(select.prop('options')[element_option_clicked_index]).val();
            }
        }

        // chercher la sélection dans la valeur précédente
        var indexSelection = selectionPrecedenteArray.indexOf(valeurSelectionne);
        if (indexSelection == -1) {
            // si pas trouvé, on l'ajoute à la valeur précédente
            selectionPrecedenteArray.push(valeurSelectionne);
            selectionPrecedenteArray.sort();
        } else {
            // si trouvé, on l'enlève de la valeur précédente
            selectionPrecedenteArray.splice(indexSelection, 1);
        }

        // mettre la 'nouvelle' valeur dans le sélecteur
        select.val(selectionPrecedenteArray);

        // garder la valeur actuelle dans l'attribut du select
        select.attr('selection-precedente', selectionPrecedenteArray != null ? selectionPrecedenteArray : '');
    }

    // créer les inputs selon les sélections
    // avoir un dict des statuts des options du select
    var options = $(original_select).is('li') ? select.find('li.option') : select.find('option');

    // pour les services disponibles dans le terrain général
    if (select.attr('name') == 'type_service_tg_liste') {
        // selon le service 08, sélectionner ou pas les services 05 et 07 qui sont disponibles dans b72 et b04
        var selectionB72 = options.filter('[selection-b04-b72="True"]');
        var service08EstSelectionne = selectionPrecedenteArray.includes('08');

        $.each(selectionB72, function () {
            var service = $(this);
            let serviceVal;
            service.attr('disabled', false);
            if ($(original_select).is('li')) {
                service.toggleClass('bg-grey', !service08EstSelectionne)
                serviceVal = service.data('js');
            } else {
                service.prop('selected', !service08EstSelectionne)
                serviceVal = service.val();
            }
            service.attr('disabled', true);
            var index = $.inArray(serviceVal, selectionPrecedenteArray);
            if (service08EstSelectionne) {
                if (index != -1) {
                    selectionPrecedenteArray.splice(index, 1);
                }
            } else {
                if (index == -1) {
                    selectionPrecedenteArray.push(serviceVal);
                }
            }
        });

        if (selectionAffichee) {
            // mettre la 'nouvelle' valeur dans le sélecteur
            select.val(selectionPrecedenteArray);

            // garder la valeur actuelle dans l'attribut du select
            select.attr('selection-precedente', selectionPrecedenteArray != null ? selectionPrecedenteArray : '');
        }

        // pour l'étape de Terrain
        var idEtapeProcessus = 18;
        var pageCourante = $($('.steps li[data-id_processus=' + idEtapeProcessus + ']').data('target'));
        var containerTypeServiceTg = pageCourante.find('[name="div-dest"] #b04-terrain-general [name="type_service_tg_liste"]').parent();
        validerTypeServiceTG(containerTypeServiceTg);

    }

    var dictInputs = {};
    if (select.is('select')) {
        $.each(options, function (index, option) {

            // si on a forcé l'affichage des sélections sur ce sélecteur, on enlève cette affichage de sélection
            if (!selectionAffichee) {
                option.defaultSelected = false;
            }

            var etaitSelected = false;
            if (selectionAffichee) {
                var selectionPrecedenteArray = selectionPrecedente != undefined && selectionPrecedente != '' ? selectionPrecedente.split(',') : [];
                etaitSelected = ($.inArray(option.value, selectionPrecedenteArray) > -1);
            }

            var statutOption = OPTION_STATUT.aucun;
            // chercher seulement les inputs qui sont sélectionnées ou qui étaient sélectionnées à l'origine
            if (option.selected || /*option.defaultSelected*/ etaitSelected) {
                if (option.selected && /*!option.defaultSelected*/ !etaitSelected) {
                    statutOption = OPTION_STATUT.ajout;
                    // #12493: Force le 'selected'...comportement spécial d'un select en mode multiple
                    $(option).prop('selected', 'selected');
                } else if (!option.selected && /*option.defaultSelected*/ etaitSelected) {
                    statutOption = OPTION_STATUT.suppresssion;
                    // #12493: Force le 'deselected'
                    $(option).prop('selected', '');
                }

                var code = $(option).attr('code');
                // si un attribut 'code' existe pour cette option, on affiche cette valeur dans le input
                if (code != undefined) {
                    dictInputs[code] = statutOption;
                } else {
                    dictInputs[$(option).val()] = statutOption;
                }
            }

        });
    } else if (select.is('ul')) {
        dictInputs = getDictSelectListMultipleInput(select, original_select, selectionAffichee, options);
    }

    // mettre en ordre ascendant de valeur des options
    var valeursOption = Object.keys(dictInputs);
    valeursOption.sort();

    // si la sélection ne doit pas être affiché
    if (!selectionAffichee) {
        // ne pas voir la sélection
        select.val('');
    }

    // garder l'information du parent sur le input à chercher
    if (select.is('ul')) {
        var inputRecherche = 'input[parent=' + select.closest('ul').data('js') + ']';
    } else {
        var inputRecherche = 'input[parent=' + select.attr('name') + ']' + '.form-control';
    }
    // garder la liste des lignes actuelles
    var containerLignes = select.closest('.bloc-container').find('.champs-multiple .sous-bloc-form .input-select-multiple ' + inputRecherche).closest('.champs-multiple .sous-bloc-form');
    var inputVideDerniereLigne = false;

    // pour chaque option, afficher le input selon son statut
    for (var i = 0; i < valeursOption.length; i++) {
        var valeurOption = valeursOption[i];
        var statutOption = dictInputs[valeurOption];

        var containerInputs = select.closest('.bloc-container').find('.champs-multiple .sous-bloc-form .input-select-multiple ' + inputRecherche);
        var inputTrouve = containerInputs.filter('[value="' + valeurOption + '"]');

        if (statutOption == OPTION_STATUT.suppresssion) {
            // parcourir les lignes correspondant à la valeur et les supprimer
            inputTrouve.each(function (index, ligne) {
                var $ligne = $(ligne);
                var containerLigne = $ligne.closest('.champs-multiple .sous-bloc-form');
                var id = containerLigne.attr('id-model-instance');
                var containerInputsRestant = select.closest('.bloc-container').find('.champs-multiple .sous-bloc-form .input-select-multiple ' + inputRecherche);

                if (id == 'None' || id == '') { // si la ligne n'est pas enregistrée dans la BD
                    // ajouter une ligne vide si on va se retrouver sans lignes
                    if (containerInputsRestant.length == 1) {
                        ajouterNouvelleLigneSectionMultiple(containerLigne, false, true);
                    }

                    containerLigne.remove();
                } else {
                    var listeDiv = getDivSuppression(containerLigne);
                    listeDiv.addClass(CLASSE_SUPPRESSION_LIGNE);
                }
            });
        }
        if (selectionAffichee == false && !inputTrouve.parent().hasClass('suppression-ligne')) {
            inputTrouve = [];
        }
        if (statutOption == OPTION_STATUT.ajout) {

            if (inputTrouve.length > 0) { // si mode valeur unique et que la valeur est déjà présente dans le sous bloc (donc il devrait être barré)
                var containerLigne = inputTrouve.first().closest('.champs-multiple .sous-bloc-form');
                var listeDiv = getDivSuppression(containerLigne);
                listeDiv.removeClass(CLASSE_SUPPRESSION_LIGNE).removeClass(CLASSE_SUPPRESSION_LIGNE_SAUVEGARDEE);

                marquerChangement(containerLigne.find(inputRecherche));
            } else {
                // on tente de trouver une ligne dont la valeur n'est pas remplie, pour lui affecter
                var ligneValeurVide = containerInputs.filter(function () {
                    return !this.value;
                }).first().closest('.sous-bloc-form .input-select-multiple');

                if (ligneValeurVide.length > 0) { // si une ligne à valeur vide est trouvée, simplement lui affecter la valeur à ajouter
                    ligneValeurVide.find(inputRecherche).val(valeurOption).attr('value', valeurOption);
                    ligneValeurVide.closest('.sous-bloc-form').find('.ctrl-suppression').prop('disabled', false);

                    // exception pour b04-topographie TG : s'il y a une seule ligne, mettre le pourcentage à 100 par défaut
                    if (ligneValeurVide.closest('#b04-topographie').find('.sous-bloc-form').length == 1) {
                        ligneValeurVide.closest('.sous-bloc-form').find('[name="pourcentage"]').val(100);
                    }

                    var ctrlInput = ligneValeurVide.closest('.sous-bloc-form').find(':input.form-control').not('input[type=hidden].form-control');
                    ctrlInput.not('.input-disabled, [name$="qualiteComplexite"]').attr('disabled', false);

                    marquerChangement(ligneValeurVide.find(inputRecherche));
                } else { // sinon on ajoute une nouvelle ligne
                    var inputDerniereLigne = containerInputs.last();

                    // créer une nouvelle ligne avec la ligne précédente
                    var nouvelleLigne = ajouterNouvelleLigneSectionMultiple(inputDerniereLigne, false, true);
                    // mettre la valeur dans le input de la 'nouvelle ligne' et dans l'attribut value
                    nouvelleLigne.find(inputRecherche).val(valeurOption).attr('value', valeurOption);

                    // s'il y a un qc imbriqué dans la nouvelle ligne et que la ligne précédente est en suppression, on remet le disabled sur chaque input
                    var nouvelleLigneAvecQc = nouvelleLigne.find('.row.qc');
                    if (inputDerniereLigne.closest('.sous-bloc-form').find('.suppression-ligne').length && nouvelleLigneAvecQc.length) {
                        // on toggle sur le disabled des contrôles du qc
                        nouvelleLigneAvecQc.find('[name^="qualiteComplexiteXBatiment."]').attr('disabled', function (index, valeur) {
                            return !valeur;
                        });
                        nouvelleLigne.attr('methode', function (index, valeur) {
                            return nouvelleLigne.attr('id-model-instance') == 'None' ? 'POST' : 'PATCH';
                        });
                    }

                    // exception pour b04-topographie TG : s'il y a une seule ligne, en ne comptant pas les lignes supprimées, mettre le pourcentage à 100 par défaut
                    var lignesSupprimees = nouvelleLigne.closest('#b04-topographie').find('.suppression-ligne').closest('.sous-bloc-form');
                    if (nouvelleLigne.closest('#b04-topographie').find('.sous-bloc-form').not(lignesSupprimees).length == 1) {
                        nouvelleLigne.find('[name="pourcentage"]').val(100);
                    }

                    marquerChangement(nouvelleLigne.find(inputRecherche));
                }
            }
        }

    }

    // redéfinir les numéros de ligne pour chaque ligne de sous-bloc après que les anciennes lignes ont été supprimées
    containerLignes = select.closest('.bloc-container').find('.champs-multiple .sous-bloc-form .input-select-multiple ' + inputRecherche).closest('.champs-multiple');
    assignerNoLigneSousBloc(containerLignes);
    // mettre a jour les numéros de ligne des repères en fonction des lignes de sous-blocs
    if (!modeWizard) {
        var reperesContainer = getReperesContainer(select);
        assignerNoLigneReperes(reperesContainer);
    }

    cacherReperesSurSuppression(containerLignes);

    nettoyerResultatsQcb15(select);

    // si on utilise l'évènement 'change', il faut ajouter ces lignes pour ne pas appeler 2 fois le code précédent
    if (event.type == 'change') {
        select.off('click');
    }

    if (!selectionAffichee) {
        var bloc = select.closest('.blocForm');
        initSelecteurMultiple(bloc, false);
    }
}

function initIntegerSpinnerContainer(container) {
    $(container).find('.integer-spinner').each(function () {
        initIntegerSpinner($(this));
    });

}

function initIntegerSpinner(controle) {

    // attention : mettre l'option hold=false empêche d'être notifier du changement sur le input
    var aceSpinnerAttributs = {
        on_sides: true,
        touch_spinner: true,
        icon_up: 'fa fa-plus smaller-75',
        icon_down: 'fa fa-minus smaller-75',
        btn_up_class: 'btn-light',
        btn_down_class: 'btn-light'
    };

    if (controle.attr('min-spinner') != undefined) {
        aceSpinnerAttributs['min'] = parseInt(controle.attr('min-spinner'));
    } else {
        aceSpinnerAttributs['min'] = 0;
    }
    if (controle.attr('max-spinner') != undefined) {
        // attention: le "max" change la longueur du input("maxlength")
        aceSpinnerAttributs['max'] = parseInt(controle.attr('max-spinner'));
    }
    if (controle.attr('step-spinner') != undefined) {
        aceSpinnerAttributs['step'] = parseInt(controle.attr('step-spinner'));
    }
    if (controle.attr('disabled') != undefined) {
        controle.attr('disabled', true);
    }
    if (controle.val() == '') {
        aceSpinnerAttributs['value'] = '';
    }

    controle.ace_spinner(aceSpinnerAttributs);


    // arrêter la roulette de la souris sur le spinner
    controle.off('mousewheel.spinner DOMMouseScroll.spinner');

    // forcer la saisie d'entier seulement (fix de l'API fuelux.spinner car celui-ci laissait passer le point)
    controle.on('keyup', function () {
        var val = $(this).val();
        $(this).val(val.replace(/[^0-9]/g, '') || '');
    });

    // si on clique sur le +/- d'un ace-spinner, qu'il n'y a pas de valeur et que c'est une année, mettre l'année de l'évènement
    var spinnerButtons = controle.closest('.ace-spinner').find('.spinner-buttons.input-group-btn');
    $(spinnerButtons).on('click', function () {
        var ctrl = $(this);

        var dateEvenement = $('#date-evenement').val();
        var annee = new Date(dateEvenement).getFullYear();
        var container = ctrl.closest('.ace-spinner');
        var inputAssocie = container.find('.integer-spinner');
        if (inputAssocie.hasClass('annee-spinner') &&
            (inputAssocie.val() == 1 || inputAssocie.val() == '')) {
            $(inputAssocie).ace_spinner('value', annee);
        } else if (inputAssocie.hasClass('pourcentage-spinner') &&
            (inputAssocie.val() == '' || inputAssocie.val() == 0) || !inputAssocie.val()) {
            $(inputAssocie).ace_spinner('value', 100);
        }
    });

    // pour la fiche non-résidentiel, on modifie la largueur des spinner
    var idFormulaire = $('#current-id-formulaire').val();
    var aceSpinners;
    if (idFormulaire == '7') {
        aceSpinners = controle.closest('.ace-spinner');
        $.each(aceSpinners, function () {
            var ctrl = $(this);
            var maxLength = ctrl.find('.integer-spinner').attr('maxlength');
            var width = 55 + maxLength * 10; // ça semble fonctionner pas pire avec 10px par caractère
            ctrl.css('width', width + 'px');
        });
    }

    // pour enlever les btn du ace-spinner et ajuster la largeur
    aceSpinners = controle.closest('.ace-spinner');
    $.each(aceSpinners, function () {
        var ctrl = $(this);
        var noSpinner = ctrl.find('.no-spinner');
        if (noSpinner.length > 0) {
            var btnSpinner = ctrl.find('.spinner-buttons');
            if (btnSpinner != undefined) {
                btnSpinner.remove();
            }
            var maxLength = ctrl.find('.integer-spinner').attr('maxlength');
            var width = 25 + maxLength * 10; // ça semble fonctionner pas pire avec 10px par caractère
            ctrl.css('width', width + 'px');
        }
    });
}

function resetIntegerSpinner(nouvelleLigne) {

    // pour les inputs +/-, il faut enlever leur data et les réinitialiser
    // (le clone garde des liens avec les +/- de chaque côté du contrôle qui faisait en sorte de modifier le contrôle original et non le contrôle copié)
    var integerSpinners = $(nouvelleLigne).find('.integer-spinner');
    $.each(integerSpinners, function () {
        var ctrl = $(this);
        // enlever les données sur le input
        ctrl.removeData('ace_spinner');
        // déplacer le input après le div du ace-spinner et enlever le ace-spinner
        ctrl.closest('.ace-spinner').after(ctrl).remove();
        // réinitialiser le ace-spinner sur le input
        initIntegerSpinner(ctrl);
    });
}

function destroyIntegerSpinner(nouvelleLigne) {
    // pour les inputs +/-, il faut enlever leur data et les réinitialiser
    // (le clone garde des liens avec les +/- de chaque côté du contrôle qui faisait en sorte de modifier le contrôle original et non le contrôle copié)
    var integerSpinners = $(nouvelleLigne).find('.integer-spinner');
    $.each(integerSpinners, function () {
        var ctrl = $(this);
        // enlever les données sur le input
        ctrl.removeData('ace_spinner');
        // déplacer le input après le div du ace-spinner et enlever le ace-spinner
        ctrl.closest('.ace-spinner').after(ctrl).remove();
    });

}


function initChampsMultiple(champsMultiple) {

    // on met disabled le checkbox de suppression pour chaque ligne vide d'un sous-bloc
    var ligneVide = champsMultiple.find('.sous-bloc-form').last();
    if (ligneVide.length == 1 && ligneEstSansDonnee(ligneVide)) {
        disableControleSuppression(ligneVide, true);
    }

    deleteLigneVideSiAutoNumberMax(champsMultiple);

    // on met un no de ligne pour chaque ligne de sous-bloc
    assignerNoLigneSousBloc(champsMultiple);
}


function deleteLigneVideSiAutoNumberMax(champsMultiple) {
    var ctrl = champsMultiple.find('.input-auto-number');
    if (ctrl.length > 0) {
        var min = $(ctrl).closest('.champs-multiple').attr("data-min");
        var max = $(ctrl).closest('.champs-multiple').attr("data-max");
        var limit = (Number(max) + 1 - Number(min));

        if (ctrl.length > limit) {
            var ligneVide = champsMultiple.find('.sous-bloc-form').last();
            ligneVide.remove();
        }
    }
}


/**
 * Ajouter une ligne contenant un input file à un sous-bloc.
 * @param {jQuery selector} input - Selecteur jQuery pointant le input file de la ligne à ajouter.
 * @param {File} fichier - Fichier ayant été sélectionné par l'utilisateur et dont on veut attacher au input file.
 */
function ajouterFichierManuellement(input, fichier) {

    // On stocke le fichier dans notre propre propriété du input afin de pouvoir le récupérer lors de la sauvegarde
    // Note: La sécurité nous empêche de venir stocker le fichier dans le value donc c'est pourquoi on le stocke ailleur
    input.prop('fichier', {
        files: fichier
    });

    // On force le event change une fois le fichier ajouté par programmation pour forcer la création de la nouvelle ligne
    input.trigger('change');
}

// #20802 #22363 : Active ou désactive les champs de résultats de guides de calculs
function init_guides_calcul(id_bloc, nom_champ_valeur, nom_champ_guide_calcul) {
    function mecanique_guide_calcul(nom_champ_valeur, champ_checkbox_guide_calcul) {
        let ligne = $(champ_checkbox_guide_calcul).parents('.row')[0];
        let champ_valeur = $(ligne).find('[name="' + nom_champ_valeur + '"]');
        if ($(champ_checkbox_guide_calcul).is(':checked')) {
            $(champ_valeur).attr('disabled', 'disabled');
            $(champ_valeur).parent('div').find('button').attr('disabled', 'disabled');
        } else {
            $(champ_valeur).removeAttr('disabled');
            $(champ_valeur).parent('div').find('button').removeAttr('disabled');
        }
    }

    let champs_checkbox_guide_calcul_du_bloc = $('#' + id_bloc + ' [name=' + nom_champ_guide_calcul + ']');
    // Pour les clicks des checbox de guides de calculs
    $(champs_checkbox_guide_calcul_du_bloc).off('click').on('click', function (e) {
        let champ_checkbox_guide_calcul = e.originalEvent.target;
        mecanique_guide_calcul(nom_champ_valeur, champ_checkbox_guide_calcul);
    });
    // Pour l'initialisation au chargement de la fiche
    $(champs_checkbox_guide_calcul_du_bloc).each(function (idx, champ_checkbox_guide_calcul) {
        mecanique_guide_calcul(nom_champ_valeur, champ_checkbox_guide_calcul);
    });

}

// le guide de calcul 2 du bloc 21 dispose d'une section supplémentaire "utilisation du batiment"
function init_guide_calcul_b21_2() {
    // pour afficher (ou cacher) la section si la case de guide de calcul est activée
    function mecanique_case_calcul_auto_b21_2() {
        // on commence par cacher la section d'aide au cacul.
        $('#guide-calcul-b21-2-utilisation-batiment').hide();
        $('#b21-acier-etagee [name="calcul_quantite_auto"]').each(function (i, case_calcul_auto_b21_2) {
            if ($(case_calcul_auto_b21_2).is(':checked')) {
                $('#guide-calcul-b21-2-utilisation-batiment').show();
                // on s'arrête au premier cas trouvé
            }
        });
    }

    mecanique_case_calcul_auto_b21_2();
    $('#b21-acier-etagee [name="calcul_quantite_auto"]').on('change', function () {
        mecanique_case_calcul_auto_b21_2();
    });

    function occupation_serialize_ligne(ligne) {
        let data_tableoccupation = $(ligne).find('input').serialize();
        let data_tableoccupation_extras = $(ligne).parents('table').find('thead input').serialize();
        // valeur + forcer un change sur le hidden input car non existant par défaut pour ce type input
        $($('[name="calcul_utilisation_batiment"]')[$(ligne).data('ligne_no')]).val(data_tableoccupation + '&' + data_tableoccupation_extras).trigger('change');
    }

    // pour ajouter un event listener par ligne de la section
    function ligne_occupation_add_change_listener(ligne) {
        // Pour chaque ligne de l'aide au calcul, on vient synchroniser le hidden input correspondant
        $(ligne).find('input').off('change').on('change', function (e) {
            occupation_serialize_ligne(ligne);
        });
    }

    // Et l'event listener des champs extras du header
    $('#tableoccupation').find('thead input').off('change').on('change', function (e) {
        // on doit aller chercher chaque ligne dans ce cas des headers
        $('#tableoccupation').each(function (i, ligne) {
            occupation_serialize_ligne(ligne);
        });
    });

    function ajout_nouvelle_ligne_occupation() {
        let ligne_occupation = $('#tableoccupation #lignevide').clone();
        ligne_occupation.attr('id', '');
        let ligne_no = $('#tableoccupation tbody tr:not(#lignevide)').length;
        ligne_occupation.data('ligne_no', ligne_no);
        ligne_occupation.appendTo('#tableoccupation tbody');
        ligne_occupation.show();
        ligne_occupation_add_change_listener(ligne_occupation);
        return ligne_occupation;
    }

    // Déserialisation / Création des lignes de la section occupation en fonction des b21
    // On supprime en premier les lignes existantes (utile lors du retour de sauvegarde de fiche)
    $('#tableoccupation tbody tr:not(#lignevide)').remove();
    $('#b21-acier-etagee [name="calcul_utilisation_batiment"]').each(function (i, ligne_utilisation_batiment) {
        var ligne_occupation = ajout_nouvelle_ligne_occupation();
        // val_utilisation_batiment json contient les valeurs de chaque champ pour tableoccupation
        let val_utilisation_batiment = $(ligne_utilisation_batiment).val();
        if (val_utilisation_batiment && val_utilisation_batiment != null) {
            var val_utilisation_batiment_json = JSON.parse(val_utilisation_batiment);
            if (val_utilisation_batiment_json) {
                $.map(val_utilisation_batiment_json, function (val, n) {
                    $(ligne_occupation).find('[name="' + n + '"]').val(val);
                    // et les extras dans le header
                    let champ_header = $(ligne_occupation).parents('table').find('thead input[name="' + n + '"]');
                    if (val && !$(champ_header).val()) {
                        $(champ_header).val(val);
                    }
                });
            }
        }
    });

    // suivi dynamique des ajouts de lignes b21 pour créer au fur et à mesurer les lignes occupations correspondantes
    var observer = new MutationObserver(function (mutations) {
                mutations.forEach(function (mutation) {
            for (var i = 0; i < mutation.addedNodes.length; i++) {
                // pour limiter le nombre de ligne ajoutées (car le dom est remanipulé également lorsq'on à des erreurs au save)
                if ($('#b21-acier-etagee .row .sous-bloc-form').length > $('#tableoccupation tbody tr:not(#lignevide)').length) {
                    ajout_nouvelle_ligne_occupation();
                }
            }
        });
    });
    let bloc_21 = $('#b21-acier-etagee')[0];
    if (bloc_21) {
        observer.observe(bloc_21, {
            childList: true,
            subtree: true
        });
    }
}

var modeErreur = false;

function offlineMode(idBatiment, idTypeBatiment, idEvenement, dateEvenement, idFormulaire, idBloc, callback) {
    var startTime = new Date();
    var modeWizard = ($('#wizard').length > 0);
    modeErreur = true;
    initBlocsCharges(idFormulaire, idBloc);
    modalReperesLoaded();
    fenetreModal.clique('modal-reperes');
    fenetreModal.escape('modal-reperes');

    if (typeof (callback) != 'undefined') {
        callback();
    }

    if (modeWizard) {
        wait.stop();
        return;
    }

    var blocsContainer;
    if (!modeWizard) {
        blocsContainer = $('#blocs-container');
    } else {
        blocsContainer = $('.step-pane.active');
    }

    // ajouter un slimScroll dans les agrandissements seulement s'il y a suffisament d'agrandissements
    ajouterSlimScrollEF($('#b08-agrandissement'), 150);
    $('#b08-agrandissement').attr('hauteur-originale', 400);


    // Initialisation spécifique au bloc 05 et 06 (documents)
    var b05Documents = $('[id^="b05-document"]');
    var b06Documents = $('[id^="b06-document"]');
    var b90Documents = $('#b90-document');

    // On ajoute un slimScroll dans les documents seulement s'il y a suffisament de documents
    ajouterSlimScrollEF(b05Documents, 400, true);
    b05Documents.attr('hauteur-originale', 400);
    if ($('#mode-read-only').val() === 'False') {
        rendreChampMultipleOrdonnable(b05Documents, "#form-ordre");
    }
    ajouterSlimScrollEF(b90Documents, 400);
    b90Documents.attr('hauteur-originale', 400);

    if (typeof camera !== 'undefined') {
        camera.initialiserClickCamera();
    }

    ajusterTailleImage($('[id^="b05-photo"] #photo-principale'), '625px', '500px');
    ajusterTailleImage($('[id^="b06-croquis"] #photo-principale'), '625px', '500px');

    // On ajuste la taille de chacune des images pour s'assurer qu'elles occupent toujours le même espace sans les déformer.
    ajusterTailleImage(b05Documents.find('img'), '100px', '80px');
    initAceThumbnails('colorboxDoc1');
    // Ajout de la description photo

    $.each(b05Documents.find('a'), function (idx, obj) {

        var a = $(obj)[0];
        var description = $(a).closest('.sous-bloc-form').find('#form-description').val();

        $(a).attr('title', description);

    });


    ajusterTailleImage(b06Documents.find('img'), '100px', '80px');
    initAceThumbnails('colorboxDoc2');

    //Bouton pour ouvrir le detail du coût
    $('.btn-cout').off('click').on('click', function () {
        blocCoutClicked($(this));
    });

    // #18249: historicité des blocs callback click/ouverture icone historique pour afficher la sélection des évènements
    $('.btn-historik-blocx').parent().on('show.bs.dropdown', function (e) {
        // on affiche la liste de sélection d'évènements dans le dropdown de ce bloc
        $(this).find('.dropdown-menu div').html($('#ef-date-evenement-historik').parent().html());
        // enlever l'évènement "en cours"
        $(this).find('.dropdown-menu div').parent().find('.btn-warning').parent().remove();
        // Event listener sur les liens d'évènements de la liste
        $('#ef-date-evenement-historik a').on('click', function (ev) {
            ev.preventDefault();
            blocHistorik($(this));
        });
    });

    if (idBloc == null) {
        ordonnerBlocs(false);

        // on met en ordre ascendant les numéros de blocs
        if ($('#mode-read-only').val() == 'False') {
            // créer un dialogue ayant un tree view qui affiche les validations
            var validationDialogInstance = $('#treeViewValidation').dialog("instance");
            if (validationDialogInstance == undefined) {
                var treeDataSource = new DataSourceTree({
                    data: tree_data
                });
                $('#treeViewValidation').ace_tree({
                    dataSource: treeDataSource,
                    multiSelect: true,
                    cacheItems: false,
                    loadingHTML: '<div class="tree-loading"><i class="ace-icon fa fa-refresh fa-spin blue"></i></div>',
                    'open-icon': 'ace-icon fa fa-folder-open',
                    'close-icon': 'ace-icon fa fa-folder',
                    'selectable': true,
                    'selected-icon': null,
                    'unselected-icon': null
                }).on('opened.fu.tree', function (event, data) {
                    // pour chaque dossier ouvert, initialiser le lien vers le bloc
                    if (data.hasOwnProperty('name') && data.name.indexOf('Bloc') === 0) {
                        var lienBloc = $('.tree-folder-name:contains(' + data.name + ')').closest('.tree-folder').find('.lien-bloc-validation');
                        initLienBloc(lienBloc);
                    }
                }).dialog({
                    autoOpen: false,
                    width: 600,
                    maxHeight: 600,
                    resizable: false,
                    fluid: true,
                    open: function (event, ui) {
                        $(this).tree('refreshAll');
                    }
                });
            } else {
                effacerValidation();
                fermerFenetreValidation();
                // fermer les messages affichés en haut de la fiche
            }
        }

        if ($("#fiche-terrain-ou-batiment").val() == 'True' || $("#fiche-terrain-ou-batiment").val() == 'true') {
            var nomLocalStorageTableauBlanc = genererNomKeyLocalStorageSvg("note");
            var nomLocalStorageCroquis = genererNomKeyLocalStorageSvg("croquis");

            var lienTableauBlancClasseSup = "";
            var lienNoteCroquisClasseSup = "";

            if ($('#mode-read-only').val() == 'True') {
                lienTableauBlancClasseSup = "readonly-vide";
                lienNoteCroquisClasseSup = "readonly-vide";
            }

            if (localStorage.getItem(nomLocalStorageTableauBlanc) !== null && $('#mode-read-only').val() != 'True') {
                lienTableauBlancClasseSup = "warning";
                afficherAvertissementEditeurFiche('avertissement_tb_note_deconnecte_non_importe', 'avertissement_tb_note_deconnecte_non_importe_texte', texteTableauDeconnecteNonImporte.note);
            } else if ($('#id-tableau-blanc').val() != '0' && $('#id-tableau-blanc').val() != '') {
                lienTableauBlancClasseSup = "active";
            }

            if (localStorage.getItem(nomLocalStorageCroquis) !== null && $('#mode-read-only').val() != 'True') {
                lienNoteCroquisClasseSup = "warning";
                afficherAvertissementEditeurFiche('avertissement_tb_croquis_deconnecte_non_importe', 'avertissement_tb_croquis_deconnecte_non_importe_texte', texteTableauDeconnecteNonImporte.croquis);
            } else if ($('#id-notes-croquis').val() != '0' && $('#id-notes-croquis').val() != '') {
                lienNoteCroquisClasseSup = "active";
            }

            $('.lien-tableau-blanc[data-type-tableau="note"]').addClass(lienTableauBlancClasseSup);
            $('.lien-tableau-blanc[data-type-tableau="croquis"]').addClass(lienNoteCroquisClasseSup);
        }
        var url_auto_declaration = $('#id_url_auto_declaration').val();
        if (url_auto_declaration !== "None") {
            $('.lien-auto-declaration').attr('href', url_auto_declaration);
        } else {
            $('.lien-auto-declaration').addClasses(['reset-button-style', 'lien', 'lien-avec-etat', 'readonly-vide']);
        }


        initLienBloc($('.lienBloc'));

        calculerHauteurAncre();

        // afficher un dialogue avec les erreurs de validation en cliquant sur le lien
        $('#lienValidationErreur').off("click").on("click", function (e) {
            e.preventDefault();
            afficherFenetreValidation();
        });

        // afficher un dialogue avec les remarques en cliquant sur le lien
        $('#lienRemarques').off("click").on("click", function (e) {
            e.preventDefault();
            afficherFenetreRemarques();
        });

        $('body').off('click', '.lien-tableau-blanc').on('click', '.lien-tableau-blanc', function () {
            if (!$(this).hasClass("readonly-vide")) {
                var type_tableau = $(this).data("type-tableau");
                chargerFormTableauBlanc(type_tableau, $(this).hasClass("active"));
            }
        });

        $('.btn-signature').off("click").on("click", function () {
            if (!$(this).is(':disabled')) {
                var idB79Instance = $(this).closest(".sous-bloc-form").attr("id-model-instance");
                var noLigne = $(this).closest(".sous-bloc-form").attr("no-ligne");
                var signature = $(this).siblings(".input-signature").val();
                chargerModalSignatureB79(idB79Instance, noLigne, signature);
            }
        });

        // permet de changer le numéro de bâtiment pour les nouveaux batiments à partir de la fiche sélectionner seulement si sélecteur de batiment
        if ($('#current-no-batiment').val() != '') {
            $('#b08-renseignements-generaux-batiment').find('[name="no_batiment"]').val($('#current-no-batiment').val());
        }

        // créer le div pour les remarques
        // $.ajax({
        //     type: "POST",
        //     url: "/gestion-roles/editeur-fiche/remarque/id-batiment/" + idBatiment + "/id-formulaire/" + idFormulaire + "/date/" + dateEvenement.replace(' ', 'T') + "/",
        //     dataType: 'html',
        //     success: function (response) {
        //         $('#remarques').html(response);
        //         var modeReadOnly = ($('#mode-read-only').val());
        //         if (modeReadOnly == 'False') {
        //             initEventsRemarques();
        //         } else {
        //             $('#remarques').find('textarea[name="remarque"]').attr('disabled', true);
        //         }
        //     }
        // });

        // créer le dialogue qui affiche les remarques
        $('#remarques').dialog({
            autoOpen: false,
            width: 1500,
            maxHeight: 600,
            resizable: false,
            fluid: true
        });

        if (estBatiment(idFormulaire)) {
            var noBatiment = $('#current-no-batiment').val();
            var descriptif = $('#current-descriptif').val();

            document.title = idBatiment + ' / ' + noBatiment;
            if (descriptif != "") {
                document.title += ' / ' + descriptif;
            }
        }
    }

    $('[name="type_fondation_liste"]').on('change', function () {
        nettoyerResultatsQcb15($(this));
    });

    $('#b15-fondation-sous-bloc').find('[name="pourcentage"]').on('change', function () {
        nettoyerResultatsQcb15($(this));
    });

    init_b46_modele_densite();
    init_b47_modele_densite();

    // pour certains champs en read only qui dépendant de valeurs d'autres champs
    updateTotaux81();

    var b81Container = $('#b81-espace-locatif-residentiel');
    var inputs = b81Container.find("[name='identifiant_espace'],[name='nb_piece'],[name='loyer_mensuel'],[name='nb_stationnement_interieur'],[name='nb_stationnement_exterieur']");

    formaterMonnaie(blocsContainer.find('input.money'), 0);

    inputs.change(function () {
        updateTotaux81();
    });


    // padding de numéros
    updateNumeros63();

    var b63Container = $('#b63-dependance-detachee');
    inputs = b63Container.find("[name='numero']");

    inputs.change(function () {
        updateNumeros63();
    });

    // passes pour fiche NR
    lierAiresPourcentages();
    updateTotauxAutresSources();

    ajouterSlimScrollEF($('#b81-espace-locatif-residentiel'), {
        hauteur: 505
    });
    ajouterSlimScrollEF($('#b81-espace-locatif-nonresidentiel'), {
        hauteur: 505
    });
    masquesSelection.init();
    if (window.editeurFicheBoutonsInitialized) {
        console.log('⚠ Boutons déjà initialisés, ignorant cet appel');
        return;
    }
    initBoutonsEditeurFiche();

    // initZoomContenuSlimscroll();

    wait.stop();

    var endTime = new Date();
    var timeDiff = endTime - startTime; //in ms

    selectGrisInputChoisi();
    activer_desactiver_liens_methodes_calcul();
    if (!window.isRunningInApp) {
        calculateAccordionStickyHeader();
    }
    decalerContainer();
    if (is_evb_tablette()) {
        if (!Keyboard.initialised) {
            Keyboard.init();
        } else {
            // "rechargement" ex.: quand on charge un nouveau bloc dans la fiche
            Keyboard.desactiverInputmodeChampsFiche();
        }
    }
}

function ouvrirFicheTaj(idBatiment, idTypeBatiment, idEvenement, dateEvenement, idFormulaire, idBloc, callback) {
    console.log('ouvrirFicheTaj!!!!', idBatiment, idTypeBatiment, idEvenement, dateEvenement, idFormulaire, idBloc);
    console.log("callback", callback);

    console.log("isRunningInApp", window.isRunningInApp);
    var modeWizard = ($('#wizard').length > 0);
    if (typeof (idBloc) == 'undefined') idBloc = null;

    var blocsContainer;
    if (!modeWizard) {
        blocsContainer = $('#blocs-container');
    } else {
        blocsContainer = $('.step-pane.active');
    }
    console.log("Before wait")

    wait.start();

    if (blocsContainer.length == 0) {
        wait.stop();
    }
    console.log("After wait");

    // On load le formulaire d'un bâtiment
    var params = {
        date_evenement: dateEvenement,
        id_evenement: idEvenement,
        mode_wizard: modeWizard,
        id_type_batiment: idTypeBatiment
    };

    if (window.mode_deconnecte === true) {
        params.mode_deconnecte = "True";
    }

    if (idBloc != null) {
        params.id_bloc_affiche = idBloc;
    }

    console.log("Just before AJAX call to openFicheTaj", params);

    $.ajax({
        type: "GET",
        url: "/" + NOM_MODULE + "/editeur-fiche/id-batiment/" + idBatiment + '/' + idFormulaire + "/form/",
        dataType: 'html',
        data: params,
        success: function (response) {
            console.log('Réponse AJAX reçue pour ouvrirFicheTaj', response);
            var startTime = new Date();

            var reponse = JSON.parse(response);
            if (reponse.barre_outils) {
                // Puisque chaque fiche d'un évènement est différente, on doit recharger la barre des outils à chaque chargement de fiche.
                $('#entete-barre-outils').empty();
                $('#entete-barre-outils').append(reponse.barre_outils);
                // Mettre à jour le input caché pour l'attribut read-only
                $('input#mode-read-only').prop('value', reponse.mode_read_only);
                // Réinitialisation des évènements sur la barre d'outils.

                // repremdre la date de l'évènement car elle peut avoir été changée par l'évènement pendant que la fiche
                // était ouverte
                $('#date-evenement').val(reponse.date_evenement);
                $('#id-batiment').val(reponse.id_batiment);
                $('#id-tableau-blanc').val(reponse.id_tableau_blanc);
                $('#id-notes-croquis').val(reponse.id_note_croquis);
                $('#fiche-terrain-ou-batiment').val(reponse.fiche_terrain_ou_batiment);
            }
            if (idBloc == null) {
                $('#blocs-container').html(reponse.contenu);
            } else {
                $('.blocForm[id_bloc="' + idBloc + '"]').html(reponse.contenu);
            }

            initBlocsCharges(idFormulaire, idBloc);

            if (typeof (callback) != 'undefined') {
                callback();
            }

            if (modeWizard) {
                wait.stop();
                return;
            }

            // ajouter un slimScroll dans les agrandissements seulement s'il y a suffisament d'agrandissements
            ajouterSlimScrollEF($('#b08-agrandissement'), 150);
            $('#b08-agrandissement').attr('hauteur-originale', 400);


            // Initialisation spécifique au bloc 05 et 06 (documents)
            var b05Documents = $('[id^="b05-document"]');
            var b06Documents = $('[id^="b06-document"]');
            var b90Documents = $('#b90-document');

            // On ajoute un slimScroll dans les documents seulement s'il y a suffisament de documents
            ajouterSlimScrollEF(b05Documents, 400, true);
            b05Documents.attr('hauteur-originale', 400);
            if ($('#mode-read-only').val() === 'False') {
                rendreChampMultipleOrdonnable(b05Documents, "#form-ordre");
            }
            ajouterSlimScrollEF(b90Documents, 400);
            b90Documents.attr('hauteur-originale', 400);

            if (typeof camera !== 'undefined') {
                camera.initialiserClickCamera();
            }

            ajusterTailleImage($('[id^="b05-photo"] #photo-principale'), '625px', '500px');
            ajusterTailleImage($('[id^="b06-croquis"] #photo-principale'), '625px', '500px');

            // On ajuste la taille de chacune des images pour s'assurer qu'elles occupent toujours le même espace sans les déformer.
            ajusterTailleImage(b05Documents.find('img'), '100px', '80px');
            initAceThumbnails('colorboxDoc1');
            // Ajout de la description photo

            $.each(b05Documents.find('a'), function (idx, obj) {

                var a = $(obj)[0];
                var description = $(a).closest('.sous-bloc-form').find('#form-description').val();

                $(a).attr('title', description);

            });


            ajusterTailleImage(b06Documents.find('img'), '100px', '80px');
            initAceThumbnails('colorboxDoc2');

            //Bouton pour ouvrir le detail du coût
            $('.btn-cout').off('click').on('click', function () {
                blocCoutClicked($(this));
            });

            // #18249: historicité des blocs callback click/ouverture icone historique pour afficher la sélection des évènements
            $('.btn-historik-blocx').parent().on('show.bs.dropdown', function (e) {
                // on affiche la liste de sélection d'évènements dans le dropdown de ce bloc
                $(this).find('.dropdown-menu div').html($('#ef-date-evenement-historik').parent().html());
                // enlever l'évènement "en cours"
                $(this).find('.dropdown-menu div').parent().find('.btn-warning').parent().remove();
                // Event listener sur les liens d'évènements de la liste
                $('#ef-date-evenement-historik a').on('click', function (ev) {
                    ev.preventDefault();
                    blocHistorik($(this));
                });
            });

            // #20802 : clic calculatrice pour afficher les détails du guide calcul
            function section_guide_calcul(btn_guide_calcul) {
                var idBloc = btn_guide_calcul.attr('data-action');
                var idEvenement = $('#id-evenement').val();
                var currentIdBatiment = $('#current-id-batiment').val();
                var nomBloc = btn_guide_calcul.attr('data-nom-bloc');

                var idWait = btn_guide_calcul.closest('.panel-default').find('.panel-collapse').attr('id');
                if ($('#evenement-' + idBloc + '-toggle').hasClass('in')) {
                    wait.start(idWait);
                } else {
                    wait.start();
                }

                $('#accordion-evenement-bloc-' + idBloc + '-focus').remove(); // On efface le div -focus, au cas où on ne le ferme pas au préalable à ce clic.


                $.ajax({
                    type: "GET",
                    url: "/gestion-roles/tenue-a-jour/evenement/" + idEvenement + "/guide-calcul-details/" + idBloc + "/" + currentIdBatiment + "/",
                    dataType: 'html',
                    success: function (response) {
                        wait.stop();

                        $('#accordion-evenement-bloc-' + idBloc).remove();
                        $('#' + nomBloc).append(response);
                        $('#' + idBloc + '-bloc-close').on('click', function () {
                                    $('#accordion-evenement-bloc-' + idBloc).fadeTo(300, 0.00, function () {
                                                $(this).slideUp(300, function () {
                                    $(this).remove();
                                    $('#accordion-evenement-bloc-' + idBloc + '-focus').remove();
                                });
                            });
                        });
                        if ($('#evenement-' + idBloc + '-toggle').hasClass('in')) {
                            wait.stop(idWait);
                        } else {
                            wait.stop();
                        }
                        wait.stop(idWait);
                        $('html, body').animate({
                            scrollTop: ($('#accordion-evenement-bloc-' + idBloc + '-focus').offset().top - $('#entete-fixe').height())
                        }, 700);

                    }
                });
            }

            $('.btn-guide-calcul').off('click').on('click', function (e) {
                e.preventDefault();
                section_guide_calcul($(this));
            });

            init_guides_calcul('b11-charge-estimee', 'poids', 'calcul_charges_auto');
            init_guides_calcul('b21-acier-cadre-rigide', 'quantite', 'calcul_quantite_auto');
            init_guides_calcul('b21-acier-etagee', 'quantite', 'calcul_quantite_auto');
            init_guide_calcul_b21_2();

            if (idBloc == null) {
                ordonnerBlocs(false);

                // on met en ordre ascendant les numéros de blocs
                if ($('#mode-read-only').val() == 'False') {
                    // créer un dialogue ayant un tree view qui affiche les validations
                    var validationDialogInstance = $('#treeViewValidation').dialog("instance");
                    if (validationDialogInstance == undefined) {
                        var treeDataSource = new DataSourceTree({
                            data: tree_data
                        });
                        $('#treeViewValidation').ace_tree({
                            dataSource: treeDataSource,
                            multiSelect: true,
                            cacheItems: false,
                            loadingHTML: '<div class="tree-loading"><i class="ace-icon fa fa-refresh fa-spin blue"></i></div>',
                            'open-icon': 'ace-icon fa fa-folder-open',
                            'close-icon': 'ace-icon fa fa-folder',
                            'selectable': true,
                            'selected-icon': null,
                            'unselected-icon': null
                        }).on('opened.fu.tree', function (event, data) {
                            // pour chaque dossier ouvert, initialiser le lien vers le bloc
                            if (data.hasOwnProperty('name') && data.name.indexOf('Bloc') === 0) {
                                var lienBloc = $('.tree-folder-name:contains(' + data.name + ')').closest('.tree-folder').find('.lien-bloc-validation');
                                initLienBloc(lienBloc);
                            }
                        }).dialog({
                            autoOpen: false,
                            width: 600,
                            maxHeight: 600,
                            resizable: false,
                            fluid: true,
                            open: function (event, ui) {
                                $(this).tree('refreshAll');
                            }
                        });
                    } else {
                        effacerValidation();
                        fermerFenetreValidation();
                        // fermer les messages affichés en haut de la fiche
                    }
                }

                if ($("#fiche-terrain-ou-batiment").val() == 'True' || $("#fiche-terrain-ou-batiment").val() == 'true') {
                    var nomLocalStorageTableauBlanc = genererNomKeyLocalStorageSvg("note");
                    var nomLocalStorageCroquis = genererNomKeyLocalStorageSvg("croquis");

                    var lienTableauBlancClasseSup = "";
                    var lienNoteCroquisClasseSup = "";

                    if ($('#mode-read-only').val() == 'True') {
                        lienTableauBlancClasseSup = "readonly-vide";
                        lienNoteCroquisClasseSup = "readonly-vide";
                    }

                    if (localStorage.getItem(nomLocalStorageTableauBlanc) !== null && $('#mode-read-only').val() != 'True') {
                        lienTableauBlancClasseSup = "warning";
                        afficherAvertissementEditeurFiche('avertissement_tb_note_deconnecte_non_importe', 'avertissement_tb_note_deconnecte_non_importe_texte', texteTableauDeconnecteNonImporte.note);
                    } else if ($('#id-tableau-blanc').val() != '0' && $('#id-tableau-blanc').val() != '') {
                        lienTableauBlancClasseSup = "active";
                    }

                    if (localStorage.getItem(nomLocalStorageCroquis) !== null && $('#mode-read-only').val() != 'True') {
                        lienNoteCroquisClasseSup = "warning";
                        afficherAvertissementEditeurFiche('avertissement_tb_croquis_deconnecte_non_importe', 'avertissement_tb_croquis_deconnecte_non_importe_texte', texteTableauDeconnecteNonImporte.croquis);
                    } else if ($('#id-notes-croquis').val() != '0' && $('#id-notes-croquis').val() != '') {
                        lienNoteCroquisClasseSup = "active";
                    }

                    $('.lien-tableau-blanc[data-type-tableau="note"]').addClass(lienTableauBlancClasseSup);
                    $('.lien-tableau-blanc[data-type-tableau="croquis"]').addClass(lienNoteCroquisClasseSup);
                }
                var url_auto_declaration = $('#id_url_auto_declaration').val();
                if (url_auto_declaration !== "None") {
                    $('.lien-auto-declaration').attr('href', url_auto_declaration);
                } else {
                    $('.lien-auto-declaration').addClasses(['reset-button-style', 'lien', 'lien-avec-etat', 'readonly-vide']);
                }


                initLienBloc($('.lienBloc'));

                calculerHauteurAncre();

                // afficher un dialogue avec les erreurs de validation en cliquant sur le lien
                $('#lienValidationErreur').off("click").on("click", function () {
                    afficherFenetreValidation();
                });

                // afficher un dialogue avec les remarques en cliquant sur le lien
                $('#lienRemarques').off("click").on("click", function () {
                    afficherFenetreRemarques();
                });

                $('#lienChronologie').off("click").on("click", function () {
                    afficherFenetreChronologie();
                });

                $('body').off('click', '.lien-tableau-blanc').on('click', '.lien-tableau-blanc', function () {
                    if (!$(this).hasClass("readonly-vide")) {
                        var type_tableau = $(this).data("type-tableau");
                        chargerFormTableauBlanc(type_tableau, $(this).hasClass("active"));
                    }
                });

                $('.btn-signature').off("click").on("click", function () {
                    if (!$(this).is(':disabled')) {
                        var idB79Instance = $(this).closest(".sous-bloc-form").attr("id-model-instance");
                        var noLigne = $(this).closest(".sous-bloc-form").attr("no-ligne");
                        var signature = $(this).siblings(".input-signature").val();
                        chargerModalSignatureB79(idB79Instance, noLigne, signature);
                    }
                });

                // permet de changer le numéro de bâtiment pour les nouveaux batiments à partir de la fiche sélectionner seulement si sélecteur de batiment
                if ($('#current-no-batiment').val() != '') {
                    $('#b08-renseignements-generaux-batiment').find('[name="no_batiment"]').val($('#current-no-batiment').val());
                }

                // créer le div pour les remarques
                $.ajax({
                    type: "POST",
                    url: "/gestion-roles/editeur-fiche/remarque/id-batiment/" + idBatiment + "/id-formulaire/" + idFormulaire + "/date/" + dateEvenement.replace(' ', 'T') + "/",
                    dataType: 'html',
                    success: function (response) {
                        $('#remarques').html(response);
                        var modeReadOnly = ($('#mode-read-only').val());
                        if (modeReadOnly == 'False') {
                            initEventsRemarques();
                        } else {
                            $('#remarques').find('textarea[name="remarque"]').attr('disabled', true);
                        }
                    }
                });

                // créer le dialogue qui affiche les remarques
                $('#remarques').dialog({
                    autoOpen: false,
                    width: 1500,
                    maxHeight: 600,
                    resizable: false,
                    fluid: true
                });

                if (estBatiment(idFormulaire)) {
                    var noBatiment = $('#current-no-batiment').val();
                    var descriptif = $('#current-descriptif').val();

                    document.title = idBatiment + ' / ' + noBatiment;
                    if (descriptif != "") {
                        document.title += ' / ' + descriptif;
                    }
                }
            }

            $('[name="type_fondation_liste"]').on('change', function () {
                nettoyerResultatsQcb15($(this));
            });

            $('#b15-fondation-sous-bloc').find('[name="pourcentage"]').on('change', function () {
                nettoyerResultatsQcb15($(this));
            });

            init_b46_modele_densite();
            init_b47_modele_densite();

            // pour certains champs en read only qui dépendant de valeurs d'autres champs
            updateTotaux81();

            var b81ContainerR = $('#b81-espace-locatif-residentiel');
            var inputsR = b81ContainerR.find("[name='identifiant_espace'],[name='nb_piece'],[name='loyer_mensuel'],[name='nb_stationnement_interieur'],[name='nb_stationnement_exterieur']");

            var b81ContainerNR = $('#b81-espace-locatif-nonresidentiel');
            var inputsNR = b81ContainerNR.find("[name='aire_m2'], [name='mnt_loyer_base'], [name='mnt_loyer_additionnel']");

            formaterMonnaie(blocsContainer.find('input.money'), 0);

            inputsR.change(function () {
                updateTotaux81();
            });

            inputsNR.change(function () {
                updateTotaux81();
            });

            $('#evenement-82-toggle').find('.montant-calcul input[name="montant"]').on('change', calculateTotalB82);
            $('#evenement-82-toggle').find('.montant-calcul input[name="montant_annee_precedente"]').on('change', calculateTotalB82);
            $('#evenement-82-toggle').find('.montant-calcul input[name="montant_annee_anterieur"]').on('change', calculateTotalB82);

            $('#evenement-83-toggle').find('input[name="montant"]').on('change', calculateTotalB83);
            $('#evenement-83-toggle').find('input[name="montant_annee_precedente"]').on('change', calculateTotalB83);
            $('#evenement-83-toggle').find('input[name="montant_annee_anterieur"]').on('change', calculateTotalB83);

            calculateTotalB82();
            calculateTotalB83();

            const annee_exercise = $('[name="date_fin_exercice"]').val();
            if (annee_exercise) {
                const year = Number(annee_exercise.split('-')[0]);
                const previousYear = year - 1;
                const yearBefore = year - 2;

                $('.annee-courante').html(year);
                $('.annee-precedent').html(previousYear);
                $('.annee-anterieur').html(yearBefore);
            }

            $('[name="date_fin_exercice"]').on('change', function () {
                let value = parseInt($(this).val().slice(0, 4));
                $('.annee-courante').html(value);
                $('.annee-precedent').html(value - 1);
               $('.annee-anterieur').html(value - 2);
            });


            // padding de numéros
            updateNumeros63();

            var b63Container = $('#b63-dependance-detachee');
            inputs = b63Container.find("[name='numero']");

            inputs.change(function () {
                updateNumeros63();
            });

            // passes pour fiche NR
            lierAiresPourcentages();
            updateTotauxAutresSources();

            ajouterSlimScrollEF($('#b81-espace-locatif-residentiel'), {
                hauteur: 505
            });
            ajouterSlimScrollEF($('#b81-espace-locatif-nonresidentiel'), {
                hauteur: 505
            });
            masquesSelection.init();
            initBoutonsEditeurFiche();

            initZoomContenuSlimscroll();

            wait.stop();

            var endTime = new Date();
            var timeDiff = endTime - startTime; //in ms
            // strip the ms
            timeDiff /= 1000;

            selectGrisInputChoisi();
            activer_desactiver_liens_methodes_calcul();
            calculateAccordionStickyHeader();
            decalerContainer();
            if (is_evb_tablette()) {
                if (!Keyboard.initialised) {
                    Keyboard.init();
                } else {
                    // "rechargement" ex.: quand on charge un nouveau bloc dans la fiche
                    Keyboard.desactiverInputmodeChampsFiche();
                }
            }
            const btnMethodeCalcul = document.querySelector('button.dropdown-toggle[title="Méthodes de calcul"]');
            const rawValue = document.querySelector('#role-evaluation-non-disponnible')?.value;
            const isRoleEvaluationNonDisponible = rawValue === "True";

            if (isRoleEvaluationNonDisponible) {
                btnMethodeCalcul?.setAttribute('disabled', 'disabled');
            }
        }
    });

}

$(window).scroll(function () {
    calculateAccordionStickyHeader();
});

$(window).resize(function () {
    calculateAccordionStickyHeader();
    decalerContainer();
});

function decalerContainer() {
    const enteteFixeHeight = $("#entete-fixe").height() + $("#liens-blocs").outerHeight() - 2;
    $("#container").css("padding-top", `${enteteFixeHeight}px`);
}

/* #17346 - Rendre le header des blocs sticky */
function calculateAccordionStickyHeader() {
    $(".accordion-fiches-sticky").each(function () {
        let enteteFixeHeight = $("#entete-fixe").height() + $("#liens-blocs").outerHeight();
        let ionHeaderToolbar;
        if (window.isRunningInApp) {
            ionHeaderToolbar = document.querySelector('ion-header ion-toolbar');
            enteteFixeHeight += ionHeaderToolbar.offsetHeight;
        }
        const accordionPosition = {
            'top': $(this).offset().top,
            'left': $(this).offset().left,
            'bottom': $(this).offset().top + $(this).outerHeight()
        };
        const accordionPanel = $(this).find(".panel").first();
        const accordionHeading = $(this).find(".panel-heading").first();
        var scrollPosition = $(window).scrollTop();

        $(accordionPanel).css("padding-top", $(accordionHeading).outerHeight(true) + 'px');

        $(accordionHeading).css({
            'top': enteteFixeHeight + 'px',
            'left': accordionPosition.left + 'px',
            'width': $(this).outerWidth() + 'px'
        });

        if (scrollPosition >= (accordionPosition.bottom - enteteFixeHeight - $(accordionHeading).outerHeight(true))) {
            accordionHeading.removeClass("stick-top");
            accordionHeading.removeClass("normal-position");
            accordionHeading.addClass("stick-bottom");
        } else if (scrollPosition >= (accordionPosition.top - enteteFixeHeight)) {
            accordionHeading.addClass("stick-top");
            accordionHeading.removeClass("normal-position");
            accordionHeading.removeClass("stick-bottom");
        } else {
            accordionHeading.removeClass("stick-top");
            accordionHeading.addClass("normal-position");
            accordionHeading.removeClass("stick-bottom");
        }
    });
}

function checkboxTousCheckedNotChecked(inverted, checkboxTous, checkboxRows) {
    // Si le checkbox Tous est coché, cocher tous les checkbox.
    // À l'inverse, si tous les checkboxs sont cochés, il faut cocher le checkbox Tous, sinon, il faut le décocher.

    if (typeof (checkboxTous) == 'undefined') {
        checkboxTous = $('#checkbox-attestation-tous');
    }
    if (typeof (checkboxRows) == 'undefined') {
        checkboxRows = $('[name="checkbox-attestation-applique-a"]');
    }

    if (!inverted) {
        var textbox = $('[name=text-numero-civique-apres]'); // DM: pour le cas spécial pour changement nom de voie publique

        let checked = checkboxTous.is(':checked');
        checkboxRows.filter(':enabled').prop("checked", checked).change();
        textbox.prop('disabled', !checked);
        checkboxRows.closest('[type="formulaire"]').attr('modifie', 'True');

        boutonAttestationEnabledDisabled();
    } else {
        let checked = checkboxRows.filter(':checked').length == checkboxRows.length && checkboxRows.length != 0;
        checkboxTous.prop("checked", checked).change();
    }
}

function boutonAttestationEnabledDisabled() {
    // si tous les checkbox sont décochés, il faut désactiver le bouton "Ajouter cette attestation"
    // sinon, il faut l'activer
    var disabled = $('[name="checkbox-attestation-applique-a"]:checked').length == 0;
    $('.btn-tj-ajouter-attestation').attr('disabled', disabled);
}

function initCheckboxTous(checkboxTous, checkboxRows) {
    checkboxTousCheckedNotChecked(true, checkboxTous, checkboxRows);

    checkboxTous.on('click', function (e) {
        checkboxTousCheckedNotChecked(false, checkboxTous, checkboxRows);
    });

    checkboxRows.on('click', function (e) {
        checkboxTousCheckedNotChecked(true, checkboxTous, checkboxRows);
    });

    if ($('#wizard').attr('id-type-evenement') != 67) {
        // désactiver les checkbox en mode read-only
        checkboxTous.add(checkboxRows).attr('disabled', $('#wizard').attr('mode') == 'r');
    }
}

function initCodeUtilisationSelect2(container, estDansWizard, afficherPlaceholder) {
    if (estDansWizard === undefined) estDansWizard = false;
    if (afficherPlaceholder === undefined) afficherPlaceholder = false;

    var paramsSupp = {
        id_formulaire: $('#current-id-formulaire').val()
    };
    var champs = container.find('.fiche-select2-ajax[name^="codeUtilisation"]');
    if (estDansWizard) {
        champs = container.find('[name="codeUtilisation"]');
        paramsSupp = {};
    }
    $.each(champs, function (index, champ) {
        // forcer pour voir les codes d'utilisation non-résidentiels dans certains cas
        if (!estDansWizard && $(champ).closest('#b81-espace-locatif-nonresidentiel, #b08-local-non-residentiel, #b44-utilisation').length > 0) {
            paramsSupp = {
                id_formulaire: ID_FORMULAIRE.nonResidentiel
            };
        }
        if (window.isRunningInApp) {
            initSelecteurDeRecherche(
                $(champ),
                (searchTerm, page, nbParPage, paramsSupp) => {
                    return window.searchCodesUtilisationOffline(searchTerm, page, nbParPage, paramsSupp);
                }, afficherPlaceholder, true, false, paramsSupp);
        } else {
            initSelecteurDeRecherche($(champ), "/gestion-roles/get-choix-code-utilisation/",
                afficherPlaceholder, true, false, paramsSupp);
        }
    });
}

function initExpUeProprietaireSelect2(idMunicipalite) {
    var champs = $('#exp-ue-proprietaire');
    if (idMunicipalite == "00000" || idMunicipalite === undefined) {
        champs.select2({
            data: [],
        });
        return;
    }

    var paramsSupp = {};
    var callbackParamsSupp = function () {
        return {
            rechercher_historique: $('#exp-ue-rechercher-historique').prop('checked'),
            id_municipalite: idMunicipalite      };
    };
    var url = "/gestion-roles/exp-ue/proprietaire/municipalite/" + idMunicipalite + "/";
    if (!window.isRunningInApp) {
        $.each(champs, function (index, champ) {
        initSelecteurDeRecherche($(champ), url, true, false, false, paramsSupp, callbackParamsSupp);
        });
    }
}

function initProprietaireSelect2(container) {
    var paramsSupp = {};
    var champs = container.find('.fiche-select2-ajax[name="proprietaire"]');
    var callbackParamsSupp = function () {
        return {
            id_municipalite: $('#id_municipalite').val(),
            date_evenement: $('#date-evenement').val()
        };
    };
    $.each(champs, function (index, champ) {
        var proprietaire = $(this).closest('.sous-bloc-form').find('[name="typeOccupationMulti"]');
        let maxlength = $(proprietaire.context).attr('maxlength');
        if (proprietaire.val() == 4) {
            initSelecteurDeRecherche($(champ), "/gestion-roles/get-choix-proprietaire", false, false, false, paramsSupp, callbackParamsSupp, false, maxlength);
            $(this).closest('.sous-bloc-form').find('[name="proprietaire"]').prop('disabled', true);
        } else {
            initSelecteurDeRecherche($(champ), "/gestion-roles/get-choix-proprietaire", true, false, true, paramsSupp, callbackParamsSupp, false, maxlength);
        }
    });
}

function initnomProprietaireSelect2(Municipalite) {
    var paramsSupp = {};
    var champs = $('#id_proprietaire');
    var callbackParamsSupp = function () {
        return {
            id_municipalite: $('#id_municipalite').val()
        };
    };
    $.each(champs, function (index, champ) {
        initSelecteurDeRecherche($(champ), '/fiche_role/recherche-propriete/proprietaire/municipalite/' + Municipalite + '/', true, false, true, paramsSupp, callbackParamsSupp);
    });
}

function initLotSelect2(container) {
    var paramsSupp = {
        id_municipalite: container.find('[name=id_municipalite]').val(),
    };
    var champs = container.find('[name="ue_recherche"]');
    var callbackParamsSupp = function () {
        return {
            id_municipalite: container.find('[name=municipalite]').val(),
            //date_evenement: $('#date-evenement').val()
        };
    };
    $.each(champs, function (index, champ) {
        initSelecteurDeRecherche($(champ), "/gestion-roles/get-choix-lot", true, false, false, paramsSupp, callbackParamsSupp, true);
    });
}

function initProprietaireRechercheSelect2(container) {
    var paramsSupp = {};
    var champs = container.find('.fiche-select2-ajax[name="proprietaire_nom_complet"]');
    var callbackParamsSupp = function () {
        return {
            id_municipalite: $('#municipalite').val(),
            date_evenement: $('#wizard').attr('date-evenement'),
        };
    };
    $.each(champs, function (index, champ) {
        initSelecteurDeRecherche($(champ), "/gestion-roles/get-choix-proprietaire-x-ue", true, false, false, paramsSupp, callbackParamsSupp, true);
    });
}

function initSelecteurDeRecherche(champ, urlOrCallback, afficherPlaceholder, afficherId, afficherTexteRecherche, paramsSupp, callbackParamsSupp, multiple = false, maxlength=null) {
    var nbParPage = 100;
    var isOfflineMode = window.isRunningInApp && typeof urlOrCallback === 'function';

    var ajaxConfig;

    if (isOfflineMode) {
        // Mode offline - utiliser la fonction de callback
        ajaxConfig = {
            transport: function (params) {
                var searchTerm = params.data.term || '';
                var pageNumber = params.data.page || 1;

                urlOrCallback(searchTerm, pageNumber, nbParPage, paramsSupp)
                    .then(function (data) {
                        params.success(data);
                    })
                    .catch(function (error) {
                        console.error('Erreur recherche offline:', error);
                        params.error(error);
                    });
            },
            data: function (searchTerm, pageNumber) {
                return {
                    term: searchTerm,
                    page: pageNumber
                };
            },
            results: function (data, pageNumber, query) {
                query.element.attr('texte-recherche', query.term.toUpperCase());
                query.element.attr('texte-recherche-nb-total', data.nb_total);

                var more = (pageNumber * nbParPage) < data.nb_total;
                return {
                    results: data.liste_resultats,
                    more: more
                };
            },
            cache: false
        };
    } else {
        // Mode online - utiliser l'URL Ajax classique
        ajaxConfig = {
            url: urlOrCallback,
            dataType: 'json',
            quietMillis: 500,
            data: function (searchTerm, pageNumber) {
                var params = {};
                params.page = pageNumber;
                params.nb_x_page = nbParPage;
                params.filtre = searchTerm;
                if (paramsSupp !== undefined) {
                    $.extend(params, paramsSupp);
                }
                if (callbackParamsSupp !== undefined) {
                    $.extend(params, callbackParamsSupp());
                }
                return params;
            },
            results: function (remoteData, pageNumber, query) {
                // garder le texte recherché pour l'afficher si on ferme le dropdown sans sélection
                query.element.attr('texte-recherche', query.term.toUpperCase());
                query.element.attr('texte-recherche-nb-total', remoteData.nb_total);

                var more = (pageNumber * nbParPage) < remoteData.nb_total;
                return {
                    results: remoteData.liste_resultats,
                    more: more
                };
            },
            cache: true
        };
    }
    var select2params = {
        ajax: ajaxConfig,
        placeholder: afficherPlaceholder ? "Rechercher..." : " ",
        minimumInputLength: 2,
        allowClear: true,
        dropdownAutoWidth: true,
        multiple: multiple,
        separator: multiple ? "|" : ",",
        escapeMarkup: function (markup) {
            return markup;
        },
        initSelection: function (element, callback) {
            // si on met à jour l'élément avec select2('val', ...) depuis formatSelection, alors, il passe ici pour retourner l'information
            var data;
            if (multiple) {
                var listeElement = element.val();
                if (typeof listeElement == 'string')
                    listeElement = JSON.parse(listeElement);
                data = [];
                for (var index in listeElement) {
                    data.push({
                        id: listeElement[index],
                        text: listeElement[index]
                    });
                }
            } else {
                data = {
                    id: element.val(),
                    text: element.attr('title')
                };
            }
            callback(data);
        },
        formatResult: function (result, container, query, escapeMarkup) {
            if (result.adresse && result.nom_complet) {
                result.text = result.nom_complet + ', ' + result.adresse;
            }

            return $.fn.select2.defaults.formatResult(result, container, query, escapeMarkup);
        },
        formatSelection: function (data, container, escapeMarkup) {
            var element = this.element;
            // effacer le texte recherché, qui est gardé comme attribut dans le input, car une sélection est faite ou il est affiché dans le sélecteur
            $(element).removeAttr('texte-recherche');
            $(element).removeAttr('texte-recherche-nb-total');

            if (data.nom_complet) {
                data.text = data.nom_complet;
            }

            // afficher un tooltip avec le texte de la sélection
            element.parent().find('.select2-container .select2-choice').attr('title', data.text);
            element.attr('title', data.text);

            if (afficherId) {
                // remplacer le texte de la sélection par le id du data pour l'afficher dans le sélecteur
                data.text = data.id;
            }

            if (typeof (data.bool_geocentralis) != 'undefined') {
                $('[name=bool_geocentralis]').val(data.bool_geocentralis);
            }

            return $.fn.select2.defaults.formatSelection(data, container, escapeMarkup);
        },
    };
    if(maxlength){
        select2params.maximumInputLength = maxlength;
    }
    champ.select2(select2params);

    // mettre le texte à rechercher en majuscules
    champ.each(function () {
        var classInputSearch = '.select2-search';
        if (multiple) {
            classInputSearch = '.select2-search-field';
        }
        $(this).select2('container').find(classInputSearch + " input.select2-input").css('text-transform', 'uppercase');
    });

    // sur la fermeture du sélecteur, vérifier si on doit afficher le texte recherché
    if (afficherTexteRecherche) {
        champ.on('select2-close', function (e) {
            var texteRecherche = $(this).attr('texte-recherche');
            var boolCreationProprietaire = $(this).closest('.sous-bloc-form').find('[name="bool_creation_proprietaire"]');
            if (texteRecherche) {
                // assigner l'attribut avant la valeur pour qu'il soit utilisé dans initSelection
                $(this).attr('title', texteRecherche);
                $(this).select2('val', texteRecherche, true);
                boolCreationProprietaire.val(true);
            }
        });
    }

    // sur la suppression de la sélection, enlever le tooltip
    champ.on('select2-clearing', function (e) {
        $(this).parent().find('.select2-container .select2-choice').attr('title', '');
        $(this).attr('title', '');

        // DM: ajouté ceci car sinon, si on avait entré un nouveau propriétaire puis qu'on efface le texte et qu'on entre un propriétaire existant, ça passerait comme un "nouveau propriétaire"
        var boolCreationProprietaire = $(this).closest('.sous-bloc-form').find('[name="bool_creation_proprietaire"]');
        boolCreationProprietaire.val(false);
    });
    if (window.isRunningInApp) {
        var childrens = champ.closest('div').children('div');
        if (childrens.eq(0).attr('id') === childrens.eq(1).attr('id')) {
            for (var i = 0; i < childrens.length; i++) {
                if (i === 0) {
                    childrens.eq(i).remove();
                }
                if (i === 1) {
                    childrens.eq(i).css('display', '');
                    childrens.eq(i).find('input').css('display', '');
                }
            }
        }
    }
}


// ???: mais pourquoi/comment!??
// on a des cas où plusieurs input sont indépendants les uns des autres:
//  comment on les distingue en faisant une var globale unique?
var boolChargement;

function updaterCascade(inputChanged) {
    var ligne = inputChanged.closest('.sous-bloc-form');

    $.each(inputChanged.data('childs'), function (idx, inputChild) {
        var cascadeFkAjax = inputChild.attr('cascade-fk-ajax');
        var valeurChanged = false;
        var currentValue;
        if (inputChild.attr('cascade-ajax')) { // DM: tentative d'avoir quelque chose de plus générique en réutilisant le serializer côté serveur
            // DM: ici on est donc dans un cas où la recherche ne se fait PAS ajax, mais où l'on charge un groupe item par ajax selon ce qui est sélectionné dans le combobox parent

            if (boolChargement) {
                return; // devrait déjà être chargé côté serveur par le serializer
            }

            var sousBlocsValidation = inputChild.closest('.champs-multiple');
            var nomBloc;
            if (sousBlocsValidation.length > 0) {
                nomBloc = sousBlocsValidation.attr('id');

                var exceptionsSauvegarde = [];
                var exceptionsLigneSansDonnee = [];
                var exceptionsLigne = [];
                var validationSousBlocs = getValidationSousBlocs(sousBlocsValidation, dateEvenement, exceptionsSauvegarde, exceptionsLigneSansDonnee, exceptionsLigne);

                var index = sousBlocsValidation.find('.sous-bloc-form').index(inputChild.closest('.sous-bloc-form'));

                var validation = [];
                $.each(validationSousBlocs.main, function (nom, val) {
                    if (nom == nomBloc + '_' + index) {
                        validation.push({
                            nom: val
                        });
                    }
                });
            }

            let champChild = inputChild.attr('name');

            let params = {
                'nom_bloc': nomBloc,
                'enfant': champChild,
                'validation': JSON.stringify(validation)
            };

            let callbackParamsSupp = inputChild.data('callback-params-supp');
            if (callbackParamsSupp) {
                var paramsSupp = callbackParamsSupp(inputChild);
                $.extend(params, paramsSupp);
            }

            $.ajax({
                type: "GET",
                url: '/core/get-combobox-choices/',
                dataType: 'json',
                data: params,
                async: false,
                success: function (response) {
                    inputChild.select2({
                        dropdownAutoWidth: 'true',
                        allowClear: true
                    });

                    inputChild.empty();
                    var liste_res = response['liste'] || response['liste_resultats'];
                    var option_selected = response['option_selected'];
                    liste_res.forEach((obj, idx, arr) => {
                        var option = {
                            value: obj.id,
                            text: obj.texte || obj.text,
                        };
                        if ('id_model' in obj) option.id_model = id_model;
                        if (option_selected == obj.id) {
                            option.selected = "selected"; // pour ne pas faire effacer la valeur par la suite
                            currentValue = option_selected;
                        }
                        inputChild.append($('<option>', option));
                    });

                },
                error: function (jqXHR, textStatus, errorThrown) {}
            });
        } else if (cascadeFkAjax !== undefined) {
            currentValue = inputChild.attr('initial-value');

            cascadeFkAjax = $.parseJSON(cascadeFkAjax);
            if (cascadeFkAjax != null) {

                var parentVal = {};
                $.each(cascadeFkAjax, function (index, fk) {
                    var champFk = ligne.find('[name="' + fk + '"]');
                    if (!ligne.length) {
                        champFk = $('.blocForm [name="' + fk + '"]').not('.sous-bloc-form [name="' + fk + '"]');
                    }
                    parentVal[fk] = champFk.val();
                });

                let champChild = inputChild.attr('name');

                let params = {
                    'enfant': champChild,
                    'parent': JSON.stringify(parentVal),
                    'has_id_model': inputChild.attr('has-id-model') != undefined ? 'True' : 'False'
                };

                var url;
                // DM: hack temporaire, faudrait rendre ça plus générique
                if (inputChild.attr('ajax-url')) {
                    url = inputChild.attr('ajax-url');
                } else {
                    url = '/gestion-roles/tenue-a-jour/valeur-retenue/get-disposition-legislative/';
                }

                let callbackParamsSupp = inputChild.data('callback-params-supp');
                if (callbackParamsSupp) {
                    let paramsSupp = callbackParamsSupp(inputChild);
                    $.extend(params, paramsSupp);
                }

                $.ajax({
                    type: "GET",
                    url: url,
                    dataType: 'json',
                    data: params,
                    async: false,
                    success: function (response) {
                        inputChild.select2({
                            dropdownAutoWidth: 'true'
                        });

                        inputChild.empty();

                        var liste_res = response['liste'] || response['liste_resultats'];
                        for (var i = 0; i < liste_res.length; i++) {
                            var obj = {
                                value: liste_res[i]['id'],
                                text: liste_res[i]['texte'] || liste_res[i]['text']
                            };
                            if (liste_res[i].hasOwnProperty('id_model')) {
                                obj.id_model = liste_res[i]['id_model'];
                            }
                            inputChild.append($('<option>', obj));
                        }
                    },
                    error: function (jqXHR, textStatus, errorThrown) {}
                });
            }
        } else {
            currentValue = inputChild.val();
            var selectionVideValue = inputChanged.attr('selection-vide-value');
            var selectionVide = selectionVideValue != undefined;
            if (selectionVide && selectionVideValue == '') {
                selectionVideValue = '-1';
            }

            inputChild.empty();

            inputChild.append($('<option>', {
                value: selectionVide ? selectionVideValue : '',
                text: selectionVide ? ' - ' : ''
            }));

            var choicesJson = inputChild.attr('initial-choices');
            if (choicesJson) {
                var jsonObj = $.parseJSON(choicesJson);
                var inputChangedValue = inputChanged.val();
                if (inputChangedValue) {
                    for (var i = 0; i < jsonObj.length; i++) {
                        var cle = jsonObj[i][0];
                        var texte = jsonObj[i][1];
                        var cleParent = jsonObj[i][2];

                        if (cleParent == inputChangedValue || (selectionVide && selectionVideValue == inputChangedValue)) {
                            inputChild.append($('<option>', {
                                value: cle,
                                text: texte
                            }));
                        }
                    }
                }
            }
        }

        var option = inputChild.find("option[value='" + currentValue + "']");
        if (option.length > 0) {
            inputChild.val(currentValue);
            inputChild.select2('val', currentValue);
            inputChild.attr('title', option.text());
        } else {
            if (inputChild.attr('name') === 'municipalite') {
                inputChild.select2().prop("disabled", false);
                if (inputChild.children().length === 2) {
                    var options = inputChild.children();
                    inputChild.select2('data', options[options.length - 1]);
                    inputChild.select2('val', options[options.length - 1].value);
                } else if (inputChild.children().length === 1)
                    inputChild.select2().prop("disabled", true);
            } else {
                inputChild.val('');
                inputChild.select2('val', '');
                inputChild.attr('title', '');
            }
            valeurChanged = true;
        }

        if (inputChild.data('childs') && valeurChanged) {
            inputChild.change();
        }
    });
}

function fctUpdaterCascade() {
    updaterCascade($(this));
}

function initCascade(container) {
    var cascadeParents = [];

    for (var passe = 0; passe < 2; passe++) {
        container.find('.cascade-combobox').each(function () {
            var ligne = $(this).closest('.sous-bloc-form');
            var champParent = $(this).attr('cascade-champ');
            if ($(this).attr('cascade-champs')) {
                var champs_parents = JSON.parse($(this).attr('cascade-champs').replaceAll("'", '"'));
                for (const champParent of champs_parents) {
                    var inputParent = ligne.find('[name="' + champParent + '"]');
                    if (!ligne.length)
                        inputParent = $('.blocForm [name="' + champParent + '"]').not('.sous-bloc-form [name="' + champParent + '"]');
                    var inputChild = $(this);

                    inputParent.each(function () {
                        var inputParent = $(this);
                        if (passe == 0) {
                            inputParent.data('childs', []); // tout resetter à la première passe
                        } else {
                            var arrInputChild = inputParent.data('childs') || [];
                            arrInputChild.push(inputChild);
                            inputParent.data('childs', arrInputChild);

                            if (jQuery.inArray(inputParent[0], cascadeParents) == -1) {
                                cascadeParents.push(inputParent[0]);
                            }
                        }
                    });
                }
            } else {
                var inputParent = ligne.find('[name="' + champParent + '"]');
                if (!ligne.length) {
                    inputParent = $('.blocForm [name="' + champParent + '"]').not('.sous-bloc-form [name="' + champParent + '"]');
                }

                var inputChild = $(this);

                inputParent.each(function () {
                    var inputParent = $(this);
                    if (passe == 0) {
                        inputParent.data('childs', []); // tout resetter à la première passe
                    } else {
                        var arrInputChild = inputParent.data('childs') || [];
                        arrInputChild.push(inputChild);
                        inputParent.data('childs', arrInputChild);

                        if (jQuery.inArray(inputParent[0], cascadeParents) == -1) {
                            cascadeParents.push(inputParent[0]);
                        }
                    }
                });
            }

        });
    }

    $.each(cascadeParents, function (index, value) {
        var inputParent = $(value);
        // si on est dans le modal de 'Assigné à' et que l'utilisateur est pré-rempli,
        // alors, on force la cascade au chargement
        if (container.is('#tenue-a-jour-modal-assigne-a') && inputParent.val()) {
            // pour ne pas y repasser plusieurs fois.
            if (boolChargement !== true) {
                boolChargement = false;
            }
        } else {
            boolChargement = true;
        }
        inputParent.off('change', fctUpdaterCascade).on('change', fctUpdaterCascade);

        inputParent.each(function () {
            updaterCascade($(this));
        });
    });

    boolChargement = false;
}

function afficherValidationGenerale(validations, type) {
    var folderBloc = 'General';
    var treeDataBloc = {};
    if (typeof (tree_data) !== 'undefined') {
        treeDataBloc = tree_data.validations.additionalParameters.children[type].additionalParameters.children;
    }
    var nomBloc = 'general';
    let couleurTexte = '#d58512';
    var validationExiste = Object.keys(validations).length > 0;
    if (!validationExiste) {
        return;
    }
    var noErreur = 1;
    $.each(validations, function (nomChamp, erreur) {
        var erreurListe = 'texte' in erreur ? erreur.texte : erreur;
        if (erreurListe.length) {
            afficherErreurGeneralValidation(erreurListe);
        }

        function afficherErreurGeneralValidation(textes) {
            if (!('general' in treeDataBloc)) {
                // on crée le sous-dossier pour recevoir les erreurs de ce bloc, s'il n'est pas déjà créé
                treeDataBloc.general = {
                    name: 'General',
                    type: 'folder',
                    'icon-class': 'orange',
                    additionalParameters: {
                        children: {}
                    }
                };
            }
            // un champ peut avoir plus d'un message alors on boucle pour avoir tous ses messages
            for (var index = 0; index < textes.length; index++) {
                // si le même message est affiché, on ne l'affiche pas de nouveau
                var infoMessage = chercherMessage(treeDataBloc.general.additionalParameters.children, textes[index], noErreur, index > 0);
                var messageTrouve = infoMessage.messageTrouve;
                noErreur = infoMessage.noErreur;

                if (!messageTrouve) {
                    //ajouter un lien pour aller sur le bloc qui a l'erreur
                    var lienTexte = `${noErreur}. ${textes[index]}`;
                    var lienControle = `<a style="color:${couleurTexte}" href="#!">${lienTexte}</a>`;

                    // on ajoute chaque erreur dans le tree data
                    // on ajoute l'index pour différencier un champ qui aurait plusieurs messages
                    // on ajoute le no d'erreur pour des blocs/sous-blocs qui auraient des messages différents
                    // le numéro '999' est assigné dans le cas où il n'y a pas de champ précisé
                    var noErreurTemp = 999;
                    var childrenKey = `${nomBloc}_${nomChamp}_${index}_${noErreurTemp}`;
                    treeDataBloc.general.additionalParameters.children[childrenKey] = {
                        name: lienControle,
                        type: 'item',
                        noErreur: noErreurTemp
                    };
                    // on met à jour le nombre d'erreurs pour ce bloc
                    let nombreErreur = Object.keys(treeDataBloc.general.additionalParameters.children).length;
                    treeDataBloc.general.name = `${folderBloc} (${nombreErreur})`;
                }
            }
        }
    });
    var list = $.extend({}, treeDataBloc.general.additionalParameters.children);
    var keysSorted = Object.keys(list).sort(function (a, b) {
        var contentA = list[a].noErreur;
        var contentB = list[b].noErreur;
        return (contentA < contentB) ? -1 : (contentA > contentB) ? 1 : 0;
    });

    treeDataBloc.general.additionalParameters.children = {};
    $(keysSorted).each(function (key) {
        treeDataBloc.general.additionalParameters.children[key] = {
            name: list[key].name,
            type: 'item',
            noErreur: list[key].noErreur
        };
    });
}

function afficherValidation(form, validations, type) {
    var formInitial = form;
    var estBloc = form.is('.blocForm');
    var idBloc = estBloc ? form.attr('id_bloc').substr(0, 2) : form.closest('.champs-multiple').attr('id').substr(1, 2);
    var idBlocInt = parseInt(idBloc); // utile pour mettre les blocs en ordre car avec le texte '08' vs '15', le '15 vient avant
    var idBlocIntInitial = idBlocInt;
    var folderBloc = 'Bloc ' + idBloc;
    var folderBlocInitial = folderBloc;
    var treeDataBloc = typeof (tree_data) !== 'undefined' ? tree_data['validations']['additionalParameters']['children'][type]['additionalParameters']['children'] : {};
    var nomBlocZoom = estBloc ? form.attr('id') : form.closest('.blocForm').attr('id');
    var nomBlocZoomInitial = nomBlocZoom;
    var nomBloc = estBloc ? form.attr('id') : form.closest('.champs-multiple').attr('id'); // sert pour différencier d'où provienne les erreurs et les rendre uniques pour le treeData
    var iconeClass = 'red';
    var couleurTexte = 'red';
    if (type === 'avertissements') {
        iconeClass = 'orange';
        couleurTexte = '#d58512';
    }
    var validationExiste = Object.keys(validations).length > 0;
    if (estBloc)
        validationExiste = ('params' in validations && Object.keys(validations).length > 1) ||
        (!('params' in validations) && Object.keys(validations).length > 0);

    if (validationExiste) {
        var noErreur = 1;
        $.each(validations, function (nomChamp, erreur) {
            if (nomChamp === 'params') {
                return true;
            }
            // reprendre les données initiales à chaque boucle
            form = formInitial;
            idBlocInt = idBlocIntInitial;
            nomBlocZoom = nomBlocZoomInitial;
            folderBloc = folderBlocInitial;
            // si c'est un bloc d'une fiche, il ne faut pas trouver les champs dans les sous-blocs
            var exceptionsFormControl = [];
            if (estBloc) {
                exceptionsFormControl = form.find('.champs-multiple .form-control');
            } else {
                exceptionsFormControl = form.find('.suppression-ligne .form-control, .suppression-ligne-sauvegardee .form-control');
            }
            var champs = form.find('.form-control[name="' + nomChamp + '"]').not(exceptionsFormControl);

            // si l'erreur arrive sur un sélecteur ayant un input associé, il faut trouver le(s) input(s) pour afficher la notification
            if (champs.is('select, ul.fake-select')) {
                var input = champs.closest('.blocForm').find('input[parent="' + champs.attr('name') + '"]');
                if (input.length > 0) {
                    champs = input;
                }
            }

            // si c'est un champ imbriqué, il faut construire le nom du champ avec un point(.) pour le retrouver
            if (champs.length == 0 && erreur instanceof Object) {
                $.each(erreur, function (nom, textes) {
                    var nomChampTemp = nomChamp + '.' + nom;
                    var champsTemp = form.find('.form-control[name="' + nomChampTemp + '"]').not(exceptionsFormControl);
                    if (champsTemp.length > 0) {
                        afficherErreurValidation(form, champsTemp, textes);
                    }
                });
            }

            var erreurListe = 'texte' in erreur ? erreur['texte'] : erreur;
            if (erreurListe.length) {
                afficherErreurValidation(form, champs, erreurListe);
            }

            if ('sous_bloc' in erreur) {
                // mettre en ordre le nom des sous-blocs
                var dictSousBloc = $.extend({}, erreur['sous_bloc']);
                var keysSousBlocSorted = Object.keys(dictSousBloc).sort(function (a, b) {
                    var contentA = a;
                    var contentB = b;
                    return (contentA < contentB) ? -1 : (contentA > contentB) ? 1 : 0;
                });
                erreur['sous_bloc'] = {};
                for (var i = 0; i < keysSousBlocSorted.length; i++) {
                    var key = keysSousBlocSorted[i];
                    erreur['sous_bloc'][key] = dictSousBloc[key];
                }

                $.each(erreur['sous_bloc'], function (sousBlocKey, sousBlocValue) {
                    // reprendre les données initiales à chaque boucle
                    form = formInitial;
                    idBlocInt = idBlocIntInitial;
                    nomBlocZoom = nomBlocZoomInitial;
                    folderBloc = folderBlocInitial;
                    // si un sous-bloc est précisé, il faut le chercher ainsi que le champ correspondant
                    form = form.find('#' + sousBlocKey);
                    // si c'est un sous-bloc qui n'est pas dans ce bloc, chercher le sous-bloc dans le reste de la fiche
                    if (form.length == 0) {
                        var divBatiment = formInitial.closest('[id^=accordion-batiment-]');
                        if (divBatiment.length) { // DM 2019-04-01: dans l'écran propagation, ne pas prendre la portion AVANT
                            form = divBatiment.find('.apres-container #' + sousBlocKey);
                        } else {
                            form = $('#' + sousBlocKey);
                        }

                        if (form.length != 0) {
                            idBlocInt = parseInt(form.closest('.blocForm').attr('id_bloc').substr(0, 2));
                            nomBlocZoom = form.closest('.blocForm').attr('id');
                            folderBloc = 'Bloc ' + form.attr('id').substr(1, 2);
                        }
                    }
                    if (form.length) {
                        var containerSousBloc = form.find('.sous-bloc-form');
                        var inputDansLigneSupprimee = containerSousBloc.find('.suppression-ligne .form-control, .suppression-ligne-sauvegardee .form-control');
                        // chercher le champ dans les sous-blocs mais il ne faut pas afficher la notification sur une nouvelle ligne de sous-bloc, ni sur une ligne supprimée
                        champs = containerSousBloc.not('.sous-bloc-form.nouvelle-ligne').find('.form-control[name="' + nomChamp + '"]').not(inputDansLigneSupprimee);
                        if (champs.length == 0) {
                            // on veut afficher l'erreur sur la nouvelle ligne
                            if (nomChamp == 'nouvelle-ligne') {
                                containerSousBloc = containerSousBloc.filter('.sous-bloc-form.nouvelle-ligne');
                            }
                            // on n'a pas de champ mais on va pointer sur le 1er input des sous-blocs disponibles, y compris une nouvelle ligne de sous-bloc
                            champs = containerSousBloc.find(':input:not([type="hidden"], button)').first();
                        } else {
                            // on veut pointer sur le input ayant la valeur précisée
                            if ('valeur' in sousBlocValue) {
                                champs = champs.filter(function () {
                                    for (var index in sousBlocValue['valeur']) {
                                        if (sousBlocValue['valeur'].hasOwnProperty(index) && $(this).val() == sousBlocValue['valeur'][index]) {
                                            return true;
                                        }
                                    }
                                });
                            }
                            if ('no_ligne' in sousBlocValue) {
                                // on veut pointer le input sur la ligne précisée
                                champs = champs.filter(function () {
                                    for (var index in sousBlocValue['no_ligne']) {
                                        if ('no_ligne' in sousBlocValue) {
                                            if (sousBlocValue['no_ligne'].hasOwnProperty(index) &&
                                                $(this).closest('.sous-bloc-form').attr('no-ligne') == (parseInt(sousBlocValue['no_ligne'][index]) + 1).toString()) {
                                                return true;
                                            }
                                        }
                                    }
                                });
                            }
                        }
                        afficherErreurValidation(form, champs, sousBlocValue['texte']);
                    } else {
                        form = formInitial;
                        afficherErreurValidation(form, champs, sousBlocValue['texte']);
                    }
                });
            }

            function afficherErreurValidation(form, champs, textes) {
                // il faut que le form existe, sinon, on ne continue pas pour l'affichage
                if (form.length !== 0) {
                    var aucunChamp = champs.length === 0;
                    // si le sous-bloc n'est pas dans le tree, on le crée
                    if (!(idBlocInt in treeDataBloc)) {
                        treeDataBloc[idBlocInt] = {
                            name: folderBloc,
                            type: 'folder',
                            'icon-class': iconeClass
                        };
                        // on crée le sous-dossier pour recevoir les erreurs de ce bloc, s'il n'est pas déjà créé
                        treeDataBloc[idBlocInt]['additionalParameters'] = {
                            'children': {}
                        };
                    }
                    // un champ peut avoir plus d'un message alors on boucle pour avoir tous ses messages
                    for (var index = 0; index < textes.length; index++) {

                        // si le même message est affiché, on ne l'affiche pas de nouveau
                        var infoMessage = chercherMessage(treeDataBloc[idBlocInt]['additionalParameters']['children'], textes[index], noErreur, index > 0);
                        var messageTrouve = infoMessage.messageTrouve;
                        noErreur = infoMessage.noErreur;

                        // afficher le numéro d'erreur et le texte de l'erreur dans le bloc, s'il y a lieu
                        erreursAjax.afficherErreurChampsFiche(form, champs, textes[index], type, noErreur, aucunChamp, messageTrouve);

                        if (!messageTrouve) {
                            //ajouter un lien pour aller sur le bloc qui a l'erreur
                            var lienTexte = aucunChamp ? textes[index] : noErreur + '. ' + textes[index];
                            var lienControle = '<a class="lien-bloc-validation" style="color:' + couleurTexte + '" href="#!" nom-bloc="' + nomBlocZoom + '">' + lienTexte + '</a>';

                            // on ajoute chaque erreur dans le tree data
                            // on ajoute le nom du bloc pour différencier un champ qui viendrait du bloc et du sous-bloc en même temps
                            // on ajoute l'index pour différencier un champ qui aurait plusieurs messages
                            // on ajoute le no d'erreur pour des blocs/sous-blocs qui auraient des messages différents
                            var noErreurTemp = aucunChamp ? 999 : noErreur;
                            var childrenKey = nomBloc + '_' + nomChamp + '_' + index + '_' + noErreurTemp;
                            treeDataBloc[idBlocInt]['additionalParameters']['children'][childrenKey] = {
                                name: lienControle,
                                type: 'item',
                                noErreur: noErreurTemp // sert à chercher le prochain numéro d'erreur et mettre les messages en ordre de numéro
                                // le numéro '999' est assigné dans le cas où il n'y a pas de champ précisé
                            };
                            // on met à jour le nombre d'erreurs pour ce bloc
                            var nombreErreur = Object.keys(treeDataBloc[idBlocInt]['additionalParameters']['children']).length;
                            treeDataBloc[idBlocInt].name = folderBloc + ' (' + nombreErreur + ')';
                        }
                    }
                }
            }
        });

        // mettre en ordre: les messages avec des numéros en premier, les messages sans numéros par la suite
        if (idBlocInt in treeDataBloc) {
            var list = $.extend({}, treeDataBloc[idBlocInt]['additionalParameters']['children']);
            var keysSorted = Object.keys(list).sort(function (a, b) {
                var contentA = list[a]['noErreur'];
                var contentB = list[b]['noErreur'];
                return (contentA < contentB) ? -1 : (contentA > contentB) ? 1 : 0;
            });

            treeDataBloc[idBlocInt]['additionalParameters']['children'] = {};
            for (var i = 0; i < keysSorted.length; i++) {
                var key = keysSorted[i];
                treeDataBloc[idBlocInt]['additionalParameters']['children'][key] = {
                    name: list[key]['name'],
                    type: 'item',
                    noErreur: list[key]['noErreur']
                };
            }
        }
    }
}

function chercherMessage(dict, message, noErreur, champAvecPlusieursMessages) {
    var messageTrouve = false;
    for (var key in dict) {
        if (dict.hasOwnProperty(key) && dict[key]['name'].indexOf(message) != -1) {
            if (dict[key]['noErreur'] != 999) {
                noErreur = dict[key]['noErreur'];
            }
            messageTrouve = true;
            break;
        }
    }
    if (!messageTrouve) {
        var dictLength = Object.keys(dict).length;
        var dernierNoErreur;
        if (dictLength > 0 && !champAvecPlusieursMessages) {
            for (var key in dict) {
                if (dict[key]['noErreur'] != 999) {
                    dernierNoErreur = dict[key]['noErreur'];
                }
            }
            if (dernierNoErreur != undefined) {
                noErreur = dernierNoErreur + 1;
            }
        }
    }
    return {
        messageTrouve: messageTrouve,
        noErreur: noErreur
    };
}


// utiliser pour le callback_save qui sert à obtenir un no de batiment pour le bloc 08
function getParamsSuppNoBatiment(idUe) {
    return {
        name: 'id_ue',
        value: idUe
    };
}

function estBatiment(idFormulaire) {
    return (idFormulaire == ID_FORMULAIRE.residentiel || idFormulaire == ID_FORMULAIRE.multi || idFormulaire == ID_FORMULAIRE.agricole || idFormulaire == ID_FORMULAIRE.nonResidentiel);
}


function TryParseInt(str, defaultValue) {
    var retValue = defaultValue;
    if (str !== null && str !== undefined) {
        if (str.length > 0) {
            if (!isNaN(str)) {
                retValue = parseInt(str);
            }
        }
    }
    return retValue;
}

function TryParseFloat(str, defaultValue) {
    var retValue = defaultValue;
    if (typeof (str) != "string") return str; // #15483
    if (str !== null && str !== undefined) {
        str = str.replace(/ /g, '').replace('$', '');

        if (str.length > 0) {
            if (!isNaN(str)) {
                retValue = parseFloat(str);
            }
        }
    }
    return retValue;
}

function initMultiplesUesMutation() {
    // utiliser pour la liste de multiples ues
    initCheckboxTous($('#checkbox-multiples-ues-tous'), $('[name="bool_info_non_disponible"]'));

    var checkboxsInfoNonDisponible = $('[name="bool_info_non_disponible"]');
    $.each(checkboxsInfoNonDisponible, function () {
        initDisabledPrix($(this));
    });

    $('[name="bool_info_non_disponible"]').on('change', function () {
        initDisabledPrix($(this));
    });

    function initDisabledPrix(checkbox) {
        checkbox.closest('[id="mutation-multiples-ues-form"]').find('[name="prix_terrain"], [name="prix_batiment"], [name="prix_immeuble"]').prop('disabled', checkbox.is(':checked'));
    }
}

/**
 * Fonction d'initialisation de la séparation du choix de la voie publique en générique, lien voie publique et orientation
 * */
function initEclaterVoiePublique() {
    // On remplace le contenu de la sélection du select2 pour voiePublique
    function formaterVoiePubliqueSelection(vp) {
        var voieSplit = vp.text.split('  ');
        var voie = voieSplit[0].replace(',', '').replace(voieSplit[3], '');

        this.element.parent().find('.select2-container .select2-choice').attr('title', voie);

        return voie;
    }

    // On remplace le contenu du champs select2 des voies publiques pour afficher l'information complète de la rue.
    function formaterVoiePublique(vp) {
        var voieSplit = vp.text.split('  ');
        var voie = voieSplit[0].replace(',', '');
        var complement = (voieSplit[1] !== '' ? '' + voieSplit[1] : '') +
            (voieSplit[2] !== '' ? ' ' + voieSplit[2] : '') +
            (voieSplit[3] !== '' ? ' ' + voieSplit[3] : '');

        if (!vp.id) {
            return voie + (complement.length >= 1 ? ' (' + complement + ')' : '');
        }
        return voie + (complement.length >= 1 ? ' (' + complement + ')' : '');
    }

    $("select#form-voiePublique.form-control").select2({
        formatResult: formaterVoiePublique,
        formatSelection: formaterVoiePubliqueSelection
    });

    $('select[name="voiePublique"]').on('change', function (e) {

        var voiePubliqueSplit = $(this).attr('title').split('  ');

        var lienAdresse = $(this).closest('div.row.sous-bloc-form').find('[name="lienAdresse"]');
        var generiqueAdresse = $(this).closest('div.row.sous-bloc-form').find('[name="generiqueAdresse"]');
        var orientation = $(this).closest('div.row.sous-bloc-form').find('[name="orientationAdresse"]');

        lienAdresse.val(voiePubliqueSplit[2]).attr('title', voiePubliqueSplit[2]);
        generiqueAdresse.val(voiePubliqueSplit[1]).attr('title', voiePubliqueSplit[1]);
        orientation.val(voiePubliqueSplit[3]).attr('title', voiePubliqueSplit[3]);
    });
}

function resetModeLoad(options) {
    if (typeof (options) == 'undefined') {
        options = {};
    }
    var modeWizard = ($('#wizard').length > 0);
    if (modeWizard) {
        modeLoad = ModeSave.WIZARD;
    } else if ($('#blocs-container').length > 0) {
        modeLoad = ModeSave.FICHE;
    } else {
        modeLoad = ModeSave.MENU;
    }
    if ('modeSave' in options) {
        modeLoad = options.modeSave;
    }
}

function simulerClicSelectMultiple(select, idx) {
    // depuis le changement (#12493) du comportement du clic pour les sélecteurs multiples sur la
    // tablette, on doit plutôt simuler un event du clic de souris et appeler directement
    // la fonction pour ajouter des lignes de sous-blocs
    if (idx > -1) {
        var eventSimule = {
            ctrlKey: false,
            currentTarget: {
                index: idx
            }
        };
        selectMultipleInputMultipleClicked($(select.find('option')[idx]), eventSimule);
    }
}

function validerTypeServiceTG(containerTypeServiceTg) {
    // Changement de type de service du terrain général
    if (!containerTypeServiceTg.length) return;

    erreursAjax.effacerErreurChamps(containerTypeServiceTg);
    let typeServiceTGListe = containerTypeServiceTg.find('[name="type_service_tg_liste"]');
    let options;
    let typeServiceTG;
    if (containerTypeServiceTg.is('ul')) {
        typeServiceTG = $.makeArray(typeServiceTGListe.find('li.option.bg-grey').map(function () {
            return $(this).data('js');
        }));
    }
    else {
        typeServiceTG = $.makeArray(
        containerTypeServiceTg.find('[name="type_service_tg_liste"] option:checked').map(function () {
            return $(this).val();
        }));
    }
    if (typeServiceTG) {
        var params = {
            id_ue: $('#wizard').attr('id-ue'),
            date_evenement: $('#wizard').attr('date-evenement'),
            type_service_tg: JSON.stringify(typeServiceTG)
        };

        $.ajax({
            url: '/gestion-roles/tenue-a-jour/terrain/valider-type-service-tg/',
            async: false,
            data: params,
            dataType: 'json',
            success: function (response) {

                if (response.erreurs) {
                    for (var index in response.erreurs) {
                        erreursAjax.afficherErreurChamps(containerTypeServiceTg, 'type_service_tg_liste', response.erreurs[index], '');
                    }
                }
            },
            error: function (xhr, ajaxOptions, thrownError) {
                erreursAjax.traiterErreurs(pageCourante, xhr, thrownError);
                $('.tooltip').remove();
            }
        });
    }
}


function closeEvenementDatatable() {
    $('#collapse-evenement').collapse('hide');
}

$(document).off('click', '#avertissement_editeur_fiche_close').on('click', '#avertissement_editeur_fiche_close', function () {
    fermerAvertissementEditeurFiche('avertissement_editeur_fiche');
});

$(document).off('click', '#avertissement_tb_note_deconnecte_non_importe_close').on('click', '#avertissement_tb_note_deconnecte_non_importe_close', function () {
    fermerAvertissementEditeurFiche('avertissement_tb_note_deconnecte_non_importe');
    $(".lien-tableau-blanc[data-type-tableau='note']").removeClass("warning");
    localStorage.removeItem(genererNomKeyLocalStorageSvg("note"));
    if ($('#id-tableau-blanc').val() != '0' && $('#id-tableau-blanc').val() != '') {
        $(".lien-tableau-blanc[data-type-tableau='note']").addClass("active");
    }
});

$(document).off('click', '#avertissement_tb_croquis_deconnecte_non_importe_close').on('click', '#avertissement_tb_croquis_deconnecte_non_importe_close', function () {
    fermerAvertissementEditeurFiche('avertissement_tb_croquis_deconnecte_non_importe');
    $(".lien-tableau-blanc[data-type-tableau='croquis']").removeClass("warning");
    localStorage.removeItem(genererNomKeyLocalStorageSvg("croquis"));
    if ($('#id-notes-croquis').val() != '0' && $('#id-notes-croquis').val() != '') {
        $(".lien-tableau-blanc[data-type-tableau='croquis']").addClass("active");
    }
});

function afficherAvertissementEditeurFiche(idContainer, idDivTexte, texteAvertissement) {
    $('#' + idDivTexte).html(texteAvertissement);
    $('#' + idContainer).show();
    calculerHauteurAncre();
    calculateAccordionStickyHeader();
}

function fermerAvertissementEditeurFiche(idContainer) {
    $('#' + idContainer).hide();
    calculerHauteurAncre();
    calculateAccordionStickyHeader();
}


function getDictSelectListMultipleInput(select, original_select, selectionAffichee, options) {
    var dictInputs = {};
    var selecteurInputParent = `input[parent="${select.data('js')}"]`;
    var selecteurInputParentDoubleListe = `input[parent="${select.closest('ul').data('js')}"]`;
    var valeurOriginalSelect = original_select.attr('code') == undefined ? original_select.attr('value') : original_select.attr('code');
    var selecteurInputParentMemeValeur = `input[value="${valeurOriginalSelect}"]`;

    var listeInputsDejaAffiche = select.closest('.bloc-container').find(`.input-select-multiple ${selecteurInputParent},.input-multiple-select-multiple ${selecteurInputParent}`);
    if (listeInputsDejaAffiche.length < 1) {
        listeInputsDejaAffiche = select.closest('.bloc-container').find(`.input-select-multiple ${selecteurInputParentDoubleListe},.input-multiple-select-multiple ${selecteurInputParentDoubleListe}`);
    }
    var arrayValeursInputDejaAffiche = listeInputsDejaAffiche.map(function () {
        if (!$(this).parent().is('.suppression-ligne, .suppression-ligne-sauvegardee')) {
            return $(this).val();
        }
    }).get();

    $.each(options, function (index, option) {
        let valeurOption = $(option).attr('code') == undefined ? $(option).attr('value') : $(option).attr('code');
        // il faut vérifier 'original_select' pour savoir s'il est sélectionné car il n'a pas encore 'bg-grey'
        let estSelectionne = $(option).hasClass('bg-grey');
        let optionEstCliquee = valeurOption == valeurOriginalSelect;
        let estDejaAffiche = false;
        if (selectionAffichee) {
            estDejaAffiche = arrayValeursInputDejaAffiche.includes(valeurOption);
        }

        let statutOption = OPTION_STATUT.aucun;
        if (optionEstCliquee || estSelectionne || estDejaAffiche) {
            if (optionEstCliquee) {
                statutOption = estDejaAffiche ? OPTION_STATUT.suppresssion : OPTION_STATUT.ajout;
    } else {
                if (selectionAffichee) {
                    if (!estSelectionne && estDejaAffiche) {
                        statutOption = OPTION_STATUT.suppresssion;
                    } else if (estSelectionne && !estDejaAffiche) {
                        statutOption = OPTION_STATUT.ajout;
                    }
                }
            }
            dictInputs[valeurOption] = statutOption;
        }
    });
    return dictInputs;
}

// Ici on a la logique de griser les inputs qui sont déjà choisis dans les listes qui remplacent les selects / options
// La structure html des évènements diffère d'un type a un autre. j'ai du adapter le code pour qu'il fonctionne pour chacune des structures
function selectGrisInputChoisi() {
    const estEnWizard = $('#wizard').length > 0;
    if (estEnWizard) {
        const panneauAvant = $('a:contains("Avant")').first();
        if (!panneauAvant.length) {
            return;
        }
        let formAvant = $('form[id^="b04-terrain"]').first();
        selectGrisInputChoisiForm(formAvant);

        const panneauApres = $('a:contains("Après")').first();
        if (!panneauApres.length) {
            return;
        }
        let formApres = $('form[id^="b04-terrain"]').eq(1);
        selectGrisInputChoisiForm(formApres);

        let terrain_boise = $('form[id^="b04-terrain"]').eq(2);
        selectGrisInputChoisiForm(terrain_boise);
    } else {
        let container = $('#blocs-container');
        selectGrisInputChoisiForm(container);
    }
}

function selectGrisInputChoisiForm(container) {
    if (!container || !container.length) {
        return;
    }
    const btnSave = $('#btn-wizard-save');
    container.find('li.bg-grey').removeClass('bg-grey');
    let inputs = container.find('input[parent]').filter(function() {
        return !$(this).parent().is('.suppression-ligne, .suppression-ligne-sauvegardee');
    });
    let estliElementModifie = false;
    inputs.each(function() {
        const elemn_input = $(this);
        const valeur = elemn_input.val();
        const nom = $(this).attr('parent');
        const ulElements = container.find(`ul[data-js="${nom}"]`);
        ulElements.each(function () {
            let liElement = $();
            if(ulElements.find('li:not(.optgroup)').first().hasAttr('code')){
                liElement = $(this).find(`li[code="${valeur}"]`);
            }else{
                liElement = $(this).find(`li[value="${valeur}"]`);
            }
            if (liElement.length) {
                liElement.addClass('bg-grey');
                estliElementModifie = true;
            }
        });
    });
    if (estliElementModifie) {
        btnSave.prop('disabled', false);
    }
}


function postSauvegardeDocument(ligne, documentData, nomChampImbrique = '') {
    var urlDocument = documentData.photo_batiment;
    if (nomChampImbrique) {
        // ajouter le point pour trouver le champ imbriqué
        nomChampImbrique += '.';
    }

    if (documentData.typeDocument == 1)
        urlDocument = urlDocument.replace(/\.(?=[^.]*$)/, "_mini.");
    else if (documentData.typeDocument == 2) {
        var indexLast = urlDocument.lastIndexOf('.');
        var extension = urlDocument.substr(indexLast, urlDocument.length);
        urlDocument = urlDocument.toLowerCase().replace(extension.toLowerCase(), '.jpg');
    }

    var urlTelechargement = documentData.lien_telechargement;
    var img = ligne.find('img');
    var lien = ligne.find('.btn-telechargement');

    if (!lien.is(':visible')) {
        // voir le lien de téléchargement maintenant que s'est sauvegardé
        lien.css('visibility', '');
    } else {
        // remettre actif le lien de téléchargement
        lien.removeClass('disabled');
    }

    if (img.length > 0) {
        // On ajuste la taille de l'image qui vient d'être ajoutée.
        ajusterTailleImage(img, '100px', '80px');
        // On vient actualiser l'image et le lien du téléchargement affichés sur la ligne suite au upload d'une nouvelle image
        img.attr('onerror', "this.src='" + img.attr('src') + "'");
        img.attr('src', urlDocument);
    }

    lien.attr('href', urlTelechargement);
    ligne.find('.selected').removeClass('selected');
    ligne.find('[name="' + nomChampImbrique + 'nom_fichier_txt"]').val(documentData.nom);

    // visible en tant que "Date vigueur" dans le cas du bloc 06
    if (documentData.date_debut) {
        var date_debut = documentData.date_debut.substring(0, 10);
        ligne.find('[name="date_debut"]').val(date_debut);
    }

    var wrapperVide = ligne.find('.cboxElementVide');
    if (wrapperVide.length > 0) {
        wrapperVide.removeClass();
        wrapperVide.addClass('cboxElement');
        if (documentData.typeDocument == 1)
            wrapperVide.attr('href', urlTelechargement);
        else if (documentData.typeDocument == 2)
            wrapperVide.attr('href', urlDocument);
    }

}

function afficherPhotoPrincipale(nomBloc, documentData) {
    if (documentData.bool_principale) {
        // On affiche la photo principale sélectionnée
        var photoPrincipale;
        if (nomBloc.startsWith('b05-document')) {
            photoPrincipale = $('#b05-photo-batiment #photo-principale');
            $("#entete-info-generale-photo").attr('src', documentData.photo_batiment);
            $(`#modalChoisirFiche a[id-batiment="${$("#id_batiment").val()}"] img`).attr('src', documentData.photo_batiment);
        } else {
            photoPrincipale = $('#b06-croquis-batiment #photo-principale');
            documentData.photo_batiment = documentData.photo_batiment.replace(/\.[^.]+$/, '.jpg');
        }
        photoPrincipale.attr('src', documentData.photo_batiment);
        ajusterTailleImage(photoPrincipale, '625px', '500px');
    }
}

function calculateTotal(selector) {
    let total = 0;
    $(selector).each(function () {
        total += parseInt($(this).val(), 10) || 0;
    });
    return total;
}

function calculateTotalB82() {
    const base = '#accordion-evenement-82 .montant-calcul';

    const total = calculateTotal(`${base} input[name="montant"]`);
    const total_precedent = calculateTotal(`${base} input[name="montant_annee_precedente"]`);
    const total_anterieur = calculateTotal(`${base} input[name="montant_annee_anterieur"]`);

    $('#accordion-evenement-82 .montant-total').val(`${total} $`);
    $('#accordion-evenement-82 .montant-precedent-total').val(`${total_precedent} $`);
    $('#accordion-evenement-82 .montant-anterieur-total').val(`${total_anterieur} $`);
}

function calculateTotalB83() {
    const base = '#accordion-evenement-83 .montant-calcul';

    const total = calculateTotal(`${base} input[name="montant"]`);
    const total_precedent = calculateTotal(`${base} input[name="montant_annee_precedente"]`);
    const total_anterieur = calculateTotal(`${base} input[name="montant_annee_anterieur"]`);

    $('#accordion-evenement-83 .montant-total').val(`${total} $`);
    $('#accordion-evenement-83 .montant-precedent-total').val(`${total_precedent} $`);
    $('#accordion-evenement-83 .montant-anterieur-total').val(`${total_anterieur} $`);
}

function get_listeIdEvenement() {
    var checked = $('.dataTables_scrollBody .table-evenements tbody input.ace.check-taj:checked').closest('tr');
    var listeIdEvenement = [];
    checked.each(function () {
        var row = $(this).closest('tr');
        var idEvenement = row.attr('data-id_evenement');
        listeIdEvenement.push(idEvenement);
    });
    return listeIdEvenement;
}
